/* eslint-disable */
// Copyright (c) 2010 Sven Kreiss, Kyle Cranmer
// Sven Kreiss <sk@svenkreiss.com>, Kyle Cranmer <kyle.cranmer@nyu.edu>
// version 0.7.2

export const replacements = [
   ['\\barleftarrowrightarrowba', '↹'],
   ['\\rightarrowshortleftarrow', '⥂'],
   ['\\leftarrowshortrightarrow', '⥃'],
   ['\\shortrightarrowleftarrow', '⥄'],
   ['\\leftrightharpoondowndown', '⥐'],
   ['\\smallblacktriangleright', '▸'],
   ['\\invwhiteupperhalfcircle', '◚'],
   ['\\invwhitelowerhalfcircle', '◛'],
   ['\\concavediamondtickright', '⟣'],
   ['\\nvtwoheadrightarrowtail', '⤗'],
   ['\\nVtwoheadrightarrowtail', '⤘'],
   ['\\updownharpoonrightright', '⥏'],
   ['\\updownharpoonsleftright', '⥮'],
   ['\\downupharpoonsleftright', '⥯'],
   ['\\mathsfbfit{\\varepsilon}', '𝞮'],
   ['\\leftrightarrowtriangle', '⇿'],
   ['\\smallblacktriangleleft', '◂'],
   ['\\blackcircleulquadwhite', '◕'],
   ['\\concavediamondtickleft', '⟢'],
   ['\\leftrightharpoonupdown', '⥊'],
   ['\\leftrightharpoondownup', '⥋'],
   ['\\updownharpoonrightleft', '⥌'],
   ['\\updownharpoonleftright', '⥍'],
   ['\\downtrianglerightblack', '⧩'],
   ['\\partialmeetcontraction', '⪣'],
   ['\\nvtwoheadleftarrowtail', '⬼'],
   ['\\nVtwoheadleftarrowtail', '⬽'],
   ['\\underrightharpoondown', '⃬'],
   ['\\barovernorthwestarrow', '↸'],
   ['\\rangledownzigzagarrow', '⍼'],
   ['\\circlebottomhalfblack', '◒'],
   ['\\twoheadrightarrowtail', '⤖'],
   ['\\updownharpoonleftleft', '⥑'],
   ['\\downharpoonsleftright', '⥥'],
   ['\\leftrightharpoonsdown', '⥧'],
   ['\\rightleftharpoonsdown', '⥩'],
   ['\\downtriangleleftblack', '⧨'],
   ['\\blackdiamonddownarrow', '⧪'],
   ['\\closedvarcupsmashprod', '⩐'],
   ['\\mathbfit{\\varepsilon}', '𝜺'],
   ['\\mathbold{\\varepsilon}', '𝜺'],
   ['\\mathsfbf{\\varepsilon}', '𝝴'],
   ['\\mathsfbfit{\\varsigma}', '𝞻'],
   ['\\mathsfbfit{\\vartheta}', '𝟅'],
   ['\\underleftharpoondown', '⃭'],
   ['\\mathring{\\mathrm{A}}', 'Å'],
   ['\\CapitalDifferentialD', 'ⅅ'],
   ['\\bigblacktriangledown', '▼'],
   ['\\circlerighthalfblack', '◑'],
   ['\\blackrighthalfcircle', '◗'],
   ['\\blackcircledrightdot', '⚈'],
   ['\\whiteinwhitetriangle', '⟁'],
   ['\\whitesquaretickright', '⟥'],
   ['\\barrightarrowdiamond', '⤠'],
   ['\\downrightcurvedarrow', '⤵'],
   ['\\rightdowncurvedarrow', '⤷'],
   ['\\curvearrowrightminus', '⤼'],
   ['\\leftrightarrowcircle', '⥈'],
   ['\\twoheaduparrowcircle', '⥉'],
   ['\\leftrightharpoonupup', '⥎'],
   ['\\leftrightharpoondown', '⥐'],
   ['\\dashrightharpoondown', '⥭'],
   ['\\blackcircledownarrow', '⧭'],
   ['\\NestedGreaterGreater', '⪢'],
   ['\\twoheadleftarrowtail', '⬻'],
   ['\\rightarrowbackapprox', '⭈'],
   ['\\mathsfbfit{\\Upsilon}', '𝞤'],
   ['\\mathsfbfit{\\upsilon}', '𝞾'],
   ['\\mathsfbfit{\\epsilon}', '𝟄'],
   ['\\textfractionsolidus', '⁄'],
   ['\\leftrightsquigarrow', '↭'],
   ['\\mathrm{\\varepsilon}', 'ε'],
   ['\\whitearrowupfrombar', '⇪'],
   ['\\blockthreeqtrshaded', '▓'],
   ['\\blackinwhitediamond', '◈'],
   ['\\circlelefthalfblack', '◐'],
   ['\\blacklefthalfcircle', '◖'],
   ['\\blackcircledtwodots', '⚉'],
   ['\\whitesquaretickleft', '⟤'],
   ['\\longrightsquigarrow', '⟿'],
   ['\\nvtwoheadrightarrow', '⤀'],
   ['\\nVtwoheadrightarrow', '⤁'],
   ['\\diamondleftarrowbar', '⤟'],
   ['\\leftdowncurvedarrow', '⤶'],
   ['\\downharpoonrightbar', '⥕'],
   ['\\rightharpoondownbar', '⥗'],
   ['\\bardownharpoonright', '⥝'],
   ['\\barrightharpoondown', '⥟'],
   ['\\upharpoonsleftright', '⥣'],
   ['\\rightharpoonsupdown', '⥤'],
   ['\\leftrightharpoonsup', '⥦'],
   ['\\rightleftharpoonsup', '⥨'],
   ['\\dashleftharpoondown', '⥫'],
   ['\\twoheadleftdbkarrow', '⬷'],
   ['\\leftarrowbackapprox', '⭂'],
   ['\\mathbf{\\varepsilon}', '𝛆'],
   ['\\mathit{\\varepsilon}', '𝜀'],
   ['\\mathbfit{\\varsigma}', '𝝇'],
   ['\\mathbold{\\varsigma}', '𝝇'],
   ['\\mathbfit{\\vartheta}', '𝝑'],
   ['\\mathbold{\\vartheta}', '𝝑'],
   ['\\mathsfbf{\\varsigma}', '𝞁'],
   ['\\mathsfbf{\\vartheta}', '𝞋'],
   ['\\mathsfbfit{\\Lambda}', '𝞚'],
   ['\\mathsfbfit{\\lambda}', '𝞴'],
   ['\\mathsfbfit{\\varphi}', '𝞿'],
   ['\\mbfitsansvarepsilon', '𝟄'],
   ['\\mathsfbfit{\\varrho}', '𝟈'],
   ['\\textpertenthousand', '‱'],
   ['\\blacktriangleright', '▸'],
   ['\\rightharpoonaccent', '⃑'],
   ['\\overleftrightarrow', '⃡'],
   ['\\acwopencirclearrow', '↺'],
   ['\\upharpoonrightdown', '⇂'],
   ['\\circleonrightarrow', '⇴'],
   ['\\rightarrowtriangle', '⇾'],
   ['\\PrecedesSlantEqual', '≼'],
   ['\\SucceedsSlantEqual', '≽'],
   ['\\measuredrightangle', '⊾'],
   ['\\blackinwhitesquare', '▣'],
   ['\\parallelogramblack', '▰'],
   ['\\bigblacktriangleup', '▲'],
   ['\\smalltriangleright', '▹'],
   ['\\circletophalfblack', '◓'],
   ['\\inversewhitecircle', '◙'],
   ['\\trianglerightblack', '◮'],
   ['\\longleftrightarrow', '⟷'],
   ['\\Longleftrightarrow', '⟺'],
   ['\\curvearrowleftplus', '⤽'],
   ['\\ccwundercurvearrow', '⤿'],
   ['\\leftrightharpoonup', '⥎'],
   ['\\rightupdownharpoon', '⥏'],
   ['\\RightDownVectorBar', '⥕'],
   ['\\barleftharpoondown', '⥖'],
   ['\\DownRightVectorBar', '⥗'],
   ['\\downharpoonleftbar', '⥙'],
   ['\\RightDownTeeVector', '⥝'],
   ['\\leftharpoondownbar', '⥞'],
   ['\\DownRightTeeVector', '⥟'],
   ['\\bardownharpoonleft', '⥡'],
   ['\\leftharpoonsupdown', '⥢'],
   ['\\rightrightharpoons', '⥤'],
   ['\\rightharpoonupdash', '⥬'],
   ['\\circledwhitebullet', '⦾'],
   ['\\errbarblackdiamond', '⧱'],
   ['\\longleftsquigarrow', '⬳'],
   ['\\nvtwoheadleftarrow', '⬴'],
   ['\\nVtwoheadleftarrow', '⬵'],
   ['\\bsimilarrightarrow', '⭇'],
   ['\\rightarrowbsimilar', '⭌'],
   ['\\rightpentagonblack', '⭓'],
   ['\\mathbfit{\\Upsilon}', '𝜰'],
   ['\\mathbold{\\Upsilon}', '𝜰'],
   ['\\mathbfit{\\upsilon}', '𝝊'],
   ['\\mathbold{\\upsilon}', '𝝊'],
   ['\\mathbfit{\\epsilon}', '𝝐'],
   ['\\mathbold{\\epsilon}', '𝝐'],
   ['\\mathsfbf{\\Upsilon}', '𝝪'],
   ['\\mathsfbf{\\upsilon}', '𝞄'],
   ['\\mathsfbf{\\epsilon}', '𝞊'],
   ['\\mathsfbfit{\\Gamma}', '𝞒'],
   ['\\mathsfbfit{\\Delta}', '𝞓'],
   ['\\mathsfbfit{\\Theta}', '𝞗'],
   ['\\mathsfbfit{\\Sigma}', '𝞢'],
   ['\\mathsfbfit{\\Omega}', '𝞨'],
   ['\\mathsfbfit{\\alpha}', '𝞪'],
   ['\\mathsfbfit{\\gamma}', '𝞬'],
   ['\\mathsfbfit{\\delta}', '𝞭'],
   ['\\mathsfbfit{\\theta}', '𝞱'],
   ['\\mathsfbfit{\\kappa}', '𝞳'],
   ['\\mathsfbfit{\\sigma}', '𝞼'],
   ['\\mathsfbfit{\\omega}', '𝟂'],
   ['\\mathsfbfit{\\varpi}', '𝟉'],
   ['\\blacktriangledown', '▾'],
   ['\\blacktriangleleft', '◂'],
   ['\\twoheadrightarrow', '↠'],
   ['\\leftrightharpoons', '⇋'],
   ['\\rightleftharpoons', '⇌'],
   ['\\textreferencemark', '※'],
   ['\\mathrm{\\varsigma}', 'ς'],
   ['\\mathrm{\\vartheta}', 'ϑ'],
   ['\\leftharpoonaccent', '⃐'],
   ['\\cwopencirclearrow', '↻'],
   ['\\upharpoonleftdown', '⇃'],
   ['\\leftarrowtriangle', '⇽'],
   ['\\kernelcontraction', '∻'],
   ['\\vardoublebarwedge', '⌆'],
   ['\\varhexagonlrbonds', '⌬'],
   ['\\APLvert{\\APLdown}', '⍒'],
   ['\\varcarriagereturn', '⏎'],
   ['\\blackpointerright', '►'],
   ['\\whitepointerright', '▻'],
   ['\\smalltriangledown', '▿'],
   ['\\smalltriangleleft', '◃'],
   ['\\circleurquadblack', '◔'],
   ['\\triangleleftblack', '◭'],
   ['\\acwgapcirclearrow', '⟲'],
   ['\\rightarrowonoplus', '⟴'],
   ['\\rightarrowdiamond', '⤞'],
   ['\\uprightcurvearrow', '⤴'],
   ['\\cwundercurvearrow', '⤾'],
   ['\\leftupdownharpoon', '⥑'],
   ['\\rightharpoonupbar', '⥓'],
   ['\\barupharpoonright', '⥔'],
   ['\\DownLeftVectorBar', '⥖'],
   ['\\LeftDownVectorBar', '⥙'],
   ['\\barrightharpoonup', '⥛'],
   ['\\upharpoonrightbar', '⥜'],
   ['\\DownLeftTeeVector', '⥞'],
   ['\\LeftDownTeeVector', '⥡'],
   ['\\leftharpoonupdash', '⥪'],
   ['\\similarrightarrow', '⥲'],
   ['\\rightarrowsimilar', '⥴'],
   ['\\measuredangleleft', '⦛'],
   ['\\errbarblacksquare', '⧯'],
   ['\\errbarblackcircle', '⧳'],
   ['\\diamondrightblack', '⬗'],
   ['\\circleonleftarrow', '⬰'],
   ['\\bsimilarleftarrow', '⭁'],
   ['\\leftarrowbsimilar', '⭋'],
   ['\\mathbf{\\varsigma}', '𝛓'],
   ['\\mathbf{\\vartheta}', '𝛝'],
   ['\\mathit{\\varsigma}', '𝜍'],
   ['\\mathit{\\vartheta}', '𝜗'],
   ['\\mathbfit{\\Lambda}', '𝜦'],
   ['\\mathbold{\\Lambda}', '𝜦'],
   ['\\mathbfit{\\lambda}', '𝝀'],
   ['\\mathbold{\\lambda}', '𝝀'],
   ['\\mathbfit{\\varphi}', '𝝋'],
   ['\\mathbold{\\varphi}', '𝝋'],
   ['\\mathbfit{\\varrho}', '𝝔'],
   ['\\mathbold{\\varrho}', '𝝔'],
   ['\\mathsfbf{\\Lambda}', '𝝠'],
   ['\\mathsfbf{\\lambda}', '𝝺'],
   ['\\mathsfbf{\\varphi}', '𝞅'],
   ['\\mbfsansvarepsilon', '𝞊'],
   ['\\mathsfbf{\\varrho}', '𝞎'],
   ['\\mbfitsansvarTheta', '𝞡'],
   ['\\mathsfbfit{\\beta}', '𝞫'],
   ['\\mathsfbfit{\\zeta}', '𝞯'],
   ['\\mathsfbfit{\\iota}', '𝞲'],
   ['\\mbfitsansvarsigma', '𝞻'],
   ['\\mbfitsansvartheta', '𝟅'],
   ['\\mbfitsansvarkappa', '𝟆'],
   ['\\circlearrowright', '↻'],
   ['\\rightrightarrows', '⇉'],
   ['\\vartriangleright', '⊳'],
   ['\\textordmasculine', 'º'],
   ['\\textvisiblespace', '␣'],
   ['\\twoheadleftarrow', '↞'],
   ['\\downharpoonright', '⇂'],
   ['\\ntrianglerighteq', '⋭'],
   ['\\rightharpoondown', '⇁'],
   ['\\mathrm{\\Upsilon}', 'Υ'],
   ['\\mathrm{\\upsilon}', 'υ'],
   ['\\mathrm{\\epsilon}', 'ϵ'],
   ['\\twoheaddownarrow', '↡'],
   ['\\upharpoonrightup', '↾'],
   ['\\uparrowdownarrow', '⇅'],
   ['\\downarrowuparrow', '⇵'],
   ['\\rightthreearrows', '⇶'],
   ['\\nvleftrightarrow', '⇹'],
   ['\\nVleftrightarrow', '⇼'],
   ['\\varointclockwise', '∲'],
   ['\\ointctrclockwise', '∳'],
   ['\\multimapdotbothA', '⊶'],
   ['\\multimapdotbothB', '⊷'],
   ['\\NotRightTriangle', '⋫'],
   ['\\APLcirc{\\APLbox}', '⌼'],
   ['\\APLvert{\\Circle}', '⌽'],
   ['\\APLcirc{\\Circle}', '⌾'],
   ['\\APLrightarrowbox', '⍈'],
   ['\\APLnot{\\APLdown}', '⍫'],
   ['\\blackpointerleft', '◄'],
   ['\\whitepointerleft', '◅'],
   ['\\squarerightblack', '◨'],
   ['\\cwgapcirclearrow', '⟳'],
   ['\\nvLeftrightarrow', '⤄'],
   ['\\nvrightarrowtail', '⤔'],
   ['\\nVrightarrowtail', '⤕'],
   ['\\diamondleftarrow', '⤝'],
   ['\\rightcurvedarrow', '⤳'],
   ['\\acwunderarcarrow', '⤻'],
   ['\\leftrightharpoon', '⥊'],
   ['\\rightleftharpoon', '⥋'],
   ['\\barleftharpoonup', '⥒'],
   ['\\RightUpVectorBar', '⥔'],
   ['\\barupharpoonleft', '⥘'],
   ['\\leftharpoonupbar', '⥚'],
   ['\\RightUpTeeVector', '⥜'],
   ['\\upharpoonleftbar', '⥠'],
   ['\\leftleftharpoons', '⥢'],
   ['\\downdownharpoons', '⥥'],
   ['\\uprevequilibrium', '⥯'],
   ['\\leftarrowsimilar', '⥳'],
   ['\\rightarrowapprox', '⥵'],
   ['\\sphericalangleup', '⦡'],
   ['\\RightTriangleBar', '⧐'],
   ['\\diamondleftblack', '⬖'],
   ['\\leftarrowonoplus', '⬲'],
   ['\\rightarrowsupset', '⭄'],
   ['\\similarleftarrow', '⭉'],
   ['\\mathbf{\\Upsilon}', '𝚼'],
   ['\\mathbf{\\upsilon}', '𝛖'],
   ['\\mathbf{\\epsilon}', '𝛜'],
   ['\\mathit{\\Upsilon}', '𝛶'],
   ['\\mathit{\\upsilon}', '𝜐'],
   ['\\mathit{\\partial}', '𝜕'],
   ['\\mathit{\\epsilon}', '𝜖'],
   ['\\mathbfit{\\Gamma}', '𝜞'],
   ['\\mathbold{\\Gamma}', '𝜞'],
   ['\\mathbfit{\\Delta}', '𝜟'],
   ['\\mathbold{\\Delta}', '𝜟'],
   ['\\mathbfit{\\Theta}', '𝜣'],
   ['\\mathbold{\\Theta}', '𝜣'],
   ['\\mathbfit{\\Sigma}', '𝜮'],
   ['\\mathbold{\\Sigma}', '𝜮'],
   ['\\mathbfit{\\Omega}', '𝜴'],
   ['\\mathbold{\\Omega}', '𝜴'],
   ['\\mathbfit{\\alpha}', '𝜶'],
   ['\\mathbold{\\alpha}', '𝜶'],
   ['\\mathbfit{\\gamma}', '𝜸'],
   ['\\mathbold{\\gamma}', '𝜸'],
   ['\\mathbfit{\\delta}', '𝜹'],
   ['\\mathbold{\\delta}', '𝜹'],
   ['\\mathbfit{\\theta}', '𝜽'],
   ['\\mathbold{\\theta}', '𝜽'],
   ['\\mathbfit{\\kappa}', '𝜿'],
   ['\\mathbold{\\kappa}', '𝜿'],
   ['\\mathbfit{\\sigma}', '𝝈'],
   ['\\mathbold{\\sigma}', '𝝈'],
   ['\\mathbfit{\\omega}', '𝝎'],
   ['\\mathbold{\\omega}', '𝝎'],
   ['\\mathbfit{\\varpi}', '𝝕'],
   ['\\mathbold{\\varpi}', '𝝕'],
   ['\\mathsfbf{\\Gamma}', '𝝘'],
   ['\\mathsfbf{\\Delta}', '𝝙'],
   ['\\mathsfbf{\\Theta}', '𝝝'],
   ['\\mathsfbf{\\Sigma}', '𝝨'],
   ['\\mathsfbf{\\Omega}', '𝝮'],
   ['\\mathsfbf{\\alpha}', '𝝰'],
   ['\\mathsfbf{\\gamma}', '𝝲'],
   ['\\mathsfbf{\\delta}', '𝝳'],
   ['\\mathsfbf{\\theta}', '𝝷'],
   ['\\mathsfbf{\\kappa}', '𝝹'],
   ['\\mathsfbf{\\sigma}', '𝞂'],
   ['\\mathsfbf{\\omega}', '𝞈'],
   ['\\mathsfbf{\\varpi}', '𝞏'],
   ['\\mbfitsansEpsilon', '𝞔'],
   ['\\mbfitsansOmicron', '𝞞'],
   ['\\mbfitsansUpsilon', '𝞤'],
   ['\\mathsfbfit{\\Phi}', '𝞥'],
   ['\\mathsfbfit{\\Psi}', '𝞧'],
   ['\\mbfitsansepsilon', '𝞮'],
   ['\\mathsfbfit{\\eta}', '𝞰'],
   ['\\mbfitsansomicron', '𝞸'],
   ['\\mathsfbfit{\\rho}', '𝞺'],
   ['\\mathsfbfit{\\tau}', '𝞽'],
   ['\\mbfitsansupsilon', '𝞾'],
   ['\\mathsfbfit{\\chi}', '𝟀'],
   ['\\mathsfbfit{\\psi}', '𝟁'],
   ['\\mbfitsanspartial', '𝟃'],
   ['\\mathsfbfit{\\phi}', '𝟇'],
   ['\\textperthousand', '‰'],
   ['\\leftrightarrows', '⇆'],
   ['\\textmusicalnote', '♪'],
   ['\\nleftrightarrow', '↮'],
   ['\\rightleftarrows', '⇄'],
   ['\\bigtriangledown', '▽'],
   ['\\textordfeminine', 'ª'],
   ['\\ntrianglelefteq', '⋬'],
   ['\\rightthreetimes', '⋌'],
   ['\\trianglerighteq', '⊵'],
   ['\\vartriangleleft', '⊲'],
   ['\\rightsquigarrow', '⇝'],
   ['\\downharpoonleft', '⇃'],
   ['\\curvearrowright', '↷'],
   ['\\circlearrowleft', '↺'],
   ['\\leftharpoondown', '↽'],
   ['\\nLeftrightarrow', '⇎'],
   ['\\mathrm{\\Lambda}', 'Λ'],
   ['\\mathrm{\\lambda}', 'λ'],
   ['\\mathrm{\\varphi}', 'φ'],
   ['\\mathrm{\\varrho}', 'ϱ'],
   ['\\enleadertwodots', '‥'],
   ['\\unicodeellipsis', '…'],
   ['\\enclosetriangle', '⃤'],
   ['\\widebridgeabove', '⃩'],
   ['\\underrightarrow', '⃯'],
   ['\\downzigzagarrow', '↯'],
   ['\\upharpoonleftup', '↿'],
   ['\\rightwhitearrow', '⇨'],
   ['\\NotGreaterTilde', '≵'],
   ['\\NotLeftTriangle', '⋪'],
   ['\\APLnotbackslash', '⍀'],
   ['\\APLleftarrowbox', '⍇'],
   ['\\APLvert{\\APLup}', '⍋'],
   ['\\APLdownarrowbox', '⍗'],
   ['\\blockhalfshaded', '▒'],
   ['\\squarecrossfill', '▩'],
   ['\\hrectangleblack', '▬'],
   ['\\vrectangleblack', '▮'],
   ['\\blacktriangleup', '▴'],
   ['\\smalltriangleup', '▵'],
   ['\\lrblacktriangle', '◢'],
   ['\\llblacktriangle', '◣'],
   ['\\ulblacktriangle', '◤'],
   ['\\urblacktriangle', '◥'],
   ['\\squareleftblack', '◧'],
   ['\\circledrightdot', '⚆'],
   ['\\downarrowbarred', '⤈'],
   ['\\cwrightarcarrow', '⤸'],
   ['\\acwleftarcarrow', '⤹'],
   ['\\acwoverarcarrow', '⤺'],
   ['\\LeftUpVectorBar', '⥘'],
   ['\\LeftUpTeeVector', '⥠'],
   ['\\rightbarharpoon', '⥬'],
   ['\\barrightharpoon', '⥭'],
   ['\\equalrightarrow', '⥱'],
   ['\\leftarrowsubset', '⥺'],
   ['\\measanglerutone', '⦨'],
   ['\\measanglelutonw', '⦩'],
   ['\\measanglerdtose', '⦪'],
   ['\\measangleldtosw', '⦫'],
   ['\\measangleurtone', '⦬'],
   ['\\measangleultonw', '⦭'],
   ['\\measangledrtose', '⦮'],
   ['\\measangledltosw', '⦯'],
   ['\\circledparallel', '⦷'],
   ['\\uparrowoncircle', '⦽'],
   ['\\LeftTriangleBar', '⧏'],
   ['\\circledownarrow', '⧬'],
   ['\\bigtriangleleft', '⨞'],
   ['\\diamondtopblack', '⬘'],
   ['\\diamondbotblack', '⬙'],
   ['\\varhexagonblack', '⬢'],
   ['\\leftthreearrows', '⬱'],
   ['\\twoheadmapsfrom', '⬶'],
   ['\\nvleftarrowtail', '⬹'],
   ['\\nVleftarrowtail', '⬺'],
   ['\\leftcurvedarrow', '⬿'],
   ['\\leftarrowapprox', '⭊'],
   ['\\mathbf{\\Lambda}', '𝚲'],
   ['\\mathbf{\\lambda}', '𝛌'],
   ['\\mathbf{\\varphi}', '𝛗'],
   ['\\mathbf{\\varrho}', '𝛠'],
   ['\\mathit{\\Lambda}', '𝛬'],
   ['\\mathit{\\lambda}', '𝜆'],
   ['\\mathit{\\varphi}', '𝜑'],
   ['\\mathit{\\varrho}', '𝜚'],
   ['\\mathbfit{\\beta}', '𝜷'],
   ['\\mathbold{\\beta}', '𝜷'],
   ['\\mathbfit{\\zeta}', '𝜻'],
   ['\\mathbold{\\zeta}', '𝜻'],
   ['\\mathbfit{\\iota}', '𝜾'],
   ['\\mathbold{\\iota}', '𝜾'],
   ['\\mbfitvarepsilon', '𝝐'],
   ['\\mbfsansvarTheta', '𝝧'],
   ['\\mathsfbf{\\beta}', '𝝱'],
   ['\\mathsfbf{\\zeta}', '𝝵'],
   ['\\mathsfbf{\\iota}', '𝝸'],
   ['\\mbfsansvarsigma', '𝞁'],
   ['\\mbfsansvartheta', '𝞋'],
   ['\\mbfsansvarkappa', '𝞌'],
   ['\\mbfitsansLambda', '𝞚'],
   ['\\mathsfbfit{\\Xi}', '𝞝'],
   ['\\mathsfbfit{\\Pi}', '𝞟'],
   ['\\mbfitsanslambda', '𝞴'],
   ['\\mathsfbfit{\\mu}', '𝞵'],
   ['\\mathsfbfit{\\nu}', '𝞶'],
   ['\\mathsfbfit{\\xi}', '𝞷'],
   ['\\mathsfbfit{\\pi}', '𝞹'],
   ['\\mbfitsansvarphi', '𝟇'],
   ['\\mbfitsansvarrho', '𝟈'],
   ['\\curvearrowleft', '↶'],
   ['\\guilsinglright', '›'],
   ['\\leftthreetimes', '⋋'],
   ['\\leftrightarrow', '↔'],
   ['\\rightharpoonup', '⇀'],
   ['\\guillemotright', '»'],
   ['\\downdownarrows', '⇊'],
   ['\\hookrightarrow', '↪'],
   ['\\hspace{0.25em}', ' '],
   ['\\dashrightarrow', '⇢'],
   ['\\leftleftarrows', '⇇'],
   ['\\trianglelefteq', '⊴'],
   ['\\ntriangleright', '⋫'],
   ['\\doublebarwedge', '⌆'],
   ['\\upharpoonright', '↾'],
   ['\\rightarrowtail', '↣'],
   ['\\looparrowright', '↬'],
   ['\\Leftrightarrow', '⇔'],
   ['\\sphericalangle', '∢'],
   ['\\ocommatopright', '̕'],
   ['\\mathrm{\\Gamma}', 'Γ'],
   ['\\mathrm{\\Delta}', 'Δ'],
   ['\\mathrm{\\Theta}', 'Θ'],
   ['\\mathrm{\\Sigma}', 'Σ'],
   ['\\mathrm{\\Omega}', 'Ω'],
   ['\\mathrm{\\alpha}', 'α'],
   ['\\mathrm{\\gamma}', 'γ'],
   ['\\mathrm{\\delta}', 'δ'],
   ['\\mathrm{\\theta}', 'θ'],
   ['\\mathrm{\\kappa}', 'κ'],
   ['\\mathrm{\\sigma}', 'σ'],
   ['\\mathrm{\\omega}', 'ω'],
   ['\\mathrm{\\varpi}', 'ϖ'],
   ['\\overrightarrow', '⃗'],
   ['\\enclosediamond', '⃟'],
   ['\\underleftarrow', '⃮'],
   ['\\mathbb{\\gamma}', 'ℽ'],
   ['\\mathbb{\\Gamma}', 'ℾ'],
   ['\\mathbb{\\Sigma}', '⅀'],
   ['\\rightwavearrow', '↝'],
   ['\\twoheaduparrow', '↟'],
   ['\\updownarrowbar', '↨'],
   ['\\carriagereturn', '↵'],
   ['\\rightleftarrow', '⇄'],
   ['\\revequilibrium', '⇋'],
   ['\\leftsquigarrow', '⇜'],
   ['\\rightdasharrow', '⇢'],
   ['\\leftwhitearrow', '⇦'],
   ['\\downwhitearrow', '⇩'],
   ['\\NotGreaterLess', '≹'],
   ['\\APLboxquestion', '⍰'],
   ['\\lparenextender', '⎜'],
   ['\\rparenextender', '⎟'],
   ['\\lbrackextender', '⎢'],
   ['\\rbrackextender', '⎥'],
   ['\\vbraceextender', '⎪'],
   ['\\harrowextender', '⎯'],
   ['\\blockrighthalf', '▐'],
   ['\\blockqtrshaded', '░'],
   ['\\squarenwsefill', '▧'],
   ['\\squareneswfill', '▨'],
   ['\\mdlgblkdiamond', '◆'],
   ['\\mdlgwhtdiamond', '◇'],
   ['\\mdlgwhtlozenge', '◊'],
   ['\\circlevertfill', '◍'],
   ['\\vardiamondsuit', '♦'],
   ['\\circledtwodots', '⚇'],
   ['\\rightouterjoin', '⟖'],
   ['\\concavediamond', '⟡'],
   ['\\longrightarrow', '⟶'],
   ['\\Longrightarrow', '⟹'],
   ['\\longmappedfrom', '⟻'],
   ['\\Longmappedfrom', '⟽'],
   ['\\fdiagovnearrow', '⤯'],
   ['\\rdiagovsearrow', '⤰'],
   ['\\acwcirclearrow', '⥀'],
   ['\\rightarrowplus', '⥅'],
   ['\\RightVectorBar', '⥓'],
   ['\\RightTeeVector', '⥛'],
   ['\\leftbarharpoon', '⥪'],
   ['\\barleftharpoon', '⥫'],
   ['\\updownharpoons', '⥮'],
   ['\\downupharpoons', '⥯'],
   ['\\rightanglemdot', '⦝'],
   ['\\triangleserifs', '⧍'],
   ['\\blackhourglass', '⧗'],
   ['\\mdlgblklozenge', '⧫'],
   ['\\bigslopedwedge', '⩘'],
   ['\\wedgedoublebar', '⩠'],
   ['\\NestedLessLess', '⪡'],
   ['\\squaretopblack', '⬒'],
   ['\\squarebotblack', '⬓'],
   ['\\equalleftarrow', '⭀'],
   ['\\mathbf{\\Gamma}', '𝚪'],
   ['\\mathbf{\\Delta}', '𝚫'],
   ['\\mathbf{\\Theta}', '𝚯'],
   ['\\mathbf{\\Sigma}', '𝚺'],
   ['\\mathbf{\\Omega}', '𝛀'],
   ['\\mathbf{\\alpha}', '𝛂'],
   ['\\mathbf{\\gamma}', '𝛄'],
   ['\\mathbf{\\delta}', '𝛅'],
   ['\\mathbf{\\theta}', '𝛉'],
   ['\\mathbf{\\kappa}', '𝛋'],
   ['\\mathbf{\\sigma}', '𝛔'],
   ['\\mathbf{\\omega}', '𝛚'],
   ['\\mathbf{\\varpi}', '𝛡'],
   ['\\mathit{\\Gamma}', '𝛤'],
   ['\\mathit{\\Delta}', '𝛥'],
   ['\\mathit{\\Theta}', '𝛩'],
   ['\\mathit{\\Sigma}', '𝛴'],
   ['\\mathit{\\Omega}', '𝛺'],
   ['\\mathit{\\alpha}', '𝛼'],
   ['\\mathit{\\gamma}', '𝛾'],
   ['\\mathit{\\delta}', '𝛿'],
   ['\\mathit{\\theta}', '𝜃'],
   ['\\mathit{\\kappa}', '𝜅'],
   ['\\mathit{\\sigma}', '𝜎'],
   ['\\mathit{\\omega}', '𝜔'],
   ['\\mathit{\\varpi}', '𝜛'],
   ['\\mathbfit{\\Phi}', '𝜱'],
   ['\\mathbold{\\Phi}', '𝜱'],
   ['\\mathbfit{\\Psi}', '𝜳'],
   ['\\mathbold{\\Psi}', '𝜳'],
   ['\\mathbfit{\\eta}', '𝜼'],
   ['\\mathbold{\\eta}', '𝜼'],
   ['\\mathbfit{\\rho}', '𝝆'],
   ['\\mathbold{\\rho}', '𝝆'],
   ['\\mathbfit{\\tau}', '𝝉'],
   ['\\mathbold{\\tau}', '𝝉'],
   ['\\mathbfit{\\chi}', '𝝌'],
   ['\\mathbold{\\chi}', '𝝌'],
   ['\\mathbfit{\\psi}', '𝝍'],
   ['\\mathbold{\\psi}', '𝝍'],
   ['\\mathbfit{\\phi}', '𝝓'],
   ['\\mathbold{\\phi}', '𝝓'],
   ['\\mbfsansEpsilon', '𝝚'],
   ['\\mbfsansOmicron', '𝝤'],
   ['\\mbfsansUpsilon', '𝝪'],
   ['\\mathsfbf{\\Phi}', '𝝫'],
   ['\\mathsfbf{\\Psi}', '𝝭'],
   ['\\mbfsansepsilon', '𝝴'],
   ['\\mathsfbf{\\eta}', '𝝶'],
   ['\\mbfsansomicron', '𝝾'],
   ['\\mathsfbf{\\rho}', '𝞀'],
   ['\\mathsfbf{\\tau}', '𝞃'],
   ['\\mbfsansupsilon', '𝞄'],
   ['\\mathsfbf{\\chi}', '𝞆'],
   ['\\mathsfbf{\\psi}', '𝞇'],
   ['\\mbfsanspartial', '𝞉'],
   ['\\mathsfbf{\\phi}', '𝞍'],
   ['\\mbfitsansAlpha', '𝞐'],
   ['\\mbfitsansGamma', '𝞒'],
   ['\\mbfitsansDelta', '𝞓'],
   ['\\mbfitsansTheta', '𝞗'],
   ['\\mbfitsansKappa', '𝞙'],
   ['\\mbfitsansSigma', '𝞢'],
   ['\\mbfitsansOmega', '𝞨'],
   ['\\mbfitsansnabla', '𝞩'],
   ['\\mbfitsansalpha', '𝞪'],
   ['\\mbfitsansgamma', '𝞬'],
   ['\\mbfitsansdelta', '𝞭'],
   ['\\mbfitsanstheta', '𝞱'],
   ['\\mbfitsanskappa', '𝞳'],
   ['\\mbfitsanssigma', '𝞼'],
   ['\\mbfitsansomega', '𝟂'],
   ['\\mbfitsansvarpi', '𝟉'],
   ['\\divideontimes', '⋇'],
   ['\\measuredangle', '∡'],
   ['\\blacktriangle', '▴'],
   ['\\ntriangleleft', '⋪'],
   ['\\mathchar"1356', '⁁'],
   ['\\texttrademark', '™'],
   ['\\mathchar"2208', '⌖'],
   ['\\triangleright', '▹'],
   ['\\leftarrowtail', '↢'],
   ['\\guilsinglleft', '‹'],
   ['\\upharpoonleft', '↿'],
   ['\\mathbb{gamma}', 'ℽ'],
   ['\\fallingdotseq', '≒'],
   ['\\looparrowleft', '↫'],
   ['\\textbrokenbar', '¦'],
   ['\\hookleftarrow', '↩'],
   ['\\smallsetminus', '﹨'],
   ['\\dashleftarrow', '⇠'],
   ['\\guillemotleft', '«'],
   ['\\leftharpoonup', '↼'],
   ['\\mathbb{Gamma}', 'ℾ'],
   ['\\bigtriangleup', '△'],
   ['\\mathrm{\\beta}', 'β'],
   ['\\mathrm{\\zeta}', 'ζ'],
   ['\\mathrm{\\iota}', 'ι'],
   ['\\upbackepsilon', '϶'],
   ['\\overleftarrow', '⃖'],
   ['\\enclosecircle', '⃝'],
   ['\\enclosesquare', '⃞'],
   ['\\threeunderdot', '⃨'],
   ['\\sansLmirrored', '⅃'],
   ['\\DifferentialD', 'ⅆ'],
   ['\\leftwavearrow', '↜'],
   ['\\leftdasharrow', '⇠'],
   ['\\downdasharrow', '⇣'],
   ['\\RightArrowBar', '⇥'],
   ['\\rightarrowbar', '⇥'],
   ['\\vysmwhtcircle', '∘'],
   ['\\vysmblkcircle', '∙'],
   ['\\wasytherefore', '∴'],
   ['\\dotsminusdots', '∺'],
   ['\\PrecedesTilde', '≾'],
   ['\\SucceedsTilde', '≿'],
   ['\\varlrtriangle', '⊿'],
   ['\\equalparallel', '⋕'],
   ['\\APLuparrowbox', '⍐'],
   ['\\APLboxupcaret', '⍓'],
   ['\\bdtriplevdash', '┆'],
   ['\\blocklefthalf', '▌'],
   ['\\mdlgblksquare', '■'],
   ['\\mdlgwhtsquare', '□'],
   ['\\parallelogram', '▱'],
   ['\\RightTriangle', '▷'],
   ['\\mdlgwhtcircle', '○'],
   ['\\mdlgblkcircle', '●'],
   ['\\inversebullet', '◘'],
   ['\\topsemicircle', '◠'],
   ['\\botsemicircle', '◡'],
   ['\\squareulblack', '◩'],
   ['\\squarelrblack', '◪'],
   ['\\mdsmwhtsquare', '◽'],
   ['\\mdsmblksquare', '◾'],
   ['\\sixteenthnote', '♬'],
   ['\\Hermaphrodite', '⚥'],
   ['\\mdsmwhtcircle', '⚬'],
   ['\\draftingarrow', '➛'],
   ['\\leftouterjoin', '⟕'],
   ['\\fullouterjoin', '⟗'],
   ['\\longleftarrow', '⟵'],
   ['\\Longleftarrow', '⟸'],
   ['\\twoheadmapsto', '⤅'],
   ['\\uparrowbarred', '⤉'],
   ['\\rightdotarrow', '⤑'],
   ['\\cwcirclearrow', '⥁'],
   ['\\leftarrowplus', '⥆'],
   ['\\LeftVectorBar', '⥒'],
   ['\\LeftTeeVector', '⥚'],
   ['\\upequilibrium', '⥮'],
   ['\\leftarrowless', '⥷'],
   ['\\rightfishtail', '⥽'],
   ['\\mdsmblkcircle', '⦁'],
   ['\\llparenthesis', '⦇'],
   ['\\rrparenthesis', '⦈'],
   ['\\rightanglesqr', '⦜'],
   ['\\wideangledown', '⦦'],
   ['\\emptysetocirc', '⦲'],
   ['\\emptysetoarrl', '⦴'],
   ['\\circledbslash', '⦸'],
   ['\\circledbullet', '⦿'],
   ['\\errbardiamond', '⧰'],
   ['\\triangleminus', '⨺'],
   ['\\triangletimes', '⨻'],
   ['\\shortlefttack', '⫞'],
   ['\\shortdowntack', '⫟'],
   ['\\threedotcolon', '⫶'],
   ['\\biginterleave', '⫼'],
   ['\\bigtalloblong', '⫿'],
   ['\\squareurblack', '⬔'],
   ['\\squarellblack', '⬕'],
   ['\\vysmblksquare', '⬝'],
   ['\\vysmwhtsquare', '⬞'],
   ['\\pentagonblack', '⬟'],
   ['\\rightarrowgtr', '⭃'],
   ['\\rightpentagon', '⭔'],
   ['\\mathsfbfit{A}', '𝘼'],
   ['\\mathsfbfit{B}', '𝘽'],
   ['\\mathsfbfit{C}', '𝘾'],
   ['\\mathsfbfit{D}', '𝘿'],
   ['\\mathsfbfit{E}', '𝙀'],
   ['\\mathsfbfit{F}', '𝙁'],
   ['\\mathsfbfit{G}', '𝙂'],
   ['\\mathsfbfit{H}', '𝙃'],
   ['\\mathsfbfit{I}', '𝙄'],
   ['\\mathsfbfit{J}', '𝙅'],
   ['\\mathsfbfit{K}', '𝙆'],
   ['\\mathsfbfit{L}', '𝙇'],
   ['\\mathsfbfit{M}', '𝙈'],
   ['\\mathsfbfit{N}', '𝙉'],
   ['\\mathsfbfit{O}', '𝙊'],
   ['\\mathsfbfit{P}', '𝙋'],
   ['\\mathsfbfit{Q}', '𝙌'],
   ['\\mathsfbfit{R}', '𝙍'],
   ['\\mathsfbfit{S}', '𝙎'],
   ['\\mathsfbfit{T}', '𝙏'],
   ['\\mathsfbfit{U}', '𝙐'],
   ['\\mathsfbfit{V}', '𝙑'],
   ['\\mathsfbfit{W}', '𝙒'],
   ['\\mathsfbfit{X}', '𝙓'],
   ['\\mathsfbfit{Y}', '𝙔'],
   ['\\mathsfbfit{Z}', '𝙕'],
   ['\\mathsfbfit{a}', '𝙖'],
   ['\\mathsfbfit{b}', '𝙗'],
   ['\\mathsfbfit{c}', '𝙘'],
   ['\\mathsfbfit{d}', '𝙙'],
   ['\\mathsfbfit{e}', '𝙚'],
   ['\\mathsfbfit{f}', '𝙛'],
   ['\\mathsfbfit{g}', '𝙜'],
   ['\\mathsfbfit{h}', '𝙝'],
   ['\\mathsfbfit{i}', '𝙞'],
   ['\\mathsfbfit{j}', '𝙟'],
   ['\\mathsfbfit{k}', '𝙠'],
   ['\\mathsfbfit{l}', '𝙡'],
   ['\\mathsfbfit{m}', '𝙢'],
   ['\\mathsfbfit{n}', '𝙣'],
   ['\\mathsfbfit{o}', '𝙤'],
   ['\\mathsfbfit{p}', '𝙥'],
   ['\\mathsfbfit{q}', '𝙦'],
   ['\\mathsfbfit{r}', '𝙧'],
   ['\\mathsfbfit{s}', '𝙨'],
   ['\\mathsfbfit{t}', '𝙩'],
   ['\\mathsfbfit{u}', '𝙪'],
   ['\\mathsfbfit{v}', '𝙫'],
   ['\\mathsfbfit{w}', '𝙬'],
   ['\\mathsfbfit{x}', '𝙭'],
   ['\\mathsfbfit{y}', '𝙮'],
   ['\\mathsfbfit{z}', '𝙯'],
   ['\\mathbf{\\beta}', '𝛃'],
   ['\\mathbf{\\zeta}', '𝛇'],
   ['\\mathbf{\\iota}', '𝛊'],
   ['\\mbfvarepsilon', '𝛜'],
   ['\\mathit{\\beta}', '𝛽'],
   ['\\mathit{\\zeta}', '𝜁'],
   ['\\mathit{\\iota}', '𝜄'],
   ['\\mitvarepsilon', '𝜖'],
   ['\\mathbfit{\\Xi}', '𝜩'],
   ['\\mathbold{\\Xi}', '𝜩'],
   ['\\mathbfit{\\Pi}', '𝜫'],
   ['\\mathbold{\\Pi}', '𝜫'],
   ['\\mbfitvarTheta', '𝜭'],
   ['\\mathbfit{\\mu}', '𝝁'],
   ['\\mathbold{\\mu}', '𝝁'],
   ['\\mathbfit{\\nu}', '𝝂'],
   ['\\mathbold{\\nu}', '𝝂'],
   ['\\mathbfit{\\xi}', '𝝃'],
   ['\\mathbold{\\xi}', '𝝃'],
   ['\\mathbfit{\\pi}', '𝝅'],
   ['\\mathbold{\\pi}', '𝝅'],
   ['\\mbfitvarsigma', '𝝇'],
   ['\\mbfitvartheta', '𝝑'],
   ['\\mbfitvarkappa', '𝝒'],
   ['\\mbfsansLambda', '𝝠'],
   ['\\mathsfbf{\\Xi}', '𝝣'],
   ['\\mathsfbf{\\Pi}', '𝝥'],
   ['\\mbfsanslambda', '𝝺'],
   ['\\mathsfbf{\\mu}', '𝝻'],
   ['\\mathsfbf{\\nu}', '𝝼'],
   ['\\mathsfbf{\\xi}', '𝝽'],
   ['\\mathsfbf{\\pi}', '𝝿'],
   ['\\mbfsansvarphi', '𝞍'],
   ['\\mbfsansvarrho', '𝞎'],
   ['\\mbfitsansBeta', '𝞑'],
   ['\\mbfitsansZeta', '𝞕'],
   ['\\mbfitsansIota', '𝞘'],
   ['\\mbfitsansbeta', '𝞫'],
   ['\\mbfitsanszeta', '𝞯'],
   ['\\mbfitsansiota', '𝞲'],
   ['\\textcircledP', '℗'],
   ['\\risingdotseq', '≓'],
   ['\\triangleleft', '◃'],
   ['\\mathsterling', '£'],
   ['\\textcurrency', '¤'],
   ['\\triangledown', '▿'],
   ['\\blacklozenge', ''],
   ['\\binampersand', '&'],
   ['\\oturnedcomma', '̒'],
   ['\\mathrm{\\Phi}', 'Φ'],
   ['\\mathrm{\\Psi}', 'Ψ'],
   ['\\varepsilonup', 'ε'],
   ['\\mathrm{\\eta}', 'η'],
   ['\\mathrm{\\rho}', 'ρ'],
   ['\\mathrm{\\tau}', 'τ'],
   ['\\mathrm{\\chi}', 'χ'],
   ['\\mathrm{\\psi}', 'ψ'],
   ['\\mathrm{\\phi}', 'ϕ'],
   ['\\upvarepsilon', 'ϵ'],
   ['\\hyphenbullet', '⁃'],
   ['\\PropertyLine', '⅊'],
   ['\\bindnasrepma', '⅋'],
   ['\\updownarrows', '⇅'],
   ['\\LeftArrowBar', '⇤'],
   ['\\barleftarrow', '⇤'],
   ['\\upwhitearrow', '⇧'],
   ['\\downuparrows', '⇵'],
   ['\\nvrightarrow', '⇸'],
   ['\\nVrightarrow', '⇻'],
   ['\\intclockwise', '∱'],
   ['\\cntclockoint', '∳'],
   ['\\GreaterTilde', '≳'],
   ['\\NotLessTilde', '≴'],
   ['\\varsubsetneq', '⊊'],
   ['\\cupleftarrow', '⊌'],
   ['\\circledequal', '⊜'],
   ['\\hermitmatrix', '⊹'],
   ['\\smwhtdiamond', '⋄'],
   ['\\npreccurlyeq', '⋠'],
   ['\\nsucccurlyeq', '⋡'],
   ['\\unicodecdots', '⋯'],
   ['\\notbackslash', '⍀'],
   ['\\underbracket', '⎵'],
   ['\\blocklowhalf', '▄'],
   ['\\squarehvfill', '▦'],
   ['\\LeftTriangle', '◁'],
   ['\\Diamondblack', '◆'],
   ['\\dottedcircle', '◌'],
   ['\\trianglecdot', '◬'],
   ['\\squareulquad', '◰'],
   ['\\squarellquad', '◱'],
   ['\\squarelrquad', '◲'],
   ['\\squareurquad', '◳'],
   ['\\circleulquad', '◴'],
   ['\\circlellquad', '◵'],
   ['\\circlelrquad', '◶'],
   ['\\circleurquad', '◷'],
   ['\\bigwhitestar', '☆'],
   ['\\invsmileface', '☻'],
   ['\\varspadesuit', '♤'],
   ['\\varheartsuit', '♥'],
   ['\\dingasterisk', '✽'],
   ['\\longdivision', '⟌'],
   ['\\lozengeminus', '⟠'],
   ['\\longmapsfrom', '⟻'],
   ['\\Longmapsfrom', '⟽'],
   ['\\nvRightarrow', '⤃'],
   ['\\rightbkarrow', '⤍'],
   ['\\leftdbkarrow', '⤎'],
   ['\\DownArrowBar', '⤓'],
   ['\\downarrowbar', '⤓'],
   ['\\rightdbltail', '⤜'],
   ['\\rdiagovfdiag', '⤫'],
   ['\\fdiagovrdiag', '⤬'],
   ['\\upupharpoons', '⥣'],
   ['\\leftfishtail', '⥼'],
   ['\\downfishtail', '⥿'],
   ['\\lbrackultick', '⦍'],
   ['\\rbracklrtick', '⦎'],
   ['\\lbracklltick', '⦏'],
   ['\\rbrackurtick', '⦐'],
   ['\\revangleubar', '⦥'],
   ['\\emptysetobar', '⦱'],
   ['\\emptysetoarr', '⦳'],
   ['\\odotslashdot', '⦼'],
   ['\\ogreaterthan', '⧁'],
   ['\\triangleodot', '⧊'],
   ['\\triangleubar', '⧋'],
   ['\\multimapboth', '⧟'],
   ['\\lrtriangleeq', '⧡'],
   ['\\errbarsquare', '⧮'],
   ['\\errbarcircle', '⧲'],
   ['\\triangleplus', '⨹'],
   ['\\closedvarcup', '⩌'],
   ['\\closedvarcap', '⩍'],
   ['\\wedgeonwedge', '⩕'],
   ['\\bigslopedvee', '⩗'],
   ['\\wedgemidvert', '⩚'],
   ['\\doublebarvee', '⩢'],
   ['\\veedoublebar', '⩣'],
   ['\\eqqslantless', '⪛'],
   ['\\subsetapprox', '⫉'],
   ['\\supsetapprox', '⫊'],
   ['\\dottedsquare', '⬚'],
   ['\\hexagonblack', '⬣'],
   ['\\mdblkdiamond', '⬥'],
   ['\\mdwhtdiamond', '⬦'],
   ['\\mdblklozenge', '⬧'],
   ['\\mdwhtlozenge', '⬨'],
   ['\\smblkdiamond', '⬩'],
   ['\\smblklozenge', '⬪'],
   ['\\smwhtlozenge', '⬫'],
   ['\\leftdotarrow', '⬸'],
   ['\\medwhitestar', '⭐'],
   ['\\medblackstar', '⭑'],
   ['\\mathbf{\\Phi}', '𝚽'],
   ['\\mathbf{\\Psi}', '𝚿'],
   ['\\mathbf{\\eta}', '𝛈'],
   ['\\mathbf{\\rho}', '𝛒'],
   ['\\mathbf{\\tau}', '𝛕'],
   ['\\mathbf{\\chi}', '𝛘'],
   ['\\mathbf{\\psi}', '𝛙'],
   ['\\mathbf{\\phi}', '𝛟'],
   ['\\mathit{\\Phi}', '𝛷'],
   ['\\mathit{\\Psi}', '𝛹'],
   ['\\mathit{\\eta}', '𝜂'],
   ['\\mathit{\\rho}', '𝜌'],
   ['\\mathit{\\tau}', '𝜏'],
   ['\\mathit{\\chi}', '𝜒'],
   ['\\mathit{\\psi}', '𝜓'],
   ['\\mathit{\\phi}', '𝜙'],
   ['\\mbfitEpsilon', '𝜠'],
   ['\\mbfitOmicron', '𝜪'],
   ['\\mbfitUpsilon', '𝜰'],
   ['\\mbfitepsilon', '𝜺'],
   ['\\mbfitomicron', '𝝄'],
   ['\\mbfitupsilon', '𝝊'],
   ['\\mbfitpartial', '𝝏'],
   ['\\mbfsansAlpha', '𝝖'],
   ['\\mbfsansGamma', '𝝘'],
   ['\\mbfsansDelta', '𝝙'],
   ['\\mbfsansTheta', '𝝝'],
   ['\\mbfsansKappa', '𝝟'],
   ['\\mbfsansSigma', '𝝨'],
   ['\\mbfsansOmega', '𝝮'],
   ['\\mbfsansnabla', '𝝯'],
   ['\\mbfsansalpha', '𝝰'],
   ['\\mbfsansgamma', '𝝲'],
   ['\\mbfsansdelta', '𝝳'],
   ['\\mbfsanstheta', '𝝷'],
   ['\\mbfsanskappa', '𝝹'],
   ['\\mbfsanssigma', '𝞂'],
   ['\\mbfsansomega', '𝞈'],
   ['\\mbfsansvarpi', '𝞏'],
   ['\\mbfitsansEta', '𝞖'],
   ['\\mbfitsansRho', '𝞠'],
   ['\\mbfitsansTau', '𝞣'],
   ['\\mbfitsansPhi', '𝞥'],
   ['\\mbfitsansChi', '𝞦'],
   ['\\mbfitsansPsi', '𝞧'],
   ['\\mbfitsanseta', '𝞰'],
   ['\\mbfitsansrho', '𝞺'],
   ['\\mbfitsanstau', '𝞽'],
   ['\\mbfitsansphi', '𝞿'],
   ['\\mbfitsanschi', '𝟀'],
   ['\\mbfitsanspsi', '𝟁'],
   ['\\mbfsansthree', '𝟯'],
   ['\\mbfsansseven', '𝟳'],
   ['\\mbfsanseight', '𝟴'],
   ['\\sfrac{5}{6}', '⅚'],
   ['\\preccurlyeq', '≼'],
   ['\\Rrightarrow', '⇛'],
   ['\\circledcirc', '⊚'],
   ['\\nRightarrow', '⇏'],
   ['\\sfrac{3}{8}', '⅜'],
   ['\\sfrac{1}{3}', '⅓'],
   ['\\sfrac{2}{5}', '⅖'],
   ['\\vartriangle', '▵'],
   ['\\Updownarrow', '⇕'],
   ['\\nrightarrow', '↛'],
   ['\\sfrac{1}{2}', '½'],
   ['\\sfrac{3}{5}', '⅗'],
   ['\\succcurlyeq', '≽'],
   ['\\sfrac{4}{5}', '⅘'],
   ['\\diamondsuit', '♦'],
   ['\\hphantom{0}', ' '],
   ['\\sfrac{1}{6}', '⅙'],
   ['\\curlyeqsucc', '⋟'],
   ['\\blacksquare', '▪'],
   ['\\hphantom{,}', ' '],
   ['\\curlyeqprec', '⋞'],
   ['\\sfrac{1}{8}', '⅛'],
   ['\\sfrac{7}{8}', '⅞'],
   ['\\sfrac{1}{5}', '⅕'],
   ['\\sfrac{2}{3}', '⅔'],
   ['\\updownarrow', '↕'],
   ['\\backepsilon', '∍'],
   ['\\circleddash', '⊝'],
   ['\\eqslantless', '⋜'],
   ['\\sfrac{3}{4}', '¾'],
   ['\\sfrac{5}{8}', '⅝'],
   ['\\hspace{1pt}', ' '],
   ['\\sfrac{1}{4}', '¼'],
   ['\\mathrm{\\mu}', 'µ'],
   ['\\mathrm{\\Xi}', 'Ξ'],
   ['\\mathrm{\\Pi}', 'Π'],
   ['\\mathrm{\\nu}', 'ν'],
   ['\\mathrm{\\xi}', 'ξ'],
   ['\\mathrm{\\pi}', 'π'],
   ['\\hspace{0pt}', '​'],
   ['\\smblkcircle', '•'],
   ['\\backtrprime', '‷'],
   ['\\caretinsert', '‸'],
   ['\\vertoverlay', '⃒'],
   ['\\asteraccent', '⃰'],
   ['\\mathfrak{H}', 'ℌ'],
   ['\\Planckconst', 'ℎ'],
   ['\\mathfrak{I}', 'ℑ'],
   ['\\mathfrak{R}', 'ℜ'],
   ['\\mathfrak{Z}', 'ℨ'],
   ['\\mathfrak{C}', 'ℭ'],
   ['\\mathbb{\\pi}', 'ℼ'],
   ['\\mathbb{\\Pi}', 'ℿ'],
   ['\\sansLturned', '⅂'],
   ['\\ExponetialE', 'ⅇ'],
   ['\\restriction', '↾'],
   ['\\equilibrium', '⇌'],
   ['\\nHdownarrow', '⇟'],
   ['\\updasharrow', '⇡'],
   ['\\nvleftarrow', '⇷'],
   ['\\nVleftarrow', '⇺'],
   ['\\approxident', '≋'],
   ['\\corresponds', '≙'],
   ['\\Corresponds', '≙'],
   ['\\GreaterLess', '≷'],
   ['\\nsqsubseteq', '⋢'],
   ['\\nsqsupseteq', '⋣'],
   ['\\sqsubsetneq', '⋤'],
   ['\\sqsupsetneq', '⋥'],
   ['\\varisinobar', '⋶'],
   ['\\varbarwedge', '⌅'],
   ['\\wasylozenge', '⌑'],
   ['\\APLnotslash', '⌿'],
   ['\\invdiameter', '⍉'],
   ['\\intextender', '⎮'],
   ['\\overbracket', '⎴'],
   ['\\blockuphalf', '▀'],
   ['\\squarehfill', '▤'],
   ['\\squarevfill', '▥'],
   ['\\smblksquare', '▪'],
   ['\\smwhtsquare', '▫'],
   ['\\RIGHTcircle', '◑'],
   ['\\RIGHTCIRCLE', '◗'],
   ['\\smwhtcircle', '◦'],
   ['\\lgwhtcircle', '◯'],
   ['\\mdwhtsquare', '◻'],
   ['\\mdblksquare', '◼'],
   ['\\CONJUNCTION', '☌'],
   ['\\blacksmiley', '☻'],
   ['\\sagittarius', '♐'],
   ['\\capricornus', '♑'],
   ['\\varclubsuit', '♧'],
   ['\\quarternote', '♩'],
   ['\\mdwhtcircle', '⚪'],
   ['\\mdblkcircle', '⚫'],
   ['\\ballotcheck', '✓'],
   ['\\circledstar', '✪'],
   ['\\arrowbullet', '➢'],
   ['\\threedangle', '⟀'],
   ['\\diamondcdot', '⟐'],
   ['\\multimapinv', '⟜'],
   ['\\nvLeftarrow', '⤂'],
   ['\\leftbkarrow', '⤌'],
   ['\\leftdbltail', '⤛'],
   ['\\seovnearrow', '⤭'],
   ['\\neovsearrow', '⤮'],
   ['\\neovnwarrow', '⤱'],
   ['\\nwovnearrow', '⤲'],
   ['\\rightarrowx', '⥇'],
   ['\\wideangleup', '⦧'],
   ['\\revemptyset', '⦰'],
   ['\\circledvert', '⦶'],
   ['\\circledless', '⧀'],
   ['\\gleichstark', '⧦'],
   ['\\ruledelayed', '⧴'],
   ['\\lcurvyangle', '⧼'],
   ['\\rcurvyangle', '⧽'],
   ['\\otimeslhrim', '⨴'],
   ['\\otimesrhrim', '⨵'],
   ['\\midbarwedge', '⩜'],
   ['\\simminussim', '⩬'],
   ['\\eqqslantgtr', '⪜'],
   ['\\precnapprox', '⪹'],
   ['\\succnapprox', '⪺'],
   ['\\shortuptack', '⫠'],
   ['\\varparallel', '⫽'],
   ['\\lgblksquare', '⬛'],
   ['\\lgwhtsquare', '⬜'],
   ['\\lgblkcircle', '⬤'],
   ['\\blkhorzoval', '⬬'],
   ['\\whthorzoval', '⬭'],
   ['\\blkvertoval', '⬮'],
   ['\\whtvertoval', '⬯'],
   ['\\RRightarrow', '⭆'],
   ['\\smwhitestar', '⭒'],
   ['\\mathbfit{A}', '𝑨'],
   ['\\mathbold{A}', '𝑨'],
   ['\\mathbfit{B}', '𝑩'],
   ['\\mathbold{B}', '𝑩'],
   ['\\mathbfit{C}', '𝑪'],
   ['\\mathbold{C}', '𝑪'],
   ['\\mathbfit{D}', '𝑫'],
   ['\\mathbold{D}', '𝑫'],
   ['\\mathbfit{E}', '𝑬'],
   ['\\mathbold{E}', '𝑬'],
   ['\\mathbfit{F}', '𝑭'],
   ['\\mathbold{F}', '𝑭'],
   ['\\mathbfit{G}', '𝑮'],
   ['\\mathbold{G}', '𝑮'],
   ['\\mathbfit{H}', '𝑯'],
   ['\\mathbold{H}', '𝑯'],
   ['\\mathbfit{I}', '𝑰'],
   ['\\mathbold{I}', '𝑰'],
   ['\\mathbfit{J}', '𝑱'],
   ['\\mathbold{J}', '𝑱'],
   ['\\mathbfit{K}', '𝑲'],
   ['\\mathbold{K}', '𝑲'],
   ['\\mathbfit{L}', '𝑳'],
   ['\\mathbold{L}', '𝑳'],
   ['\\mathbfit{M}', '𝑴'],
   ['\\mathbold{M}', '𝑴'],
   ['\\mathbfit{N}', '𝑵'],
   ['\\mathbold{N}', '𝑵'],
   ['\\mathbfit{O}', '𝑶'],
   ['\\mathbold{O}', '𝑶'],
   ['\\mathbfit{P}', '𝑷'],
   ['\\mathbold{P}', '𝑷'],
   ['\\mathbfit{Q}', '𝑸'],
   ['\\mathbold{Q}', '𝑸'],
   ['\\mathbfit{R}', '𝑹'],
   ['\\mathbold{R}', '𝑹'],
   ['\\mathbfit{S}', '𝑺'],
   ['\\mathbold{S}', '𝑺'],
   ['\\mathbfit{T}', '𝑻'],
   ['\\mathbold{T}', '𝑻'],
   ['\\mathbfit{U}', '𝑼'],
   ['\\mathbold{U}', '𝑼'],
   ['\\mathbfit{V}', '𝑽'],
   ['\\mathbold{V}', '𝑽'],
   ['\\mathbfit{W}', '𝑾'],
   ['\\mathbold{W}', '𝑾'],
   ['\\mathbfit{X}', '𝑿'],
   ['\\mathbold{X}', '𝑿'],
   ['\\mathbfit{Y}', '𝒀'],
   ['\\mathbold{Y}', '𝒀'],
   ['\\mathbfit{Z}', '𝒁'],
   ['\\mathbold{Z}', '𝒁'],
   ['\\mathbfit{a}', '𝒂'],
   ['\\mathbold{a}', '𝒂'],
   ['\\mathbfit{b}', '𝒃'],
   ['\\mathbold{b}', '𝒃'],
   ['\\mathbfit{c}', '𝒄'],
   ['\\mathbold{c}', '𝒄'],
   ['\\mathbfit{d}', '𝒅'],
   ['\\mathbold{d}', '𝒅'],
   ['\\mathbfit{e}', '𝒆'],
   ['\\mathbold{e}', '𝒆'],
   ['\\mathbfit{f}', '𝒇'],
   ['\\mathbold{f}', '𝒇'],
   ['\\mathbfit{g}', '𝒈'],
   ['\\mathbold{g}', '𝒈'],
   ['\\mathbfit{h}', '𝒉'],
   ['\\mathbold{h}', '𝒉'],
   ['\\mathbfit{i}', '𝒊'],
   ['\\mathbold{i}', '𝒊'],
   ['\\mathbfit{j}', '𝒋'],
   ['\\mathbold{j}', '𝒋'],
   ['\\mathbfit{k}', '𝒌'],
   ['\\mathbold{k}', '𝒌'],
   ['\\mathbfit{l}', '𝒍'],
   ['\\mathbold{l}', '𝒍'],
   ['\\mathbfit{m}', '𝒎'],
   ['\\mathbold{m}', '𝒎'],
   ['\\mathbfit{n}', '𝒏'],
   ['\\mathbold{n}', '𝒏'],
   ['\\mathbfit{o}', '𝒐'],
   ['\\mathbold{o}', '𝒐'],
   ['\\mathbfit{p}', '𝒑'],
   ['\\mathbold{p}', '𝒑'],
   ['\\mathbfit{q}', '𝒒'],
   ['\\mathbold{q}', '𝒒'],
   ['\\mathbfit{r}', '𝒓'],
   ['\\mathbold{r}', '𝒓'],
   ['\\mathbfit{s}', '𝒔'],
   ['\\mathbold{s}', '𝒔'],
   ['\\mathbfit{t}', '𝒕'],
   ['\\mathbold{t}', '𝒕'],
   ['\\mathbfit{u}', '𝒖'],
   ['\\mathbold{u}', '𝒖'],
   ['\\mathbfit{v}', '𝒗'],
   ['\\mathbold{v}', '𝒗'],
   ['\\mathbfit{w}', '𝒘'],
   ['\\mathbold{w}', '𝒘'],
   ['\\mathbfit{x}', '𝒙'],
   ['\\mathbold{x}', '𝒙'],
   ['\\mathbfit{y}', '𝒚'],
   ['\\mathbold{y}', '𝒚'],
   ['\\mathbfit{z}', '𝒛'],
   ['\\mathbold{z}', '𝒛'],
   ['\\mathfrak{A}', '𝔄'],
   ['\\mathfrak{B}', '𝔅'],
   ['\\mathfrak{D}', '𝔇'],
   ['\\mathfrak{E}', '𝔈'],
   ['\\mathfrak{F}', '𝔉'],
   ['\\mathfrak{G}', '𝔊'],
   ['\\mathfrak{J}', '𝔍'],
   ['\\mathfrak{K}', '𝔎'],
   ['\\mathfrak{L}', '𝔏'],
   ['\\mathfrak{M}', '𝔐'],
   ['\\mathfrak{N}', '𝔑'],
   ['\\mathfrak{O}', '𝔒'],
   ['\\mathfrak{P}', '𝔓'],
   ['\\mathfrak{Q}', '𝔔'],
   ['\\mathfrak{S}', '𝔖'],
   ['\\mathfrak{T}', '𝔗'],
   ['\\mathfrak{U}', '𝔘'],
   ['\\mathfrak{V}', '𝔙'],
   ['\\mathfrak{W}', '𝔚'],
   ['\\mathfrak{X}', '𝔛'],
   ['\\mathfrak{Y}', '𝔜'],
   ['\\mathfrak{a}', '𝔞'],
   ['\\mathfrak{b}', '𝔟'],
   ['\\mathfrak{c}', '𝔠'],
   ['\\mathfrak{d}', '𝔡'],
   ['\\mathfrak{e}', '𝔢'],
   ['\\mathfrak{f}', '𝔣'],
   ['\\mathfrak{g}', '𝔤'],
   ['\\mathfrak{h}', '𝔥'],
   ['\\mathfrak{i}', '𝔦'],
   ['\\mathfrak{j}', '𝔧'],
   ['\\mathfrak{k}', '𝔨'],
   ['\\mathfrak{l}', '𝔩'],
   ['\\mathfrak{m}', '𝔪'],
   ['\\mathfrak{n}', '𝔫'],
   ['\\mathfrak{o}', '𝔬'],
   ['\\mathfrak{p}', '𝔭'],
   ['\\mathfrak{q}', '𝔮'],
   ['\\mathfrak{r}', '𝔯'],
   ['\\mathfrak{s}', '𝔰'],
   ['\\mathfrak{t}', '𝔱'],
   ['\\mathfrak{u}', '𝔲'],
   ['\\mathfrak{v}', '𝔳'],
   ['\\mathfrak{w}', '𝔴'],
   ['\\mathfrak{x}', '𝔵'],
   ['\\mathfrak{y}', '𝔶'],
   ['\\mathfrak{z}', '𝔷'],
   ['\\mathsfbf{A}', '𝗔'],
   ['\\mathsfbf{B}', '𝗕'],
   ['\\mathsfbf{C}', '𝗖'],
   ['\\mathsfbf{D}', '𝗗'],
   ['\\mathsfbf{E}', '𝗘'],
   ['\\mathsfbf{F}', '𝗙'],
   ['\\mathsfbf{G}', '𝗚'],
   ['\\mathsfbf{H}', '𝗛'],
   ['\\mathsfbf{I}', '𝗜'],
   ['\\mathsfbf{J}', '𝗝'],
   ['\\mathsfbf{K}', '𝗞'],
   ['\\mathsfbf{L}', '𝗟'],
   ['\\mathsfbf{M}', '𝗠'],
   ['\\mathsfbf{N}', '𝗡'],
   ['\\mathsfbf{O}', '𝗢'],
   ['\\mathsfbf{P}', '𝗣'],
   ['\\mathsfbf{Q}', '𝗤'],
   ['\\mathsfbf{R}', '𝗥'],
   ['\\mathsfbf{S}', '𝗦'],
   ['\\mathsfbf{T}', '𝗧'],
   ['\\mathsfbf{U}', '𝗨'],
   ['\\mathsfbf{V}', '𝗩'],
   ['\\mathsfbf{W}', '𝗪'],
   ['\\mathsfbf{X}', '𝗫'],
   ['\\mathsfbf{Y}', '𝗬'],
   ['\\mathsfbf{Z}', '𝗭'],
   ['\\mathsfbf{a}', '𝗮'],
   ['\\mathsfbf{b}', '𝗯'],
   ['\\mathsfbf{c}', '𝗰'],
   ['\\mathsfbf{d}', '𝗱'],
   ['\\mathsfbf{e}', '𝗲'],
   ['\\mathsfbf{f}', '𝗳'],
   ['\\mathsfbf{g}', '𝗴'],
   ['\\mathsfbf{h}', '𝗵'],
   ['\\mathsfbf{i}', '𝗶'],
   ['\\mathsfbf{j}', '𝗷'],
   ['\\mathsfbf{k}', '𝗸'],
   ['\\mathsfbf{l}', '𝗹'],
   ['\\mathsfbf{m}', '𝗺'],
   ['\\mathsfbf{n}', '𝗻'],
   ['\\mathsfbf{o}', '𝗼'],
   ['\\mathsfbf{p}', '𝗽'],
   ['\\mathsfbf{q}', '𝗾'],
   ['\\mathsfbf{r}', '𝗿'],
   ['\\mathsfbf{s}', '𝘀'],
   ['\\mathsfbf{t}', '𝘁'],
   ['\\mathsfbf{u}', '𝘂'],
   ['\\mathsfbf{v}', '𝘃'],
   ['\\mathsfbf{w}', '𝘄'],
   ['\\mathsfbf{x}', '𝘅'],
   ['\\mathsfbf{y}', '𝘆'],
   ['\\mathsfbf{z}', '𝘇'],
   ['\\mathsfit{A}', '𝘈'],
   ['\\mathsfit{B}', '𝘉'],
   ['\\mathsfit{C}', '𝘊'],
   ['\\mathsfit{D}', '𝘋'],
   ['\\mathsfit{E}', '𝘌'],
   ['\\mathsfit{F}', '𝘍'],
   ['\\mathsfit{G}', '𝘎'],
   ['\\mathsfit{H}', '𝘏'],
   ['\\mathsfit{I}', '𝘐'],
   ['\\mathsfit{J}', '𝘑'],
   ['\\mathsfit{K}', '𝘒'],
   ['\\mathsfit{L}', '𝘓'],
   ['\\mathsfit{M}', '𝘔'],
   ['\\mathsfit{N}', '𝘕'],
   ['\\mathsfit{O}', '𝘖'],
   ['\\mathsfit{P}', '𝘗'],
   ['\\mathsfit{Q}', '𝘘'],
   ['\\mathsfit{R}', '𝘙'],
   ['\\mathsfit{S}', '𝘚'],
   ['\\mathsfit{T}', '𝘛'],
   ['\\mathsfit{U}', '𝘜'],
   ['\\mathsfit{V}', '𝘝'],
   ['\\mathsfit{W}', '𝘞'],
   ['\\mathsfit{X}', '𝘟'],
   ['\\mathsfit{Y}', '𝘠'],
   ['\\mathsfit{Z}', '𝘡'],
   ['\\mathsfit{a}', '𝘢'],
   ['\\mathsfit{b}', '𝘣'],
   ['\\mathsfit{c}', '𝘤'],
   ['\\mathsfit{d}', '𝘥'],
   ['\\mathsfit{e}', '𝘦'],
   ['\\mathsfit{f}', '𝘧'],
   ['\\mathsfit{g}', '𝘨'],
   ['\\mathsfit{h}', '𝘩'],
   ['\\mathsfit{i}', '𝘪'],
   ['\\mathsfit{j}', '𝘫'],
   ['\\mathsfit{k}', '𝘬'],
   ['\\mathsfit{l}', '𝘭'],
   ['\\mathsfit{m}', '𝘮'],
   ['\\mathsfit{n}', '𝘯'],
   ['\\mathsfit{o}', '𝘰'],
   ['\\mathsfit{p}', '𝘱'],
   ['\\mathsfit{q}', '𝘲'],
   ['\\mathsfit{r}', '𝘳'],
   ['\\mathsfit{s}', '𝘴'],
   ['\\mathsfit{t}', '𝘵'],
   ['\\mathsfit{u}', '𝘶'],
   ['\\mathsfit{v}', '𝘷'],
   ['\\mathsfit{w}', '𝘸'],
   ['\\mathsfit{x}', '𝘹'],
   ['\\mathsfit{y}', '𝘺'],
   ['\\mathsfit{z}', '𝘻'],
   ['\\mathbf{\\Xi}', '𝚵'],
   ['\\mathbf{\\Pi}', '𝚷'],
   ['\\mbfvarTheta', '𝚹'],
   ['\\mathbf{\\mu}', '𝛍'],
   ['\\mathbf{\\nu}', '𝛎'],
   ['\\mathbf{\\xi}', '𝛏'],
   ['\\mathbf{\\pi}', '𝛑'],
   ['\\mbfvarsigma', '𝛓'],
   ['\\mbfvartheta', '𝛝'],
   ['\\mbfvarkappa', '𝛞'],
   ['\\mathit{\\Xi}', '𝛯'],
   ['\\mathit{\\Pi}', '𝛱'],
   ['\\mitvarTheta', '𝛳'],
   ['\\mathit{\\mu}', '𝜇'],
   ['\\mathit{\\nu}', '𝜈'],
   ['\\mathit{\\xi}', '𝜉'],
   ['\\mathit{\\pi}', '𝜋'],
   ['\\mitvarsigma', '𝜍'],
   ['\\mitvartheta', '𝜗'],
   ['\\mitvarkappa', '𝜘'],
   ['\\mbfitLambda', '𝜦'],
   ['\\mbfitlambda', '𝝀'],
   ['\\mbfitvarphi', '𝝓'],
   ['\\mbfitvarrho', '𝝔'],
   ['\\mbfsansBeta', '𝝗'],
   ['\\mbfsansZeta', '𝝛'],
   ['\\mbfsansIota', '𝝞'],
   ['\\mbfsansbeta', '𝝱'],
   ['\\mbfsanszeta', '𝝵'],
   ['\\mbfsansiota', '𝝸'],
   ['\\mbfitsansMu', '𝞛'],
   ['\\mbfitsansNu', '𝞜'],
   ['\\mbfitsansXi', '𝞝'],
   ['\\mbfitsansPi', '𝞟'],
   ['\\mbfitsansmu', '𝞵'],
   ['\\mbfitsansnu', '𝞶'],
   ['\\mbfitsansxi', '𝞷'],
   ['\\mbfitsanspi', '𝞹'],
   ['\\mathsfbf{0}', '𝟬'],
   ['\\mbfsanszero', '𝟬'],
   ['\\mathsfbf{1}', '𝟭'],
   ['\\mathsfbf{2}', '𝟮'],
   ['\\mathsfbf{3}', '𝟯'],
   ['\\mathsfbf{4}', '𝟰'],
   ['\\mbfsansfour', '𝟰'],
   ['\\mathsfbf{5}', '𝟱'],
   ['\\mbfsansfive', '𝟱'],
   ['\\mathsfbf{6}', '𝟲'],
   ['\\mathsfbf{7}', '𝟳'],
   ['\\mathsfbf{8}', '𝟴'],
   ['\\mathsfbf{9}', '𝟵'],
   ['\\mbfsansnine', '𝟵'],
   ['\\mathbb{Pi}', 'ℿ'],
   ['\\mathcal{M}', 'ℳ'],
   ['\\mathcal{o}', 'ℴ'],
   ['\\mathcal{O}', '𝒪'],
   ['\\nsupseteqq', '⊉'],
   ['\\mathcal{B}', 'ℬ'],
   ['\\textrecipe', '℞'],
   ['\\nsubseteqq', '⊈'],
   ['\\subsetneqq', '⊊'],
   ['\\mathcal{I}', 'ℑ'],
   ['\\upuparrows', '⇈'],
   ['\\mathcal{e}', 'ℯ'],
   ['\\mathcal{L}', 'ℒ'],
   ['\\nleftarrow', '↚'],
   ['\\mathcal{H}', 'ℋ'],
   ['\\mathcal{E}', 'ℰ'],
   ['\\eqslantgtr', '⋝'],
   ['\\curlywedge', '⋏'],
   ['\\varepsilon', 'ε'],
   ['\\supsetneqq', '⊋'],
   ['\\rightarrow', '→'],
   ['\\mathcal{R}', 'ℛ'],
   ['\\sqsubseteq', '⊑'],
   ['\\mathcal{g}', 'ℊ'],
   ['\\sqsupseteq', '⊒'],
   ['\\complement', '∁'],
   ['\\Rightarrow', '⇒'],
   ['\\gtreqqless', '⋛'],
   ['\\lesseqqgtr', '⋚'],
   ['\\circledast', '⊛'],
   ['\\nLeftarrow', '⇍'],
   ['\\Lleftarrow', '⇚'],
   ['\\varnothing', '∅'],
   ['\\mathcal{N}', '𝒩'],
   ['\\octothorpe', '#'],
   ['\\mathdollar', '$'],
   ['\\wideutilde', '̰'],
   ['\\upvarsigma', 'ς'],
   ['\\varsigmaup', 'ς'],
   ['\\upvartheta', 'ϑ'],
   ['\\varthetaup', 'ϑ'],
   ['\\upoldKoppa', 'Ϙ'],
   ['\\upoldkoppa', 'ϙ'],
   ['\\upvarkappa', 'ϰ'],
   ['\\upvarTheta', 'ϴ'],
   ['\\twolowline', '‗'],
   ['\\backdprime', '‶'],
   ['\\Eulerconst', 'ℇ'],
   ['\\turnediota', '℩'],
   ['\\mathcal{F}', 'ℱ'],
   ['\\EulerGamma', 'ℽ'],
   ['\\mappedfrom', '↤'],
   ['\\fourthroot', '∜'],
   ['\\rightangle', '∟'],
   ['\\Proportion', '∷'],
   ['\\SetDelayed', '≔'],
   ['\\smallfrown', '⌢'],
   ['\\smallsmile', '⌣'],
   ['\\conictaper', '⌲'],
   ['\\APLcomment', '⍝'],
   ['\\lparenuend', '⎛'],
   ['\\lparenlend', '⎝'],
   ['\\rparenuend', '⎞'],
   ['\\rparenlend', '⎠'],
   ['\\lbrackuend', '⎡'],
   ['\\lbracklend', '⎣'],
   ['\\rbrackuend', '⎤'],
   ['\\rbracklend', '⎦'],
   ['\\lbraceuend', '⎧'],
   ['\\lbracelend', '⎩'],
   ['\\rbraceuend', '⎫'],
   ['\\rbracelend', '⎭'],
   ['\\lmoustache', '⎰'],
   ['\\rmoustache', '⎱'],
   ['\\sqrtbottom', '⎷'],
   ['\\underparen', '⏝'],
   ['\\underbrace', '⏟'],
   ['\\hrectangle', '▭'],
   ['\\vrectangle', '▯'],
   ['\\LEFTcircle', '◐'],
   ['\\LEFTCIRCLE', '◖'],
   ['\\ultriangle', '◸'],
   ['\\urtriangle', '◹'],
   ['\\lltriangle', '◺'],
   ['\\lrtriangle', '◿'],
   ['\\CheckedBox', '☑'],
   ['\\Checkedbox', '☑'],
   ['\\Crossedbox', '☒'],
   ['\\pointright', '☞'],
   ['\\vardiamond', '♦'],
   ['\\eighthnote', '♪'],
   ['\\subsetcirc', '⟃'],
   ['\\supsetcirc', '⟄'],
   ['\\Diamonddot', '⟐'],
   ['\\DDownarrow', '⟱'],
   ['\\longmapsto', '⟼'],
   ['\\Longmapsto', '⟾'],
   ['\\Mappedfrom', '⤆'],
   ['\\Ddownarrow', '⤋'],
   ['\\UpArrowBar', '⤒'],
   ['\\baruparrow', '⤒'],
   ['\\rightimply', '⥰'],
   ['\\upfishtail', '⥾'],
   ['\\lbrackubar', '⦋'],
   ['\\rbrackubar', '⦌'],
   ['\\lparenless', '⦓'],
   ['\\Rparenless', '⦖'],
   ['\\lblkbrbrak', '⦗'],
   ['\\rblkbrbrak', '⦘'],
   ['\\circlehbar', '⦵'],
   ['\\circledgtr', '⧁'],
   ['\\doubleplus', '⧺'],
   ['\\tripleplus', '⧻'],
   ['\\plussubtwo', '⨧'],
   ['\\commaminus', '⨩'],
   ['\\minusfdots', '⨫'],
   ['\\minusrdots', '⨬'],
   ['\\opluslhrim', '⨭'],
   ['\\oplusrhrim', '⨮'],
   ['\\smashtimes', '⨳'],
   ['\\cupovercap', '⩆'],
   ['\\capovercup', '⩇'],
   ['\\veeonwedge', '⩙'],
   ['\\veemidvert', '⩛'],
   ['\\equivVvert', '⩩'],
   ['\\lessapprox', '⪅'],
   ['\\rightslice', '⪧'],
   ['\\precapprox', '⪷'],
   ['\\succapprox', '⪸'],
   ['\\subsetplus', '⪿'],
   ['\\supsetplus', '⫀'],
   ['\\interleave', '⫴'],
   ['\\talloblong', '⫾'],
   ['\\varhexagon', '⬡'],
   ['\\leftarrowx', '⬾'],
   ['\\LLeftarrow', '⭅'],
   ['\\postalmark', '〒'],
   ['\\mathcal{A}', '𝒜'],
   ['\\mathcal{C}', '𝒞'],
   ['\\mathcal{D}', '𝒟'],
   ['\\mathcal{G}', '𝒢'],
   ['\\mathcal{J}', '𝒥'],
   ['\\mathcal{K}', '𝒦'],
   ['\\mathcal{P}', '𝒫'],
   ['\\mathcal{Q}', '𝒬'],
   ['\\mathcal{S}', '𝒮'],
   ['\\mathcal{T}', '𝒯'],
   ['\\mathcal{U}', '𝒰'],
   ['\\mathcal{V}', '𝒱'],
   ['\\mathcal{W}', '𝒲'],
   ['\\mathcal{X}', '𝒳'],
   ['\\mathcal{Y}', '𝒴'],
   ['\\mathcal{Z}', '𝒵'],
   ['\\mathcal{a}', '𝒶'],
   ['\\mathcal{b}', '𝒷'],
   ['\\mathcal{c}', '𝒸'],
   ['\\mathcal{d}', '𝒹'],
   ['\\mathcal{f}', '𝒻'],
   ['\\mathcal{h}', '𝒽'],
   ['\\mathcal{i}', '𝒾'],
   ['\\mathcal{j}', '𝒿'],
   ['\\mathcal{k}', '𝓀'],
   ['\\mathcal{l}', '𝓁'],
   ['\\mathcal{m}', '𝓂'],
   ['\\mathcal{n}', '𝓃'],
   ['\\mathcal{p}', '𝓅'],
   ['\\mathcal{q}', '𝓆'],
   ['\\mathcal{r}', '𝓇'],
   ['\\mathcal{s}', '𝓈'],
   ['\\mathcal{t}', '𝓉'],
   ['\\mathcal{u}', '𝓊'],
   ['\\mathcal{v}', '𝓋'],
   ['\\mathcal{w}', '𝓌'],
   ['\\mathcal{x}', '𝓍'],
   ['\\mathcal{y}', '𝓎'],
   ['\\mathcal{z}', '𝓏'],
   ['\\mbfitsansA', '𝘼'],
   ['\\mbfitsansB', '𝘽'],
   ['\\mbfitsansC', '𝘾'],
   ['\\mbfitsansD', '𝘿'],
   ['\\mbfitsansE', '𝙀'],
   ['\\mbfitsansF', '𝙁'],
   ['\\mbfitsansG', '𝙂'],
   ['\\mbfitsansH', '𝙃'],
   ['\\mbfitsansI', '𝙄'],
   ['\\mbfitsansJ', '𝙅'],
   ['\\mbfitsansK', '𝙆'],
   ['\\mbfitsansL', '𝙇'],
   ['\\mbfitsansM', '𝙈'],
   ['\\mbfitsansN', '𝙉'],
   ['\\mbfitsansO', '𝙊'],
   ['\\mbfitsansP', '𝙋'],
   ['\\mbfitsansQ', '𝙌'],
   ['\\mbfitsansR', '𝙍'],
   ['\\mbfitsansS', '𝙎'],
   ['\\mbfitsansT', '𝙏'],
   ['\\mbfitsansU', '𝙐'],
   ['\\mbfitsansV', '𝙑'],
   ['\\mbfitsansW', '𝙒'],
   ['\\mbfitsansX', '𝙓'],
   ['\\mbfitsansY', '𝙔'],
   ['\\mbfitsansZ', '𝙕'],
   ['\\mbfitsansa', '𝙖'],
   ['\\mbfitsansb', '𝙗'],
   ['\\mbfitsansc', '𝙘'],
   ['\\mbfitsansd', '𝙙'],
   ['\\mbfitsanse', '𝙚'],
   ['\\mbfitsansf', '𝙛'],
   ['\\mbfitsansg', '𝙜'],
   ['\\mbfitsansh', '𝙝'],
   ['\\mbfitsansi', '𝙞'],
   ['\\mbfitsansj', '𝙟'],
   ['\\mbfitsansk', '𝙠'],
   ['\\mbfitsansl', '𝙡'],
   ['\\mbfitsansm', '𝙢'],
   ['\\mbfitsansn', '𝙣'],
   ['\\mbfitsanso', '𝙤'],
   ['\\mbfitsansp', '𝙥'],
   ['\\mbfitsansq', '𝙦'],
   ['\\mbfitsansr', '𝙧'],
   ['\\mbfitsanss', '𝙨'],
   ['\\mbfitsanst', '𝙩'],
   ['\\mbfitsansu', '𝙪'],
   ['\\mbfitsansv', '𝙫'],
   ['\\mbfitsansw', '𝙬'],
   ['\\mbfitsansx', '𝙭'],
   ['\\mbfitsansy', '𝙮'],
   ['\\mbfitsansz', '𝙯'],
   ['\\mbfEpsilon', '𝚬'],
   ['\\mbfOmicron', '𝚶'],
   ['\\mbfUpsilon', '𝚼'],
   ['\\mbfepsilon', '𝛆'],
   ['\\mbfomicron', '𝛐'],
   ['\\mbfupsilon', '𝛖'],
   ['\\mbfpartial', '𝛛'],
   ['\\mitEpsilon', '𝛦'],
   ['\\mitOmicron', '𝛰'],
   ['\\mitUpsilon', '𝛶'],
   ['\\varUpsilon', '𝛶'],
   ['\\mitepsilon', '𝜀'],
   ['\\mitomicron', '𝜊'],
   ['\\mitupsilon', '𝜐'],
   ['\\mitpartial', '𝜕'],
   ['\\mbfitAlpha', '𝜜'],
   ['\\mbfitGamma', '𝜞'],
   ['\\mbfitDelta', '𝜟'],
   ['\\mbfitTheta', '𝜣'],
   ['\\mbfitKappa', '𝜥'],
   ['\\mbfitSigma', '𝜮'],
   ['\\mbfitOmega', '𝜴'],
   ['\\mbfitnabla', '𝜵'],
   ['\\mbfitalpha', '𝜶'],
   ['\\mbfitgamma', '𝜸'],
   ['\\mbfitdelta', '𝜹'],
   ['\\mbfittheta', '𝜽'],
   ['\\mbfitkappa', '𝜿'],
   ['\\mbfitsigma', '𝝈'],
   ['\\mbfitomega', '𝝎'],
   ['\\mbfitvarpi', '𝝕'],
   ['\\mbfsansEta', '𝝜'],
   ['\\mbfsansRho', '𝝦'],
   ['\\mbfsansTau', '𝝩'],
   ['\\mbfsansPhi', '𝝫'],
   ['\\mbfsansChi', '𝝬'],
   ['\\mbfsansPsi', '𝝭'],
   ['\\mbfsanseta', '𝝶'],
   ['\\mbfsansrho', '𝞀'],
   ['\\mbfsanstau', '𝞃'],
   ['\\mbfsansphi', '𝞅'],
   ['\\mbfsanschi', '𝞆'],
   ['\\mbfsanspsi', '𝞇'],
   ['\\mbfDigamma', '𝟊'],
   ['\\mbfdigamma', '𝟋'],
   ['\\msansthree', '𝟥'],
   ['\\msansseven', '𝟩'],
   ['\\msanseight', '𝟪'],
   ['\\mbfsansone', '𝟭'],
   ['\\mbfsanstwo', '𝟮'],
   ['\\mbfsanssix', '𝟲'],
   ['\\Leftarrow', '⇐'],
   ['\\gvertneqq', '≩'],
   ['\\mathbb{C}', 'ℂ'],
   ['\\supsetneq', '⊋'],
   ['\\leftarrow', '←'],
   ['\\nleqslant', '≰'],
   ['\\mathbb{Q}', 'ℚ'],
   ['\\mathbb{Z}', 'ℤ'],
   ['\\llbracket', '〚'],
   ['\\mathbb{H}', 'ℍ'],
   ['\\spadesuit', '♠'],
   ['\\mathbb{P}', 'ℙ'],
   ['\\rrbracket', '〛'],
   ['\\supseteqq', '⊇'],
   ['\\copyright', '©'],
   ['\\textsc{k}', 'ĸ'],
   ['\\gtreqless', '⋛'],
   ['\\mathbb{j}', 'ⅉ'],
   ['\\pitchfork', '⋔'],
   ['\\estimated', '℮'],
   ['\\ngeqslant', '≱'],
   ['\\mathbb{e}', 'ⅇ'],
   ['\\therefore', '∴'],
   ['\\triangleq', '≜'],
   ['\\varpropto', '∝'],
   ['\\subsetneq', '⊊'],
   ['\\heartsuit', '♥'],
   ['\\mathbb{d}', 'ⅆ'],
   ['\\lvertneqq', '≨'],
   ['\\checkmark', '✓'],
   ['\\nparallel', '∦'],
   ['\\mathbb{R}', 'ℝ'],
   ['\\lesseqgtr', '⋚'],
   ['\\downarrow', '↓'],
   ['\\mathbb{D}', 'ⅅ'],
   ['\\mathbb{i}', 'ⅈ'],
   ['\\backsimeq', '⋍'],
   ['\\mathbb{N}', 'ℕ'],
   ['\\Downarrow', '⇓'],
   ['\\subseteqq', '⊆'],
   ['\\ampersand', '&'],
   ['\\mathslash', '/'],
   ['\\mathcolon', ':'],
   ['\\semicolon', ';'],
   ['\\mathrm{A}', 'A'],
   ['\\mathrm{B}', 'B'],
   ['\\mathrm{C}', 'C'],
   ['\\mathrm{D}', 'D'],
   ['\\mathrm{E}', 'E'],
   ['\\mathrm{F}', 'F'],
   ['\\mathrm{G}', 'G'],
   ['\\mathrm{H}', 'H'],
   ['\\mathrm{I}', 'I'],
   ['\\mathrm{J}', 'J'],
   ['\\mathrm{K}', 'K'],
   ['\\mathrm{L}', 'L'],
   ['\\mathrm{M}', 'M'],
   ['\\mathrm{N}', 'N'],
   ['\\mathrm{O}', 'O'],
   ['\\mathrm{P}', 'P'],
   ['\\mathrm{Q}', 'Q'],
   ['\\mathrm{R}', 'R'],
   ['\\mathrm{S}', 'S'],
   ['\\mathrm{T}', 'T'],
   ['\\mathrm{U}', 'U'],
   ['\\mathrm{V}', 'V'],
   ['\\mathrm{W}', 'W'],
   ['\\mathrm{X}', 'X'],
   ['\\mathrm{Y}', 'Y'],
   ['\\mathrm{Z}', 'Z'],
   ['\\backslash', '\\'],
   ['\\mathrm{a}', 'a'],
   ['\\mathrm{b}', 'b'],
   ['\\mathrm{c}', 'c'],
   ['\\mathrm{d}', 'd'],
   ['\\mathrm{e}', 'e'],
   ['\\mathrm{f}', 'f'],
   ['\\mathrm{g}', 'g'],
   ['\\mathrm{h}', 'h'],
   ['\\mathrm{i}', 'i'],
   ['\\mathrm{j}', 'j'],
   ['\\mathrm{k}', 'k'],
   ['\\mathrm{l}', 'l'],
   ['\\mathrm{m}', 'm'],
   ['\\mathrm{n}', 'n'],
   ['\\mathrm{o}', 'o'],
   ['\\mathrm{p}', 'p'],
   ['\\mathrm{q}', 'q'],
   ['\\mathrm{r}', 'r'],
   ['\\mathrm{s}', 's'],
   ['\\mathrm{t}', 't'],
   ['\\mathrm{u}', 'u'],
   ['\\mathrm{v}', 'v'],
   ['\\mathrm{w}', 'w'],
   ['\\mathrm{x}', 'x'],
   ['\\mathrm{y}', 'y'],
   ['\\mathrm{z}', 'z'],
   ['\\widetilde', '̃'],
   ['\\upEpsilon', 'Ε'],
   ['\\upOmicron', 'Ο'],
   ['\\upUpsilon', 'Υ'],
   ['\\upepsilon', 'ε'],
   ['\\upomicron', 'ο'],
   ['\\upupsilon', 'υ'],
   ['\\upsilonup', 'υ'],
   ['\\upvarbeta', 'ϐ'],
   ['\\upDigamma', 'Ϝ'],
   ['\\updigamma', 'ϝ'],
   ['\\epsilonup', 'ϵ'],
   ['\\backprime', '‵'],
   ['\\tieconcat', '⁀'],
   ['\\fracslash', '⁄'],
   ['\\mathds{C}', 'ℂ'],
   ['\\mathds{H}', 'ℍ'],
   ['\\mathds{N}', 'ℕ'],
   ['\\mathds{P}', 'ℙ'],
   ['\\mathds{Q}', 'ℚ'],
   ['\\mathds{R}', 'ℝ'],
   ['\\mathds{Z}', 'ℤ'],
   ['\\Angstroem', 'Å'],
   ['\\lightning', '↯'],
   ['\\Lightning', '↯'],
   ['\\rightturn', '↻'],
   ['\\nHuparrow', '⇞'],
   ['\\dasharrow', '⇢'],
   ['\\partialup', '∂'],
   ['\\increment', '∆'],
   ['\\clockoint', '∲'],
   ['\\mathratio', '∶'],
   ['\\dashcolon', '∹'],
   ['\\LessTilde', '≲'],
   ['\\nsubseteq', '⊈'],
   ['\\nsupseteq', '⊉'],
   ['\\varniobar', '⋽'],
   ['\\bagmember', '⋿'],
   ['\\sqlozenge', '⌑'],
   ['\\turnednot', '⌙'],
   ['\\intbottom', '⌡'],
   ['\\lbracemid', '⎨'],
   ['\\rbracemid', '⎬'],
   ['\\sumbottom', '⎳'],
   ['\\lvboxline', '⎸'],
   ['\\rvboxline', '⎹'],
   ['\\overparen', '⏜'],
   ['\\wideparen', '⏜'],
   ['\\overbrace', '⏞'],
   ['\\trapezium', '⏢'],
   ['\\accurrent', '⏦'],
   ['\\blockfull', '█'],
   ['\\radiation', '☢'],
   ['\\biohazard', '☣'],
   ['\\smileface', '☺'],
   ['\\rightmoon', '☽'],
   ['\\medbullet', '⚫'],
   ['\\DashVDash', '⟚'],
   ['\\dashVdash', '⟛'],
   ['\\vlongdash', '⟝'],
   ['\\longdashv', '⟞'],
   ['\\impliedby', '⟸'],
   ['\\righttail', '⤚'],
   ['\\nwsearrow', '⤡'],
   ['\\neswarrow', '⤢'],
   ['\\hknwarrow', '⤣'],
   ['\\hknearrow', '⤤'],
   ['\\typecolon', '⦂'],
   ['\\langledot', '⦑'],
   ['\\rangledot', '⦒'],
   ['\\rparengtr', '⦔'],
   ['\\Lparengtr', '⦕'],
   ['\\fourvdots', '⦙'],
   ['\\turnangle', '⦢'],
   ['\\angleubar', '⦤'],
   ['\\olessthan', '⧀'],
   ['\\boxbslash', '⧅'],
   ['\\boxcircle', '⧇'],
   ['\\triangles', '⧌'],
   ['\\hourglass', '⧖'],
   ['\\bigotimes', '⨂'],
   ['\\bigcupdot', '⨃'],
   ['\\conjquant', '⨇'],
   ['\\disjquant', '⨈'],
   ['\\modtwosum', '⨊'],
   ['\\otimeshat', '⨶'],
   ['\\cupbarcap', '⩈'],
   ['\\capbarcup', '⩉'],
   ['\\wedgeodot', '⩑'],
   ['\\midbarvee', '⩝'],
   ['\\varveebar', '⩡'],
   ['\\equivVert', '⩨'],
   ['\\hatapprox', '⩯'],
   ['\\approxeqq', '⩰'],
   ['\\gtrapprox', '⪆'],
   ['\\leftslice', '⪦'],
   ['\\subsetdot', '⪽'],
   ['\\supsetdot', '⪾'],
   ['\\leqqslant', '⫹'],
   ['\\geqqslant', '⫺'],
   ['\\centerdot', '⬝'],
   ['\\Squaredot', '⬝'],
   ['\\mathbf{A}', '𝐀'],
   ['\\mathbf{B}', '𝐁'],
   ['\\mathbf{C}', '𝐂'],
   ['\\mathbf{D}', '𝐃'],
   ['\\mathbf{E}', '𝐄'],
   ['\\mathbf{F}', '𝐅'],
   ['\\mathbf{G}', '𝐆'],
   ['\\mathbf{H}', '𝐇'],
   ['\\mathbf{I}', '𝐈'],
   ['\\mathbf{J}', '𝐉'],
   ['\\mathbf{K}', '𝐊'],
   ['\\mathbf{L}', '𝐋'],
   ['\\mathbf{M}', '𝐌'],
   ['\\mathbf{N}', '𝐍'],
   ['\\mathbf{O}', '𝐎'],
   ['\\mathbf{P}', '𝐏'],
   ['\\mathbf{Q}', '𝐐'],
   ['\\mathbf{R}', '𝐑'],
   ['\\mathbf{S}', '𝐒'],
   ['\\mathbf{T}', '𝐓'],
   ['\\mathbf{U}', '𝐔'],
   ['\\mathbf{V}', '𝐕'],
   ['\\mathbf{W}', '𝐖'],
   ['\\mathbf{X}', '𝐗'],
   ['\\mathbf{Y}', '𝐘'],
   ['\\mathbf{Z}', '𝐙'],
   ['\\mathbf{a}', '𝐚'],
   ['\\mathbf{b}', '𝐛'],
   ['\\mathbf{c}', '𝐜'],
   ['\\mathbf{d}', '𝐝'],
   ['\\mathbf{e}', '𝐞'],
   ['\\mathbf{f}', '𝐟'],
   ['\\mathbf{g}', '𝐠'],
   ['\\mathbf{h}', '𝐡'],
   ['\\mathbf{i}', '𝐢'],
   ['\\mathbf{j}', '𝐣'],
   ['\\mathbf{k}', '𝐤'],
   ['\\mathbf{l}', '𝐥'],
   ['\\mathbf{m}', '𝐦'],
   ['\\mathbf{n}', '𝐧'],
   ['\\mathbf{o}', '𝐨'],
   ['\\mathbf{p}', '𝐩'],
   ['\\mathbf{q}', '𝐪'],
   ['\\mathbf{r}', '𝐫'],
   ['\\mathbf{s}', '𝐬'],
   ['\\mathbf{t}', '𝐭'],
   ['\\mathbf{u}', '𝐮'],
   ['\\mathbf{v}', '𝐯'],
   ['\\mathbf{w}', '𝐰'],
   ['\\mathbf{x}', '𝐱'],
   ['\\mathbf{y}', '𝐲'],
   ['\\mathbf{z}', '𝐳'],
   ['\\mathit{A}', '𝐴'],
   ['\\mathit{B}', '𝐵'],
   ['\\mathit{C}', '𝐶'],
   ['\\mathit{D}', '𝐷'],
   ['\\mathit{E}', '𝐸'],
   ['\\mathit{F}', '𝐹'],
   ['\\mathit{G}', '𝐺'],
   ['\\mathit{H}', '𝐻'],
   ['\\mathit{I}', '𝐼'],
   ['\\mathit{J}', '𝐽'],
   ['\\mathit{K}', '𝐾'],
   ['\\mathit{L}', '𝐿'],
   ['\\mathit{M}', '𝑀'],
   ['\\mathit{N}', '𝑁'],
   ['\\mathit{O}', '𝑂'],
   ['\\mathit{P}', '𝑃'],
   ['\\mathit{Q}', '𝑄'],
   ['\\mathit{R}', '𝑅'],
   ['\\mathit{S}', '𝑆'],
   ['\\mathit{T}', '𝑇'],
   ['\\mathit{U}', '𝑈'],
   ['\\mathit{V}', '𝑉'],
   ['\\mathit{W}', '𝑊'],
   ['\\mathit{X}', '𝑋'],
   ['\\mathit{Y}', '𝑌'],
   ['\\mathit{Z}', '𝑍'],
   ['\\mathit{a}', '𝑎'],
   ['\\mathit{b}', '𝑏'],
   ['\\mathit{c}', '𝑐'],
   ['\\mathit{d}', '𝑑'],
   ['\\mathit{e}', '𝑒'],
   ['\\mathit{f}', '𝑓'],
   ['\\mathit{g}', '𝑔'],
   ['\\mathit{i}', '𝑖'],
   ['\\mathit{j}', '𝑗'],
   ['\\mathit{k}', '𝑘'],
   ['\\mathit{l}', '𝑙'],
   ['\\mathit{m}', '𝑚'],
   ['\\mathit{n}', '𝑛'],
   ['\\mathit{o}', '𝑜'],
   ['\\mathit{p}', '𝑝'],
   ['\\mathit{q}', '𝑞'],
   ['\\mathit{r}', '𝑟'],
   ['\\mathit{s}', '𝑠'],
   ['\\mathit{t}', '𝑡'],
   ['\\mathit{u}', '𝑢'],
   ['\\mathit{v}', '𝑣'],
   ['\\mathit{w}', '𝑤'],
   ['\\mathit{x}', '𝑥'],
   ['\\mathit{y}', '𝑦'],
   ['\\mathit{z}', '𝑧'],
   ['\\mathbb{A}', '𝔸'],
   ['\\mathds{A}', '𝔸'],
   ['\\mathbb{B}', '𝔹'],
   ['\\mathds{B}', '𝔹'],
   ['\\mathds{D}', '𝔻'],
   ['\\mathbb{E}', '𝔼'],
   ['\\mathds{E}', '𝔼'],
   ['\\mathbb{F}', '𝔽'],
   ['\\mathds{F}', '𝔽'],
   ['\\mathbb{G}', '𝔾'],
   ['\\mathds{G}', '𝔾'],
   ['\\mathbb{I}', '𝕀'],
   ['\\mathds{I}', '𝕀'],
   ['\\mathbb{J}', '𝕁'],
   ['\\mathds{J}', '𝕁'],
   ['\\mathbb{K}', '𝕂'],
   ['\\mathds{K}', '𝕂'],
   ['\\mathbb{L}', '𝕃'],
   ['\\mathds{L}', '𝕃'],
   ['\\mathbb{M}', '𝕄'],
   ['\\mathds{M}', '𝕄'],
   ['\\mathbb{O}', '𝕆'],
   ['\\mathds{O}', '𝕆'],
   ['\\mathbb{S}', '𝕊'],
   ['\\mathds{S}', '𝕊'],
   ['\\mathbb{T}', '𝕋'],
   ['\\mathds{T}', '𝕋'],
   ['\\mathbb{U}', '𝕌'],
   ['\\mathds{U}', '𝕌'],
   ['\\mathbb{V}', '𝕍'],
   ['\\mathds{V}', '𝕍'],
   ['\\mathbb{W}', '𝕎'],
   ['\\mathds{W}', '𝕎'],
   ['\\mathbb{X}', '𝕏'],
   ['\\mathds{X}', '𝕏'],
   ['\\mathbb{Y}', '𝕐'],
   ['\\mathds{Y}', '𝕐'],
   ['\\mathbb{a}', '𝕒'],
   ['\\mathbb{b}', '𝕓'],
   ['\\mathbb{c}', '𝕔'],
   ['\\mathbb{f}', '𝕗'],
   ['\\mathbb{g}', '𝕘'],
   ['\\mathbb{h}', '𝕙'],
   ['\\mathbb{k}', '𝕜'],
   ['\\mathbb{l}', '𝕝'],
   ['\\mathbb{m}', '𝕞'],
   ['\\mathbb{n}', '𝕟'],
   ['\\mathbb{o}', '𝕠'],
   ['\\mathbb{p}', '𝕡'],
   ['\\mathbb{q}', '𝕢'],
   ['\\mathbb{r}', '𝕣'],
   ['\\mathbb{s}', '𝕤'],
   ['\\mathbb{t}', '𝕥'],
   ['\\mathbb{u}', '𝕦'],
   ['\\mathbb{v}', '𝕧'],
   ['\\mathbb{w}', '𝕨'],
   ['\\mathbb{x}', '𝕩'],
   ['\\mathbb{y}', '𝕪'],
   ['\\mathbb{z}', '𝕫'],
   ['\\mathsf{A}', '𝖠'],
   ['\\mathsf{B}', '𝖡'],
   ['\\mathsf{C}', '𝖢'],
   ['\\mathsf{D}', '𝖣'],
   ['\\mathsf{E}', '𝖤'],
   ['\\mathsf{F}', '𝖥'],
   ['\\mathsf{G}', '𝖦'],
   ['\\mathsf{H}', '𝖧'],
   ['\\mathsf{I}', '𝖨'],
   ['\\mathsf{J}', '𝖩'],
   ['\\mathsf{K}', '𝖪'],
   ['\\mathsf{L}', '𝖫'],
   ['\\mathsf{M}', '𝖬'],
   ['\\mathsf{N}', '𝖭'],
   ['\\mathsf{O}', '𝖮'],
   ['\\mathsf{P}', '𝖯'],
   ['\\mathsf{Q}', '𝖰'],
   ['\\mathsf{R}', '𝖱'],
   ['\\mathsf{S}', '𝖲'],
   ['\\mathsf{T}', '𝖳'],
   ['\\mathsf{U}', '𝖴'],
   ['\\mathsf{V}', '𝖵'],
   ['\\mathsf{W}', '𝖶'],
   ['\\mathsf{X}', '𝖷'],
   ['\\mathsf{Y}', '𝖸'],
   ['\\mathsf{Z}', '𝖹'],
   ['\\mathsf{a}', '𝖺'],
   ['\\mathsf{b}', '𝖻'],
   ['\\mathsf{c}', '𝖼'],
   ['\\mathsf{d}', '𝖽'],
   ['\\mathsf{e}', '𝖾'],
   ['\\mathsf{f}', '𝖿'],
   ['\\mathsf{g}', '𝗀'],
   ['\\mathsf{h}', '𝗁'],
   ['\\mathsf{i}', '𝗂'],
   ['\\mathsf{j}', '𝗃'],
   ['\\mathsf{k}', '𝗄'],
   ['\\mathsf{l}', '𝗅'],
   ['\\mathsf{m}', '𝗆'],
   ['\\mathsf{n}', '𝗇'],
   ['\\mathsf{o}', '𝗈'],
   ['\\mathsf{p}', '𝗉'],
   ['\\mathsf{q}', '𝗊'],
   ['\\mathsf{r}', '𝗋'],
   ['\\mathsf{s}', '𝗌'],
   ['\\mathsf{t}', '𝗍'],
   ['\\mathsf{u}', '𝗎'],
   ['\\mathsf{v}', '𝗏'],
   ['\\mathsf{w}', '𝗐'],
   ['\\mathsf{x}', '𝗑'],
   ['\\mathsf{y}', '𝗒'],
   ['\\mathsf{z}', '𝗓'],
   ['\\mathtt{A}', '𝙰'],
   ['\\mathtt{B}', '𝙱'],
   ['\\mathtt{C}', '𝙲'],
   ['\\mathtt{D}', '𝙳'],
   ['\\mathtt{E}', '𝙴'],
   ['\\mathtt{F}', '𝙵'],
   ['\\mathtt{G}', '𝙶'],
   ['\\mathtt{H}', '𝙷'],
   ['\\mathtt{I}', '𝙸'],
   ['\\mathtt{J}', '𝙹'],
   ['\\mathtt{K}', '𝙺'],
   ['\\mathtt{L}', '𝙻'],
   ['\\mathtt{M}', '𝙼'],
   ['\\mathtt{N}', '𝙽'],
   ['\\mathtt{O}', '𝙾'],
   ['\\mathtt{P}', '𝙿'],
   ['\\mathtt{Q}', '𝚀'],
   ['\\mathtt{R}', '𝚁'],
   ['\\mathtt{S}', '𝚂'],
   ['\\mathtt{T}', '𝚃'],
   ['\\mathtt{U}', '𝚄'],
   ['\\mathtt{V}', '𝚅'],
   ['\\mathtt{W}', '𝚆'],
   ['\\mathtt{X}', '𝚇'],
   ['\\mathtt{Y}', '𝚈'],
   ['\\mathtt{Z}', '𝚉'],
   ['\\mathtt{a}', '𝚊'],
   ['\\mathtt{b}', '𝚋'],
   ['\\mathtt{c}', '𝚌'],
   ['\\mathtt{d}', '𝚍'],
   ['\\mathtt{e}', '𝚎'],
   ['\\mathtt{f}', '𝚏'],
   ['\\mathtt{g}', '𝚐'],
   ['\\mathtt{h}', '𝚑'],
   ['\\mathtt{i}', '𝚒'],
   ['\\mathtt{j}', '𝚓'],
   ['\\mathtt{k}', '𝚔'],
   ['\\mathtt{l}', '𝚕'],
   ['\\mathtt{m}', '𝚖'],
   ['\\mathtt{n}', '𝚗'],
   ['\\mathtt{o}', '𝚘'],
   ['\\mathtt{p}', '𝚙'],
   ['\\mathtt{q}', '𝚚'],
   ['\\mathtt{r}', '𝚛'],
   ['\\mathtt{s}', '𝚜'],
   ['\\mathtt{t}', '𝚝'],
   ['\\mathtt{u}', '𝚞'],
   ['\\mathtt{v}', '𝚟'],
   ['\\mathtt{w}', '𝚠'],
   ['\\mathtt{x}', '𝚡'],
   ['\\mathtt{y}', '𝚢'],
   ['\\mathtt{z}', '𝚣'],
   ['\\mbfLambda', '𝚲'],
   ['\\mbflambda', '𝛌'],
   ['\\mbfvarphi', '𝛗'],
   ['\\mbfvarrho', '𝛠'],
   ['\\mitLambda', '𝛬'],
   ['\\varLambda', '𝛬'],
   ['\\mitlambda', '𝜆'],
   ['\\mitvarphi', '𝜙'],
   ['\\mitvarrho', '𝜚'],
   ['\\mbfitBeta', '𝜝'],
   ['\\mbfitZeta', '𝜡'],
   ['\\mbfitIota', '𝜤'],
   ['\\mbfitbeta', '𝜷'],
   ['\\mbfitzeta', '𝜻'],
   ['\\mbfitiota', '𝜾'],
   ['\\mbfsansMu', '𝝡'],
   ['\\mbfsansNu', '𝝢'],
   ['\\mbfsansXi', '𝝣'],
   ['\\mbfsansPi', '𝝥'],
   ['\\mbfsansmu', '𝝻'],
   ['\\mbfsansnu', '𝝼'],
   ['\\mbfsansxi', '𝝽'],
   ['\\mbfsanspi', '𝝿'],
   ['\\mathbf{0}', '𝟎'],
   ['\\mathbf{1}', '𝟏'],
   ['\\mathbf{2}', '𝟐'],
   ['\\mathbf{3}', '𝟑'],
   ['\\mathbf{4}', '𝟒'],
   ['\\mathbf{5}', '𝟓'],
   ['\\mathbf{6}', '𝟔'],
   ['\\mathbf{7}', '𝟕'],
   ['\\mathbf{8}', '𝟖'],
   ['\\mathbf{9}', '𝟗'],
   ['\\mathbb{0}', '𝟘'],
   ['\\mathbb{1}', '𝟙'],
   ['\\mathds{1}', '𝟙'],
   ['\\mathbb{2}', '𝟚'],
   ['\\mathbb{3}', '𝟛'],
   ['\\mathbb{4}', '𝟜'],
   ['\\mathbb{5}', '𝟝'],
   ['\\mathbb{6}', '𝟞'],
   ['\\mathbb{7}', '𝟟'],
   ['\\mathbb{8}', '𝟠'],
   ['\\mathbb{9}', '𝟡'],
   ['\\mathsf{0}', '𝟢'],
   ['\\msanszero', '𝟢'],
   ['\\mathsf{1}', '𝟣'],
   ['\\mathsf{2}', '𝟤'],
   ['\\mathsf{3}', '𝟥'],
   ['\\mathsf{4}', '𝟦'],
   ['\\msansfour', '𝟦'],
   ['\\mathsf{5}', '𝟧'],
   ['\\msansfive', '𝟧'],
   ['\\mathsf{6}', '𝟨'],
   ['\\mathsf{7}', '𝟩'],
   ['\\mathsf{8}', '𝟪'],
   ['\\mathsf{9}', '𝟫'],
   ['\\msansnine', '𝟫'],
   ['\\mathtt{0}', '𝟶'],
   ['\\mathtt{1}', '𝟷'],
   ['\\mathtt{2}', '𝟸'],
   ['\\mathtt{3}', '𝟹'],
   ['\\mathtt{4}', '𝟺'],
   ['\\mathtt{5}', '𝟻'],
   ['\\mathtt{6}', '𝟼'],
   ['\\mathtt{7}', '𝟽'],
   ['\\mathtt{8}', '𝟾'],
   ['\\mathtt{9}', '𝟿'],
   ['\\setminus', '∖'],
   ['\\succnsim', '⋩'],
   ['\\doteqdot', '≑'],
   ['\\clubsuit', '♣'],
   ['\\emptyset', '∅'],
   ['\\sqsupset', '⊐'],
   ['\\fbox{~~}', '▭'],
   ['\\curlyvee', '⋎'],
   ['\\varkappa', 'ϰ'],
   ['\\llcorner', '⌞'],
   ['\\varsigma', 'ς'],
   ['\\approxeq', '≊'],
   ['\\backcong', '≌'],
   ['\\supseteq', '⊇'],
   ['\\circledS', 'Ⓢ'],
   ['\\circledR', '®'],
   ['\\textcent', '¢'],
   ['\\urcorner', '⌝'],
   ['\\lrcorner', '⌟'],
   ['\\boxminus', '⊟'],
   ['\\texteuro', '€'],
   ['\\vartheta', 'ϑ'],
   ['\\barwedge', '⊼'],
   ['\\ding{86}', '✶'],
   ['\\sqsubset', '⊏'],
   ['\\subseteq', '⊆'],
   ['\\intercal', '⊺'],
   ['\\ding{73}', '☆'],
   ['\\ulcorner', '⌜'],
   ['\\recorder', '⌕'],
   ['\\precnsim', '⋨'],
   ['\\parallel', '∥'],
   ['\\boxtimes', '⊠'],
   ['\\ding{55}', '✗'],
   ['\\multimap', '⊸'],
   ['\\question', '?'],
   ['\\mathcent', '¢'],
   ['\\sterling', '£'],
   ['\\currency', '¤'],
   ['\\mathring', '̊'],
   ['\\underbar', '̱'],
   ['\\upLambda', 'Λ'],
   ['\\uplambda', 'λ'],
   ['\\lambdaup', 'λ'],
   ['\\upvarphi', 'φ'],
   ['\\varphiup', 'φ'],
   ['\\upStigma', 'Ϛ'],
   ['\\upstigma', 'ϛ'],
   ['\\upvarrho', 'ϱ'],
   ['\\varrhoup', 'ϱ'],
   ['\\varTheta', 'ϴ'],
   ['\\horizbar', '―'],
   ['\\Question', '⁇'],
   ['\\medspace', ' '],
   ['\\Angstrom', 'Å'],
   ['\\DoublePi', 'ℼ'],
   ['\\Bbbgamma', 'ℽ'],
   ['\\BbbGamma', 'ℾ'],
   ['\\ComplexI', 'ⅈ'],
   ['\\ComplexJ', 'ⅉ'],
   ['\\mapsfrom', '↤'],
   ['\\MapsDown', '↧'],
   ['\\mapsdown', '↧'],
   ['\\linefeed', '↴'],
   ['\\leftturn', '↺'],
   ['\\notowner', '∌'],
   ['\\divslash', '∕'],
   ['\\cuberoot', '∛'],
   ['\\dotminus', '∸'],
   ['\\invlazys', '∾'],
   ['\\sinewave', '∿'],
   ['\\dotequal', '≐'],
   ['\\coloneqq', '≔'],
   ['\\eqqcolon', '≕'],
   ['\\notasymp', '≭'],
   ['\\nlesssim', '≴'],
   ['\\nlessgtr', '≸'],
   ['\\ngtrless', '≹'],
   ['\\bigwedge', '⋀'],
   ['\\varisins', '⋳'],
   ['\\isinobar', '⋷'],
   ['\\diameter', '⌀'],
   ['\\profline', '⌒'],
   ['\\profsurf', '⌓'],
   ['\\viewdata', '⌗'],
   ['\\notslash', '⌿'],
   ['\\APLinput', '⍞'],
   ['\\bbrktbrk', '⎶'],
   ['\\elinters', '⏧'],
   ['\\triangle', '△'],
   ['\\bullseye', '◎'],
   ['\\astrosun', '☉'],
   ['\\steaming', '☕'],
   ['\\leftmoon', '☾'],
   ['\\varEarth', '♁'],
   ['\\aquarius', '♒'],
   ['\\varspade', '♤'],
   ['\\varheart', '♥'],
   ['\\twonotes', '♫'],
   ['\\acidfree', '♾'],
   ['\\bsolhsub', '⟈'],
   ['\\wedgedot', '⟑'],
   ['\\pullback', '⟓'],
   ['\\UUparrow', '⟰'],
   ['\\Mapsfrom', '⤆'],
   ['\\Uuparrow', '⤊'],
   ['\\drbkarow', '⤐'],
   ['\\lefttail', '⤙'],
   ['\\hksearow', '⤥'],
   ['\\hkswarow', '⤦'],
   ['\\strictfi', '⥼'],
   ['\\strictif', '⥽'],
   ['\\revangle', '⦣'],
   ['\\boxslash', '⧄'],
   ['\\boxonbox', '⧉'],
   ['\\rtriltri', '⧎'],
   ['\\lfbowtie', '⧑'],
   ['\\rfbowtie', '⧒'],
   ['\\lvzigzag', '⧘'],
   ['\\rvzigzag', '⧙'],
   ['\\Lvzigzag', '⧚'],
   ['\\Rvzigzag', '⧛'],
   ['\\tieinfty', '⧝'],
   ['\\smeparsl', '⧤'],
   ['\\eqvparsl', '⧥'],
   ['\\bigoplus', '⨁'],
   ['\\biguplus', '⨄'],
   ['\\bigsqcap', '⨅'],
   ['\\bigsqcup', '⨆'],
   ['\\bigtimes', '⨉'],
   ['\\cirfnint', '⨐'],
   ['\\rppolint', '⨒'],
   ['\\scpolint', '⨓'],
   ['\\pointint', '⨕'],
   ['\\intlarhk', '⨗'],
   ['\\zproject', '⨡'],
   ['\\ringplus', '⨢'],
   ['\\plustrif', '⨨'],
   ['\\minusdot', '⨪'],
   ['\\vectimes', '⨯'],
   ['\\dottimes', '⨰'],
   ['\\timesbar', '⨱'],
   ['\\intprodr', '⨽'],
   ['\\capwedge', '⩄'],
   ['\\veeonvee', '⩖'],
   ['\\wedgebar', '⩟'],
   ['\\dotequiv', '⩧'],
   ['\\simrdots', '⩫'],
   ['\\Coloneqq', '⩴'],
   ['\\leqslant', '⩽'],
   ['\\geqslant', '⩾'],
   ['\\lesdotor', '⪃'],
   ['\\gesdotol', '⪄'],
   ['\\lnapprox', '⪉'],
   ['\\gnapprox', '⪊'],
   ['\\precneqq', '⪵'],
   ['\\succneqq', '⪶'],
   ['\\forksnot', '⫝'],
   ['\\varVdash', '⫦'],
   ['\\pentagon', '⬠'],
   ['\\mbffrakA', '𝕬'],
   ['\\mbffrakB', '𝕭'],
   ['\\mbffrakC', '𝕮'],
   ['\\mbffrakD', '𝕯'],
   ['\\mbffrakE', '𝕰'],
   ['\\mbffrakF', '𝕱'],
   ['\\mbffrakG', '𝕲'],
   ['\\mbffrakH', '𝕳'],
   ['\\mbffrakI', '𝕴'],
   ['\\mbffrakJ', '𝕵'],
   ['\\mbffrakK', '𝕶'],
   ['\\mbffrakL', '𝕷'],
   ['\\mbffrakM', '𝕸'],
   ['\\mbffrakN', '𝕹'],
   ['\\mbffrakO', '𝕺'],
   ['\\mbffrakP', '𝕻'],
   ['\\mbffrakQ', '𝕼'],
   ['\\mbffrakR', '𝕽'],
   ['\\mbffrakS', '𝕾'],
   ['\\mbffrakT', '𝕿'],
   ['\\mbffrakU', '𝖀'],
   ['\\mbffrakV', '𝖁'],
   ['\\mbffrakW', '𝖂'],
   ['\\mbffrakX', '𝖃'],
   ['\\mbffrakY', '𝖄'],
   ['\\mbffrakZ', '𝖅'],
   ['\\mbffraka', '𝖆'],
   ['\\mbffrakb', '𝖇'],
   ['\\mbffrakc', '𝖈'],
   ['\\mbffrakd', '𝖉'],
   ['\\mbffrake', '𝖊'],
   ['\\mbffrakf', '𝖋'],
   ['\\mbffrakg', '𝖌'],
   ['\\mbffrakh', '𝖍'],
   ['\\mbffraki', '𝖎'],
   ['\\mbffrakj', '𝖏'],
   ['\\mbffrakk', '𝖐'],
   ['\\mbffrakl', '𝖑'],
   ['\\mbffrakm', '𝖒'],
   ['\\mbffrakn', '𝖓'],
   ['\\mbffrako', '𝖔'],
   ['\\mbffrakp', '𝖕'],
   ['\\mbffrakq', '𝖖'],
   ['\\mbffrakr', '𝖗'],
   ['\\mbffraks', '𝖘'],
   ['\\mbffrakt', '𝖙'],
   ['\\mbffraku', '𝖚'],
   ['\\mbffrakv', '𝖛'],
   ['\\mbffrakw', '𝖜'],
   ['\\mbffrakx', '𝖝'],
   ['\\mbffraky', '𝖞'],
   ['\\mbffrakz', '𝖟'],
   ['\\mbfsansA', '𝗔'],
   ['\\mbfsansB', '𝗕'],
   ['\\mbfsansC', '𝗖'],
   ['\\mbfsansD', '𝗗'],
   ['\\mbfsansE', '𝗘'],
   ['\\mbfsansF', '𝗙'],
   ['\\mbfsansG', '𝗚'],
   ['\\mbfsansH', '𝗛'],
   ['\\mbfsansI', '𝗜'],
   ['\\mbfsansJ', '𝗝'],
   ['\\mbfsansK', '𝗞'],
   ['\\mbfsansL', '𝗟'],
   ['\\mbfsansM', '𝗠'],
   ['\\mbfsansN', '𝗡'],
   ['\\mbfsansO', '𝗢'],
   ['\\mbfsansP', '𝗣'],
   ['\\mbfsansQ', '𝗤'],
   ['\\mbfsansR', '𝗥'],
   ['\\mbfsansS', '𝗦'],
   ['\\mbfsansT', '𝗧'],
   ['\\mbfsansU', '𝗨'],
   ['\\mbfsansV', '𝗩'],
   ['\\mbfsansW', '𝗪'],
   ['\\mbfsansX', '𝗫'],
   ['\\mbfsansY', '𝗬'],
   ['\\mbfsansZ', '𝗭'],
   ['\\mbfsansa', '𝗮'],
   ['\\mbfsansb', '𝗯'],
   ['\\mbfsansc', '𝗰'],
   ['\\mbfsansd', '𝗱'],
   ['\\mbfsanse', '𝗲'],
   ['\\mbfsansf', '𝗳'],
   ['\\mbfsansg', '𝗴'],
   ['\\mbfsansh', '𝗵'],
   ['\\mbfsansi', '𝗶'],
   ['\\mbfsansj', '𝗷'],
   ['\\mbfsansk', '𝗸'],
   ['\\mbfsansl', '𝗹'],
   ['\\mbfsansm', '𝗺'],
   ['\\mbfsansn', '𝗻'],
   ['\\mbfsanso', '𝗼'],
   ['\\mbfsansp', '𝗽'],
   ['\\mbfsansq', '𝗾'],
   ['\\mbfsansr', '𝗿'],
   ['\\mbfsanss', '𝘀'],
   ['\\mbfsanst', '𝘁'],
   ['\\mbfsansu', '𝘂'],
   ['\\mbfsansv', '𝘃'],
   ['\\mbfsansw', '𝘄'],
   ['\\mbfsansx', '𝘅'],
   ['\\mbfsansy', '𝘆'],
   ['\\mbfsansz', '𝘇'],
   ['\\mitsansA', '𝘈'],
   ['\\mitsansB', '𝘉'],
   ['\\mitsansC', '𝘊'],
   ['\\mitsansD', '𝘋'],
   ['\\mitsansE', '𝘌'],
   ['\\mitsansF', '𝘍'],
   ['\\mitsansG', '𝘎'],
   ['\\mitsansH', '𝘏'],
   ['\\mitsansI', '𝘐'],
   ['\\mitsansJ', '𝘑'],
   ['\\mitsansK', '𝘒'],
   ['\\mitsansL', '𝘓'],
   ['\\mitsansM', '𝘔'],
   ['\\mitsansN', '𝘕'],
   ['\\mitsansO', '𝘖'],
   ['\\mitsansP', '𝘗'],
   ['\\mitsansQ', '𝘘'],
   ['\\mitsansR', '𝘙'],
   ['\\mitsansS', '𝘚'],
   ['\\mitsansT', '𝘛'],
   ['\\mitsansU', '𝘜'],
   ['\\mitsansV', '𝘝'],
   ['\\mitsansW', '𝘞'],
   ['\\mitsansX', '𝘟'],
   ['\\mitsansY', '𝘠'],
   ['\\mitsansZ', '𝘡'],
   ['\\mitsansa', '𝘢'],
   ['\\mitsansb', '𝘣'],
   ['\\mitsansc', '𝘤'],
   ['\\mitsansd', '𝘥'],
   ['\\mitsanse', '𝘦'],
   ['\\mitsansf', '𝘧'],
   ['\\mitsansg', '𝘨'],
   ['\\mitsansh', '𝘩'],
   ['\\mitsansi', '𝘪'],
   ['\\mitsansj', '𝘫'],
   ['\\mitsansk', '𝘬'],
   ['\\mitsansl', '𝘭'],
   ['\\mitsansm', '𝘮'],
   ['\\mitsansn', '𝘯'],
   ['\\mitsanso', '𝘰'],
   ['\\mitsansp', '𝘱'],
   ['\\mitsansq', '𝘲'],
   ['\\mitsansr', '𝘳'],
   ['\\mitsanss', '𝘴'],
   ['\\mitsanst', '𝘵'],
   ['\\mitsansu', '𝘶'],
   ['\\mitsansv', '𝘷'],
   ['\\mitsansw', '𝘸'],
   ['\\mitsansx', '𝘹'],
   ['\\mitsansy', '𝘺'],
   ['\\mitsansz', '𝘻'],
   ['\\mbfAlpha', '𝚨'],
   ['\\mbfGamma', '𝚪'],
   ['\\mbfDelta', '𝚫'],
   ['\\mbfTheta', '𝚯'],
   ['\\mbfKappa', '𝚱'],
   ['\\mbfSigma', '𝚺'],
   ['\\mbfOmega', '𝛀'],
   ['\\mbfnabla', '𝛁'],
   ['\\mbfalpha', '𝛂'],
   ['\\mbfgamma', '𝛄'],
   ['\\mbfdelta', '𝛅'],
   ['\\mbftheta', '𝛉'],
   ['\\mbfkappa', '𝛋'],
   ['\\mbfsigma', '𝛔'],
   ['\\mbfomega', '𝛚'],
   ['\\mbfvarpi', '𝛡'],
   ['\\mitAlpha', '𝛢'],
   ['\\mitGamma', '𝛤'],
   ['\\varGamma', '𝛤'],
   ['\\mitDelta', '𝛥'],
   ['\\varDelta', '𝛥'],
   ['\\mitTheta', '𝛩'],
   ['\\mitKappa', '𝛫'],
   ['\\mitSigma', '𝛴'],
   ['\\varSigma', '𝛴'],
   ['\\mitOmega', '𝛺'],
   ['\\varOmega', '𝛺'],
   ['\\mitnabla', '𝛻'],
   ['\\mitalpha', '𝛼'],
   ['\\mitgamma', '𝛾'],
   ['\\mitdelta', '𝛿'],
   ['\\mittheta', '𝜃'],
   ['\\mitkappa', '𝜅'],
   ['\\mitsigma', '𝜎'],
   ['\\mitomega', '𝜔'],
   ['\\mitvarpi', '𝜛'],
   ['\\mbfitEta', '𝜢'],
   ['\\mbfitRho', '𝜬'],
   ['\\mbfitTau', '𝜯'],
   ['\\mbfitPhi', '𝜱'],
   ['\\mbfitChi', '𝜲'],
   ['\\mbfitPsi', '𝜳'],
   ['\\mbfiteta', '𝜼'],
   ['\\mbfitrho', '𝝆'],
   ['\\mbfittau', '𝝉'],
   ['\\mbfitphi', '𝝋'],
   ['\\mbfitchi', '𝝌'],
   ['\\mbfitpsi', '𝝍'],
   ['\\Bbbthree', '𝟛'],
   ['\\Bbbseven', '𝟟'],
   ['\\Bbbeight', '𝟠'],
   ['\\msansone', '𝟣'],
   ['\\msanstwo', '𝟤'],
   ['\\msanssix', '𝟨'],
   ['\\mttthree', '𝟹'],
   ['\\mttseven', '𝟽'],
   ['\\mtteight', '𝟾'],
   ['\\maltese', '✠'],
   ['\\nearrow', '↗'],
   ['\\swarrow', '↙'],
   ['\\lozenge', '◊'],
   ['\\sqrt[3]', '∛'],
   ['\\succsim', '≿'],
   ['\\dotplus', '∔'],
   ['\\tilde{}', '~'],
   ['\\check{}', 'ˇ'],
   ['\\lessgtr', '≶'],
   ['\\Upsilon', 'ϒ'],
   ['\\Cdprime', 'Ъ'],
   ['\\gtrless', '≷'],
   ['\\backsim', '∽'],
   ['\\nexists', '∄'],
   ['\\searrow', '↘'],
   ['\\lessdot', '⋖'],
   ['\\boxplus', '⊞'],
   ['\\upsilon', 'υ'],
   ['\\epsilon', 'ε'],
   ['\\diamond', '⋄'],
   ['\\bigstar', '★'],
   ['\\ddagger', '‡'],
   ['\\cdprime', 'ъ'],
   ['\\Uparrow', '⇑'],
   ['\\sqrt[4]', '∜'],
   ['\\between', '≬'],
   ['\\sqangle', '∟'],
   ['\\digamma', 'Ϝ'],
   ['\\uparrow', '↑'],
   ['\\nwarrow', '↖'],
   ['\\precsim', '≾'],
   ['\\breve{}', '˘'],
   ['\\because', '∵'],
   ['\\bigcirc', '◯'],
   ['\\acute{}', '´'],
   ['\\grave{}', '`'],
   ['\\lesssim', '≲'],
   ['\\partial', '∂'],
   ['\\natural', '♮'],
   ['\\percent', '%'],
   ['\\greater', '>'],
   ['\\sptilde', '~'],
   ['\\matheth', 'ð'],
   ['\\widehat', '̂'],
   ['\\overbar', '̅'],
   ['\\upAlpha', 'Α'],
   ['\\upGamma', 'Γ'],
   ['\\upDelta', 'Δ'],
   ['\\upTheta', 'Θ'],
   ['\\upKappa', 'Κ'],
   ['\\upSigma', 'Σ'],
   ['\\upOmega', 'Ω'],
   ['\\upalpha', 'α'],
   ['\\alphaup', 'α'],
   ['\\upgamma', 'γ'],
   ['\\gammaup', 'γ'],
   ['\\updelta', 'δ'],
   ['\\deltaup', 'δ'],
   ['\\uptheta', 'θ'],
   ['\\thetaup', 'θ'],
   ['\\upkappa', 'κ'],
   ['\\kappaup', 'κ'],
   ['\\upsigma', 'σ'],
   ['\\sigmaup', 'σ'],
   ['\\upomega', 'ω'],
   ['\\omegaup', 'ω'],
   ['\\varbeta', 'ϐ'],
   ['\\upvarpi', 'ϖ'],
   ['\\varpiup', 'ϖ'],
   ['\\Digamma', 'Ϝ'],
   ['\\upKoppa', 'Ϟ'],
   ['\\upkoppa', 'ϟ'],
   ['\\upSampi', 'Ϡ'],
   ['\\upsampi', 'ϡ'],
   ['\\trprime', '‴'],
   ['\\closure', '⁐'],
   ['\\annuity', '⃧'],
   ['\\mitBbbD', 'ⅅ'],
   ['\\mitBbbd', 'ⅆ'],
   ['\\mitBbbe', 'ⅇ'],
   ['\\mitBbbi', 'ⅈ'],
   ['\\mitBbbj', 'ⅉ'],
   ['\\Nwarrow', '⇖'],
   ['\\Nearrow', '⇗'],
   ['\\Searrow', '⇘'],
   ['\\Swarrow', '⇙'],
   ['\\smallin', '∊'],
   ['\\notowns', '∌'],
   ['\\smallni', '∍'],
   ['\\dbloint', '∯'],
   ['\\eqcolon', '∹'],
   ['\\simneqq', '≆'],
   ['\\napprox', '≉'],
   ['\\coloneq', '≔'],
   ['\\varsdef', '≜'],
   ['\\questeq', '≟'],
   ['\\ngtrsim', '≵'],
   ['\\nsubset', '⊄'],
   ['\\nsupset', '⊅'],
   ['\\imageof', '⊷'],
   ['\\lrtimes', '⋈'],
   ['\\npreceq', '⋠'],
   ['\\nsucceq', '⋡'],
   ['\\isindot', '⋵'],
   ['\\hexagon', '⎔'],
   ['\\obrbrak', '⏠'],
   ['\\ubrbrak', '⏡'],
   ['\\benzenr', '⏣'],
   ['\\squoval', '▢'],
   ['\\Diamond', '◇'],
   ['\\fisheye', '◉'],
   ['\\yinyang', '☯'],
   ['\\frownie', '☹'],
   ['\\sadface', '☹'],
   ['\\mercury', '☿'],
   ['\\Mercury', '☿'],
   ['\\jupiter', '♃'],
   ['\\Jupiter', '♃'],
   ['\\neptune', '♆'],
   ['\\Neptune', '♆'],
   ['\\scorpio', '♏'],
   ['\\Scorpio', '♏'],
   ['\\varclub', '♧'],
   ['\\recycle', '♻'],
   ['\\diceiii', '⚂'],
   ['\\warning', '⚠'],
   ['\\medcirc', '⚪'],
   ['\\ballotx', '✗'],
   ['\\varstar', '✶'],
   ['\\lbrbrak', '❲'],
   ['\\rbrbrak', '❳'],
   ['\\suphsol', '⟉'],
   ['\\pushout', '⟔'],
   ['\\Lbrbrak', '⟬'],
   ['\\Rbrbrak', '⟭'],
   ['\\implies', '⟹'],
   ['\\dbkarow', '⤏'],
   ['\\leadsto', '⤳'],
   ['\\subrarr', '⥹'],
   ['\\suplarr', '⥻'],
   ['\\llangle', '⦉'],
   ['\\rrangle', '⦊'],
   ['\\vzigzag', '⦚'],
   ['\\obslash', '⦸'],
   ['\\olcross', '⦻'],
   ['\\cirscir', '⧂'],
   ['\\boxdiag', '⧄'],
   ['\\fbowtie', '⧓'],
   ['\\lftimes', '⧔'],
   ['\\rftimes', '⧕'],
   ['\\nvinfty', '⧞'],
   ['\\dualmap', '⧟'],
   ['\\shuffle', '⧢'],
   ['\\thermod', '⧧'],
   ['\\rsolbar', '⧷'],
   ['\\bigodot', '⨀'],
   ['\\varprod', '⨉'],
   ['\\npolint', '⨔'],
   ['\\fatsemi', '⨟'],
   ['\\project', '⨡'],
   ['\\plushat', '⨣'],
   ['\\simplus', '⨤'],
   ['\\plusdot', '⨥'],
   ['\\plussim', '⨦'],
   ['\\intprod', '⨼'],
   ['\\twocups', '⩊'],
   ['\\twocaps', '⩋'],
   ['\\veeodot', '⩒'],
   ['\\congdot', '⩭'],
   ['\\eqqplus', '⩱'],
   ['\\pluseqq', '⩲'],
   ['\\Coloneq', '⩴'],
   ['\\ddotseq', '⩷'],
   ['\\equivDD', '⩸'],
   ['\\ltquest', '⩻'],
   ['\\gtquest', '⩼'],
   ['\\lesdoto', '⪁'],
   ['\\gesdoto', '⪂'],
   ['\\eqqless', '⪙'],
   ['\\simless', '⪝'],
   ['\\bumpeqq', '⪮'],
   ['\\precneq', '⪱'],
   ['\\succneq', '⪲'],
   ['\\preceqq', '⪳'],
   ['\\succeqq', '⪴'],
   ['\\llcurly', '⪻'],
   ['\\ggcurly', '⪼'],
   ['\\submult', '⫁'],
   ['\\supmult', '⫂'],
   ['\\subedot', '⫃'],
   ['\\supedot', '⫄'],
   ['\\lsqhook', '⫍'],
   ['\\rsqhook', '⫎'],
   ['\\suphsub', '⫗'],
   ['\\supdsub', '⫘'],
   ['\\topfork', '⫚'],
   ['\\revnmid', '⫮'],
   ['\\nhVvert', '⫵'],
   ['\\lllnest', '⫷'],
   ['\\gggnest', '⫸'],
   ['\\trslash', '⫻'],
   ['\\hzigzag', '〰'],
   ['\\mbfscrA', '𝓐'],
   ['\\mbfscrB', '𝓑'],
   ['\\mbfscrC', '𝓒'],
   ['\\mbfscrD', '𝓓'],
   ['\\mbfscrE', '𝓔'],
   ['\\mbfscrF', '𝓕'],
   ['\\mbfscrG', '𝓖'],
   ['\\mbfscrH', '𝓗'],
   ['\\mbfscrI', '𝓘'],
   ['\\mbfscrJ', '𝓙'],
   ['\\mbfscrK', '𝓚'],
   ['\\mbfscrL', '𝓛'],
   ['\\mbfscrM', '𝓜'],
   ['\\mbfscrN', '𝓝'],
   ['\\mbfscrO', '𝓞'],
   ['\\mbfscrP', '𝓟'],
   ['\\mbfscrQ', '𝓠'],
   ['\\mbfscrR', '𝓡'],
   ['\\mbfscrS', '𝓢'],
   ['\\mbfscrT', '𝓣'],
   ['\\mbfscrU', '𝓤'],
   ['\\mbfscrV', '𝓥'],
   ['\\mbfscrW', '𝓦'],
   ['\\mbfscrX', '𝓧'],
   ['\\mbfscrY', '𝓨'],
   ['\\mbfscrZ', '𝓩'],
   ['\\mbfscra', '𝓪'],
   ['\\mbfscrb', '𝓫'],
   ['\\mbfscrc', '𝓬'],
   ['\\mbfscrd', '𝓭'],
   ['\\mbfscre', '𝓮'],
   ['\\mbfscrf', '𝓯'],
   ['\\mbfscrg', '𝓰'],
   ['\\mbfscrh', '𝓱'],
   ['\\mbfscri', '𝓲'],
   ['\\mbfscrj', '𝓳'],
   ['\\mbfscrk', '𝓴'],
   ['\\mbfscrl', '𝓵'],
   ['\\mbfscrm', '𝓶'],
   ['\\mbfscrn', '𝓷'],
   ['\\mbfscro', '𝓸'],
   ['\\mbfscrp', '𝓹'],
   ['\\mbfscrq', '𝓺'],
   ['\\mbfscrr', '𝓻'],
   ['\\mbfscrs', '𝓼'],
   ['\\mbfscrt', '𝓽'],
   ['\\mbfscru', '𝓾'],
   ['\\mbfscrv', '𝓿'],
   ['\\mbfscrw', '𝔀'],
   ['\\mbfscrx', '𝔁'],
   ['\\mbfscry', '𝔂'],
   ['\\mbfscrz', '𝔃'],
   ['\\mbfBeta', '𝚩'],
   ['\\mbfZeta', '𝚭'],
   ['\\mbfIota', '𝚰'],
   ['\\mbfbeta', '𝛃'],
   ['\\mbfzeta', '𝛇'],
   ['\\mbfiota', '𝛊'],
   ['\\mitBeta', '𝛣'],
   ['\\mitZeta', '𝛧'],
   ['\\mitIota', '𝛪'],
   ['\\mitbeta', '𝛽'],
   ['\\mitzeta', '𝜁'],
   ['\\mitiota', '𝜄'],
   ['\\mbfitMu', '𝜧'],
   ['\\mbfitNu', '𝜨'],
   ['\\mbfitXi', '𝜩'],
   ['\\mbfitPi', '𝜫'],
   ['\\mbfitmu', '𝝁'],
   ['\\mbfitnu', '𝝂'],
   ['\\mbfitxi', '𝝃'],
   ['\\mbfitpi', '𝝅'],
   ['\\Bbbzero', '𝟘'],
   ['\\Bbbfour', '𝟜'],
   ['\\Bbbfive', '𝟝'],
   ['\\Bbbnine', '𝟡'],
   ['\\mttzero', '𝟶'],
   ['\\mttfour', '𝟺'],
   ['\\mttfive', '𝟻'],
   ['\\mttnine', '𝟿'],
   ['\\supset', '⊃'],
   ['\\hstrok', 'ħ'],
   ['\\Tstrok', 'Ŧ'],
   ['\\coprod', '∐'],
   ['\\models', '⊧'],
   ['\\otimes', '⊗'],
   ['\\degree', '°'],
   ['\\gtrdot', '⋗'],
   ['\\preceq', '≼'],
   ['\\Lambda', 'Λ'],
   ['\\lambda', 'λ'],
   ['\\cprime', 'ь'],
   ['\\varrho', 'ϱ'],
   ['\\Bumpeq', '≎'],
   ['\\hybull', '⁃'],
   ['\\lmidot', 'ŀ'],
   ['\\nvdash', '⊬'],
   ['\\lbrace', '{'],
   ['\\bullet', '•'],
   ['\\varphi', 'φ'],
   ['\\bumpeq', '≏'],
   ['\\ddot{}', '¨'],
   ['\\Lmidot', 'Ŀ'],
   ['\\Cprime', 'Ь'],
   ['\\female', '♀'],
   ['\\rtimes', '⋊'],
   ['\\gtrsim', '≳'],
   ['\\mapsto', '↦'],
   ['\\daleth', 'ℸ'],
   ['\\square', '■'],
   ['\\nVDash', '⊯'],
   ['\\rangle', '〉'],
   ['\\tstrok', 'ŧ'],
   ['\\oslash', '⊘'],
   ['\\ltimes', '⋉'],
   ['\\lfloor', '⌊'],
   ['\\marker', '▮'],
   ['\\Subset', '⋐'],
   ['\\Vvdash', '⊪'],
   ['\\propto', '∝'],
   ['\\Hstrok', 'Ħ'],
   ['\\dlcrop', '⌍'],
   ['\\forall', '∀'],
   ['\\nVdash', '⊮'],
   ['\\Supset', '⋑'],
   ['\\langle', '〈'],
   ['\\ominus', '⊖'],
   ['\\rfloor', '⌋'],
   ['\\circeq', '≗'],
   ['\\eqcirc', '≖'],
   ['\\drcrop', '⌌'],
   ['\\veebar', '⊻'],
   ['\\ulcrop', '⌏'],
   ['\\nvDash', '⊭'],
   ['\\urcrop', '⌎'],
   ['\\exists', '∃'],
   ['\\approx', '≈'],
   ['\\dagger', '†'],
   ['\\boxdot', '⊡'],
   ['\\succeq', '≽'],
   ['\\bowtie', '⋈'],
   ['\\subset', '⊂'],
   ['\\exclam', '!'],
   ['\\lparen', '('],
   ['\\rparen', ')'],
   ['\\period', '.'],
   ['\\atsign', '@'],
   ['\\lbrack', '('],
   ['\\rbrack', ')'],
   ['\\rbrace', '}'],
   ['\\pounds', '£'],
   ['\\spddot', '¨'],
   ['\\textmu', 'µ'],
   ['\\ovhook', '̉'],
   ['\\candra', '̐'],
   ['\\droang', '̚'],
   ['\\utilde', '̰'],
   ['\\upBeta', 'Β'],
   ['\\upZeta', 'Ζ'],
   ['\\upIota', 'Ι'],
   ['\\upbeta', 'β'],
   ['\\betaup', 'β'],
   ['\\upzeta', 'ζ'],
   ['\\zetaup', 'ζ'],
   ['\\upiota', 'ι'],
   ['\\iotaup', 'ι'],
   ['\\Stigma', 'Ϛ'],
   ['\\stigma', 'ϛ'],
   ['\\CYRSHA', 'Ш'],
   ['\\second', '″'],
   ['\\dprime', '″'],
   ['\\Exclam', '‼'],
   ['\\fourth', '⁗'],
   ['\\qprime', '⁗'],
   ['\\ddddot', '⃜'],
   ['\\mfrakH', 'ℌ'],
   ['\\hslash', 'ℏ'],
   ['\\mfrakZ', 'ℨ'],
   ['\\mfrakC', 'ℭ'],
   ['\\Bbbsum', '⅀'],
   ['\\invamp', '⅋'],
   ['\\MapsUp', '↥'],
   ['\\mapsup', '↥'],
   ['\\oiiint', '∰'],
   ['\\nsimeq', '≄'],
   ['\\wedgeq', '≙'],
   ['\\stareq', '≛'],
   ['\\measeq', '≞'],
   ['\\nequiv', '≢'],
   ['\\nasymp', '≭'],
   ['\\apprle', '≲'],
   ['\\apprge', '≳'],
   ['\\cupdot', '⊍'],
   ['\\assert', '⊦'],
   ['\\prurel', '⊰'],
   ['\\scurel', '⊱'],
   ['\\origof', '⊶'],
   ['\\barvee', '⊽'],
   ['\\bigvee', '⋁'],
   ['\\bigcap', '⋂'],
   ['\\dinter', '⋂'],
   ['\\bigcup', '⋃'],
   ['\\dunion', '⋃'],
   ['\\eqless', '⋜'],
   ['\\nunlhd', '⋬'],
   ['\\nunrhd', '⋭'],
   ['\\iddots', '⋰'],
   ['\\isinvb', '⋸'],
   ['\\varnis', '⋻'],
   ['\\niobar', '⋾'],
   ['\\invneg', '⌐'],
   ['\\invnot', '⌐'],
   ['\\inttop', '⌠'],
   ['\\topbot', '⌶'],
   ['\\APLinv', '⌹'],
   ['\\APLlog', '⍟'],
   ['\\sumtop', '⎲'],
   ['\\Circle', '○'],
   ['\\CIRCLE', '●'],
   ['\\boxbar', '◫'],
   ['\\Square', '☐'],
   ['\\danger', '☡'],
   ['\\smiley', '☺'],
   ['\\saturn', '♄'],
   ['\\Saturn', '♄'],
   ['\\uranus', '♅'],
   ['\\Uranus', '♅'],
   ['\\taurus', '♉'],
   ['\\Taurus', '♉'],
   ['\\gemini', '♊'],
   ['\\Gemini', '♊'],
   ['\\cancer', '♋'],
   ['\\pisces', '♓'],
   ['\\diceii', '⚁'],
   ['\\diceiv', '⚃'],
   ['\\dicevi', '⚅'],
   ['\\anchor', '⚓'],
   ['\\swords', '⚔'],
   ['\\neuter', '⚲'],
   ['\\pencil', '✎'],
   ['\\veedot', '⟇'],
   ['\\bigbot', '⟘'],
   ['\\bigtop', '⟙'],
   ['\\cirbot', '⟟'],
   ['\\lBrack', '⟦'],
   ['\\Lbrack', '⟦'],
   ['\\rBrack', '⟧'],
   ['\\Rbrack', '⟧'],
   ['\\lAngle', '⟪'],
   ['\\rAngle', '⟫'],
   ['\\lgroup', '⟮'],
   ['\\rgroup', '⟯'],
   ['\\Mapsto', '⤇'],
   ['\\ltlarr', '⥶'],
   ['\\gtrarr', '⥸'],
   ['\\lBrace', '⦃'],
   ['\\rBrace', '⦄'],
   ['\\Lparen', '⦅'],
   ['\\lParen', '⦅'],
   ['\\Rparen', '⦆'],
   ['\\rParen', '⦆'],
   ['\\angles', '⦞'],
   ['\\angdnr', '⦟'],
   ['\\gtlpar', '⦠'],
   ['\\boxast', '⧆'],
   ['\\boxbox', '⧈'],
   ['\\ltrivb', '⧏'],
   ['\\vbrtri', '⧐'],
   ['\\iinfin', '⧜'],
   ['\\laplac', '⧠'],
   ['\\eparsl', '⧣'],
   ['\\tminus', '⧿'],
   ['\\sumint', '⨋'],
   ['\\iiiint', '⨌'],
   ['\\intbar', '⨍'],
   ['\\intBar', '⨎'],
   ['\\sqrint', '⨖'],
   ['\\intcap', '⨙'],
   ['\\intcup', '⨚'],
   ['\\lowint', '⨜'],
   ['\\btimes', '⨲'],
   ['\\Otimes', '⨷'],
   ['\\capdot', '⩀'],
   ['\\uminus', '⩁'],
   ['\\barcup', '⩂'],
   ['\\barcap', '⩃'],
   ['\\cupvee', '⩅'],
   ['\\dotsim', '⩪'],
   ['\\eqqsim', '⩳'],
   ['\\eqeqeq', '⩶'],
   ['\\lesdot', '⩿'],
   ['\\gesdot', '⪀'],
   ['\\lesges', '⪓'],
   ['\\gesles', '⪔'],
   ['\\elsdot', '⪗'],
   ['\\egsdot', '⪘'],
   ['\\eqqgtr', '⪚'],
   ['\\simgtr', '⪞'],
   ['\\subsim', '⫇'],
   ['\\supsim', '⫈'],
   ['\\subsup', '⫓'],
   ['\\supsub', '⫔'],
   ['\\subsub', '⫕'],
   ['\\supsup', '⫖'],
   ['\\vDdash', '⫢'],
   ['\\cirmid', '⫯'],
   ['\\midcir', '⫰'],
   ['\\topcir', '⫱'],
   ['\\parsim', '⫳'],
   ['\\sslash', '⫽'],
   ['\\mbfitA', '𝑨'],
   ['\\mbfitB', '𝑩'],
   ['\\mbfitC', '𝑪'],
   ['\\mbfitD', '𝑫'],
   ['\\mbfitE', '𝑬'],
   ['\\mbfitF', '𝑭'],
   ['\\mbfitG', '𝑮'],
   ['\\mbfitH', '𝑯'],
   ['\\mbfitI', '𝑰'],
   ['\\mbfitJ', '𝑱'],
   ['\\mbfitK', '𝑲'],
   ['\\mbfitL', '𝑳'],
   ['\\mbfitM', '𝑴'],
   ['\\mbfitN', '𝑵'],
   ['\\mbfitO', '𝑶'],
   ['\\mbfitP', '𝑷'],
   ['\\mbfitQ', '𝑸'],
   ['\\mbfitR', '𝑹'],
   ['\\mbfitS', '𝑺'],
   ['\\mbfitT', '𝑻'],
   ['\\mbfitU', '𝑼'],
   ['\\mbfitV', '𝑽'],
   ['\\mbfitW', '𝑾'],
   ['\\mbfitX', '𝑿'],
   ['\\mbfitY', '𝒀'],
   ['\\mbfitZ', '𝒁'],
   ['\\mbfita', '𝒂'],
   ['\\mbfitb', '𝒃'],
   ['\\mbfitc', '𝒄'],
   ['\\mbfitd', '𝒅'],
   ['\\mbfite', '𝒆'],
   ['\\mbfitf', '𝒇'],
   ['\\mbfitg', '𝒈'],
   ['\\mbfith', '𝒉'],
   ['\\mbfiti', '𝒊'],
   ['\\mbfitj', '𝒋'],
   ['\\mbfitk', '𝒌'],
   ['\\mbfitl', '𝒍'],
   ['\\mbfitm', '𝒎'],
   ['\\mbfitn', '𝒏'],
   ['\\mbfito', '𝒐'],
   ['\\mbfitp', '𝒑'],
   ['\\mbfitq', '𝒒'],
   ['\\mbfitr', '𝒓'],
   ['\\mbfits', '𝒔'],
   ['\\mbfitt', '𝒕'],
   ['\\mbfitu', '𝒖'],
   ['\\mbfitv', '𝒗'],
   ['\\mbfitw', '𝒘'],
   ['\\mbfitx', '𝒙'],
   ['\\mbfity', '𝒚'],
   ['\\mbfitz', '𝒛'],
   ['\\mfrakA', '𝔄'],
   ['\\mfrakB', '𝔅'],
   ['\\mfrakD', '𝔇'],
   ['\\mfrakE', '𝔈'],
   ['\\mfrakF', '𝔉'],
   ['\\mfrakG', '𝔊'],
   ['\\mfrakJ', '𝔍'],
   ['\\mfrakK', '𝔎'],
   ['\\mfrakL', '𝔏'],
   ['\\mfrakM', '𝔐'],
   ['\\mfrakN', '𝔑'],
   ['\\mfrakO', '𝔒'],
   ['\\mfrakP', '𝔓'],
   ['\\mfrakQ', '𝔔'],
   ['\\mfrakS', '𝔖'],
   ['\\mfrakT', '𝔗'],
   ['\\mfrakU', '𝔘'],
   ['\\mfrakV', '𝔙'],
   ['\\mfrakW', '𝔚'],
   ['\\mfrakX', '𝔛'],
   ['\\mfrakY', '𝔜'],
   ['\\mfraka', '𝔞'],
   ['\\mfrakb', '𝔟'],
   ['\\mfrakc', '𝔠'],
   ['\\mfrakd', '𝔡'],
   ['\\mfrake', '𝔢'],
   ['\\mfrakf', '𝔣'],
   ['\\mfrakg', '𝔤'],
   ['\\mfrakh', '𝔥'],
   ['\\mfraki', '𝔦'],
   ['\\mfrakj', '𝔧'],
   ['\\mfrakk', '𝔨'],
   ['\\mfrakl', '𝔩'],
   ['\\mfrakm', '𝔪'],
   ['\\mfrakn', '𝔫'],
   ['\\mfrako', '𝔬'],
   ['\\mfrakp', '𝔭'],
   ['\\mfrakq', '𝔮'],
   ['\\mfrakr', '𝔯'],
   ['\\mfraks', '𝔰'],
   ['\\mfrakt', '𝔱'],
   ['\\mfraku', '𝔲'],
   ['\\mfrakv', '𝔳'],
   ['\\mfrakw', '𝔴'],
   ['\\mfrakx', '𝔵'],
   ['\\mfraky', '𝔶'],
   ['\\mfrakz', '𝔷'],
   ['\\msansA', '𝖠'],
   ['\\msansB', '𝖡'],
   ['\\msansC', '𝖢'],
   ['\\msansD', '𝖣'],
   ['\\msansE', '𝖤'],
   ['\\msansF', '𝖥'],
   ['\\msansG', '𝖦'],
   ['\\msansH', '𝖧'],
   ['\\msansI', '𝖨'],
   ['\\msansJ', '𝖩'],
   ['\\msansK', '𝖪'],
   ['\\msansL', '𝖫'],
   ['\\msansM', '𝖬'],
   ['\\msansN', '𝖭'],
   ['\\msansO', '𝖮'],
   ['\\msansP', '𝖯'],
   ['\\msansQ', '𝖰'],
   ['\\msansR', '𝖱'],
   ['\\msansS', '𝖲'],
   ['\\msansT', '𝖳'],
   ['\\msansU', '𝖴'],
   ['\\msansV', '𝖵'],
   ['\\msansW', '𝖶'],
   ['\\msansX', '𝖷'],
   ['\\msansY', '𝖸'],
   ['\\msansZ', '𝖹'],
   ['\\msansa', '𝖺'],
   ['\\msansb', '𝖻'],
   ['\\msansc', '𝖼'],
   ['\\msansd', '𝖽'],
   ['\\msanse', '𝖾'],
   ['\\msansf', '𝖿'],
   ['\\msansg', '𝗀'],
   ['\\msansh', '𝗁'],
   ['\\msansi', '𝗂'],
   ['\\msansj', '𝗃'],
   ['\\msansk', '𝗄'],
   ['\\msansl', '𝗅'],
   ['\\msansm', '𝗆'],
   ['\\msansn', '𝗇'],
   ['\\msanso', '𝗈'],
   ['\\msansp', '𝗉'],
   ['\\msansq', '𝗊'],
   ['\\msansr', '𝗋'],
   ['\\msanss', '𝗌'],
   ['\\msanst', '𝗍'],
   ['\\msansu', '𝗎'],
   ['\\msansv', '𝗏'],
   ['\\msansw', '𝗐'],
   ['\\msansx', '𝗑'],
   ['\\msansy', '𝗒'],
   ['\\msansz', '𝗓'],
   ['\\mbfEta', '𝚮'],
   ['\\mbfRho', '𝚸'],
   ['\\mbfTau', '𝚻'],
   ['\\mbfPhi', '𝚽'],
   ['\\mbfChi', '𝚾'],
   ['\\mbfPsi', '𝚿'],
   ['\\mbfeta', '𝛈'],
   ['\\mbfrho', '𝛒'],
   ['\\mbftau', '𝛕'],
   ['\\mbfchi', '𝛘'],
   ['\\mbfpsi', '𝛙'],
   ['\\mbfphi', '𝛟'],
   ['\\mitEta', '𝛨'],
   ['\\mitRho', '𝛲'],
   ['\\mitTau', '𝛵'],
   ['\\mitPhi', '𝛷'],
   ['\\varPhi', '𝛷'],
   ['\\mitChi', '𝛸'],
   ['\\mitPsi', '𝛹'],
   ['\\varPsi', '𝛹'],
   ['\\miteta', '𝜂'],
   ['\\mitrho', '𝜌'],
   ['\\mittau', '𝜏'],
   ['\\mitphi', '𝜑'],
   ['\\mitchi', '𝜒'],
   ['\\mitpsi', '𝜓'],
   ['\\Bbbone', '𝟙'],
   ['\\Bbbtwo', '𝟚'],
   ['\\Bbbsix', '𝟞'],
   ['\\mttone', '𝟷'],
   ['\\mtttwo', '𝟸'],
   ['\\mttsix', '𝟼'],
   ['\\Sigma', 'Σ'],
   ['\\Omega', 'Ω'],
   ['\\nabla', '∇'],
   ['\\colon', ':'],
   ['\\boxHu', '╧'],
   ['\\boxHd', '╤'],
   ['\\aleph', 'ℵ'],
   ['\\gnsim', '⋧'],
   ['\\boxHU', '╩'],
   ['\\boxHD', '╦'],
   ['\\equiv', '≡'],
   ['\\lneqq', '≨'],
   ['\\alpha', 'α'],
   ['\\amalg', '∐'],
   ['\\boxhU', '╨'],
   ['\\boxhD', '╥'],
   ['\\uplus', '⊎'],
   ['\\boxhu', '┴'],
   ['\\kappa', 'κ'],
   ['\\sigma', 'σ'],
   ['\\boxDL', '╗'],
   ['\\Theta', 'Θ'],
   ['\\Vdash', '⊩'],
   ['\\boxDR', '╔'],
   ['\\boxDl', '╖'],
   ['\\sqcap', '⊓'],
   ['\\boxDr', '╓'],
   ['\\bar{}', '¯'],
   ['\\dashv', '⊣'],
   ['\\vDash', '⊨'],
   ['\\boxdl', '┐'],
   ['\\boxVl', '╢'],
   ['\\boxVh', '╫'],
   ['\\boxVr', '╟'],
   ['\\boxdr', '┌'],
   ['\\boxdL', '╕'],
   ['\\boxVL', '╣'],
   ['\\boxVH', '╬'],
   ['\\boxVR', '╠'],
   ['\\boxdR', '╒'],
   ['\\theta', 'θ'],
   ['\\lhblk', '▄'],
   ['\\uhblk', '▀'],
   ['\\ldotp', '.'],
   ['\\ldots', '…'],
   ['\\boxvL', '╡'],
   ['\\boxvH', '╪'],
   ['\\boxvR', '╞'],
   ['\\boxvl', '┤'],
   ['\\boxvh', '┼'],
   ['\\boxvr', '├'],
   ['\\Delta', 'Δ'],
   ['\\boxUR', '╚'],
   ['\\boxUL', '╝'],
   ['\\oplus', '⊕'],
   ['\\boxUr', '╙'],
   ['\\boxUl', '╜'],
   ['\\doteq', '≐'],
   ['\\happy', '㋡'],
   ['\\varpi', 'ϖ'],
   ['\\smile', '☺'],
   ['\\boxul', '┘'],
   ['\\simeq', '≃'],
   ['\\boxuR', '╘'],
   ['\\boxuL', '╛'],
   ['\\boxhd', '┬'],
   ['\\gimel', 'ℷ'],
   ['\\Gamma', 'Γ'],
   ['\\lnsim', '⋦'],
   ['\\sqcup', '⊔'],
   ['\\omega', 'ω'],
   ['\\sharp', '♯'],
   ['\\times', '×'],
   ['\\block', '█'],
   ['\\hat{}', '^'],
   ['\\wedge', '∧'],
   ['\\vdash', '⊢'],
   ['\\angle', '∠'],
   ['\\infty', '∞'],
   ['\\gamma', 'γ'],
   ['\\asymp', '≍'],
   ['\\rceil', '⌉'],
   ['\\dot{}', '˙'],
   ['\\lceil', '⌈'],
   ['\\delta', 'δ'],
   ['\\gneqq', '≩'],
   ['\\frown', '⌢'],
   ['\\phone', '☎'],
   ['\\vdots', '⋮'],
   ['\\comma', ','],
   ['\\slash', '/'],
   ['\\equal', '='],
   ['\\sphat', '^'],
   ['\\Micro', 'µ'],
   ['\\cdotp', '·'],
   ['\\imath', 'ı'],
   ['\\jmath', 'ȷ'],
   ['\\ocirc', '̊'],
   ['\\check', '̌'],
   ['\\upEta', 'Η'],
   ['\\upRho', 'Ρ'],
   ['\\upTau', 'Τ'],
   ['\\upPhi', 'Φ'],
   ['\\upChi', 'Χ'],
   ['\\upPsi', 'Ψ'],
   ['\\upeta', 'η'],
   ['\\etaup', 'η'],
   ['\\uprho', 'ρ'],
   ['\\rhoup', 'ρ'],
   ['\\uptau', 'τ'],
   ['\\tauup', 'τ'],
   ['\\upchi', 'χ'],
   ['\\chiup', 'χ'],
   ['\\uppsi', 'ψ'],
   ['\\psiup', 'ψ'],
   ['\\upphi', 'ϕ'],
   ['\\phiup', 'ϕ'],
   ['\\Qoppa', 'Ϙ'],
   ['\\Koppa', 'Ϙ'],
   ['\\qoppa', 'ϙ'],
   ['\\koppa', 'ϙ'],
   ['\\Sampi', 'Ϡ'],
   ['\\sampi', 'ϡ'],
   ['\\prime', '′'],
   ['\\third', '‴'],
   ['\\dddot', '⃛'],
   ['\\DDDot', '⃛'],
   ['\\Euler', 'ℇ'],
   ['\\mscrg', 'ℊ'],
   ['\\mscrH', 'ℋ'],
   ['=\\HBar', 'ℏ'],
   ['#\\hbar', 'ℏ'],
   ['\\mscrI', 'ℐ'],
   ['\\mscrL', 'ℒ'],
   ['\\mscrR', 'ℛ'],
   ['\\tcohm', 'Ω'],
   ['\\agemO', '℧'],
   ['\\mscrB', 'ℬ'],
   ['\\mscre', 'ℯ'],
   ['\\mscrE', 'ℰ'],
   ['\\mscrF', 'ℱ'],
   ['\\mscrM', 'ℳ'],
   ['\\mscro', 'ℴ'],
   ['\\Bbbpi', 'ℼ'],
   ['\\BbbPi', 'ℿ'],
   ['\\upand', '⅋'],
   ['\\notin', '∉'],
   ['\\notni', '∌'],
   ['\\minus', '−'],
   ['\\iiint', '∭'],
   ['\\oiint', '∯'],
   ['\\Colon', '∷'],
   ['\\eqsim', '≂'],
   ['\\nsime', '≄'],
   ['\\ncong', '≇'],
   ['\\Doteq', '≑'],
   ['\\arceq', '≘'],
   ['\\veeeq', '≚'],
   ['\\eqdef', '≝'],
   ['\\Equiv', '≣'],
   ['\\nless', '≮'],
   ['\\nprec', '⊀'],
   ['\\nsucc', '⊁'],
   ['\\unlhd', '⊴'],
   ['\\unrhd', '⊵'],
   ['\\eqgtr', '⋝'],
   ['\\cdots', '⋯'],
   ['\\adots', '⋰'],
   ['\\ddots', '⋱'],
   ['\\disin', '⋲'],
   ['\\isins', '⋴'],
   ['\\barin', '⋶'],
   ['\\isinE', '⋹'],
   ['\\house', '⌂'],
   ['\\strns', '⏤'],
   ['\\fltns', '⏥'],
   ['\\ularc', '◜'],
   ['\\urarc', '◝'],
   ['\\lrarc', '◞'],
   ['\\llarc', '◟'],
   ['\\skull', '☠'],
   ['\\Venus', '♀'],
   ['\\earth', '♁'],
   ['\\pluto', '♇'],
   ['\\Pluto', '♇'],
   ['\\aries', '♈'],
   ['\\Aries', '♈'],
   ['\\virgo', '♍'],
   ['\\libra', '♎'],
   ['\\Libra', '♎'],
   ['\\dicei', '⚀'],
   ['\\dicev', '⚄'],
   ['\\psurj', '⤀'],
   ['\\Vvert', '⦀'],
   ['\\lblot', '⦉'],
   ['\\rblot', '⦊'],
   ['\\operp', '⦹'],
   ['\\zhide', '⧹'],
   ['\\xbsol', '⧹'],
   ['\\tplus', '⧾'],
   ['\\awint', '⨑'],
   ['\\sqint', '⨖'],
   ['\\upint', '⨛'],
   ['\\zpipe', '⨠'],
   ['\\Sqcap', '⩎'],
   ['\\Sqcup', '⩏'],
   ['\\Wedge', '⩓'],
   ['\\ndres', '⩤'],
   ['\\nrres', '⩥'],
   ['\\eqdot', '⩦'],
   ['\\asteq', '⩮'],
   ['\\Equal', '⩵'],
   ['\\ltcir', '⩹'],
   ['\\gtcir', '⩺'],
   ['\\lsime', '⪍'],
   ['\\gsime', '⪎'],
   ['\\lsimg', '⪏'],
   ['\\gsiml', '⪐'],
   ['\\simlE', '⪟'],
   ['\\simgE', '⪠'],
   ['\\lescc', '⪨'],
   ['\\gescc', '⪩'],
   ['\\csube', '⫑'],
   ['\\csupe', '⫒'],
   ['\\forkv', '⫙'],
   ['\\forks', '⫝̸'],
   ['\\perps', '⫡'],
   ['\\dashV', '⫣'],
   ['\\Dashv', '⫤'],
   ['\\DashV', '⫥'],
   ['\\vBarv', '⫩'],
   ['\\nhpar', '⫲'],
   ['\\mscrA', '𝒜'],
   ['\\mscrC', '𝒞'],
   ['\\mscrD', '𝒟'],
   ['\\mscrG', '𝒢'],
   ['\\mscrJ', '𝒥'],
   ['\\mscrK', '𝒦'],
   ['\\mscrN', '𝒩'],
   ['\\mscrO', '𝒪'],
   ['\\mscrP', '𝒫'],
   ['\\mscrQ', '𝒬'],
   ['\\mscrS', '𝒮'],
   ['\\mscrT', '𝒯'],
   ['\\mscrU', '𝒰'],
   ['\\mscrV', '𝒱'],
   ['\\mscrW', '𝒲'],
   ['\\mscrX', '𝒳'],
   ['\\mscrY', '𝒴'],
   ['\\mscrZ', '𝒵'],
   ['\\mscra', '𝒶'],
   ['\\mscrb', '𝒷'],
   ['\\mscrc', '𝒸'],
   ['\\mscrd', '𝒹'],
   ['\\mscrf', '𝒻'],
   ['\\mscrh', '𝒽'],
   ['\\mscri', '𝒾'],
   ['\\mscrj', '𝒿'],
   ['\\mscrk', '𝓀'],
   ['\\mscrl', '𝓁'],
   ['\\mscrm', '𝓂'],
   ['\\mscrn', '𝓃'],
   ['\\mscrp', '𝓅'],
   ['\\mscrq', '𝓆'],
   ['\\mscrr', '𝓇'],
   ['\\mscrs', '𝓈'],
   ['\\mscrt', '𝓉'],
   ['\\mscru', '𝓊'],
   ['\\mscrv', '𝓋'],
   ['\\mscrw', '𝓌'],
   ['\\mscrx', '𝓍'],
   ['\\mscry', '𝓎'],
   ['\\mscrz', '𝓏'],
   ['\\mbfMu', '𝚳'],
   ['\\mbfNu', '𝚴'],
   ['\\mbfXi', '𝚵'],
   ['\\mbfPi', '𝚷'],
   ['\\mbfmu', '𝛍'],
   ['\\mbfnu', '𝛎'],
   ['\\mbfxi', '𝛏'],
   ['\\mbfpi', '𝛑'],
   ['\\mitMu', '𝛭'],
   ['\\mitNu', '𝛮'],
   ['\\mitXi', '𝛯'],
   ['\\varXi', '𝛯'],
   ['\\mitPi', '𝛱'],
   ['\\varPi', '𝛱'],
   ['\\mitmu', '𝜇'],
   ['\\mitnu', '𝜈'],
   ['\\mitxi', '𝜉'],
   ['\\mitpi', '𝜋'],
   ['\\boxr', '└'],
   ['\\k{i}', 'į'],
   ['\\`{I}', 'Ì'],
   ['\\perp', '⊥'],
   ['\\"{o}', 'ö'],
   ['\\={I}', 'Ī'],
   ['\\`{a}', 'à'],
   ['\\v{T}', 'Ť'],
   ['\\surd', '√'],
   ['\\H{O}', 'Ő'],
   ['\\vert', '|'],
   ['\\k{I}', 'Į'],
   ['\\"{y}', 'ÿ'],
   ['\\"{O}', 'Ö'],
   ['\\\'{Y}', 'Ý'],
   ['\\u{u}', 'ў'],
   ['\\u{G}', 'Ğ'],
   ['\\.{E}', 'Ė'],
   ['\\.{z}', 'ż'],
   ['\\v{t}', 'ť'],
   ['\\prec', '≺'],
   ['\\H{o}', 'ő'],
   ['\\mldr', '…'],
   ['\\\'{y}', 'ý'],
   ['\\cong', '≅'],
   ['\\.{e}', 'ė'],
   ['\\\'{L}', 'Ĺ'],
   ['\\star', '*'],
   ['\\.{Z}', 'Ż'],
   ['\\\'{e}', 'é'],
   ['\\geqq', '≧'],
   ['\\cdot', '⋅'],
   ['\\`{U}', 'Ù'],
   ['\\\'{l}', 'ĺ'],
   ['\\v{L}', 'Ľ'],
   ['\\c{s}', 'ş'],
   ['\\\'{s}', 'ś'],
   ['\\~{A}', 'Ã'],
   ['\\Vert', '‖'],
   ['\\k{e}', 'ę'],
   ['\\lnot', '¬'],
   ['\\\'{z}', 'ź'],
   ['\\leqq', '≦'],
   ['\\beta', 'β'],
   ['\\beth', 'ℶ'],
   ['\\\'{E}', 'É'],
   ['\\~{n}', 'ñ'],
   ['\\u{i}', 'й'],
   ['\\c{S}', 'Ş'],
   ['\\c{N}', 'Ņ'],
   ['\\H{u}', 'ű'],
   ['\\v{n}', 'ň'],
   ['\\\'{S}', 'Ś'],
   ['\\={U}', 'Ū'],
   ['\\~{O}', 'Õ'],
   ['\\\'{Z}', 'Ź'],
   ['\\v{E}', 'Ě'],
   ['\\\'{R}', 'Ŕ'],
   ['\\H{U}', 'Ű'],
   ['\\v{N}', 'Ň'],
   ['\\prod', '∏'],
   ['\\v{s}', 'š'],
   ['\\"{U}', 'Ü'],
   ['\\c{n}', 'ņ'],
   ['\\k{U}', 'Ų'],
   ['\\c{R}', 'Ŗ'],
   ['\\\'{A}', 'Á'],
   ['\\~{o}', 'õ'],
   ['\\v{e}', 'ě'],
   ['\\v{S}', 'Š'],
   ['\\u{A}', 'Ă'],
   ['\\circ', '∘'],
   ['\\"{u}', 'ü'],
   ['\\flat', '♭'],
   ['\\v{z}', 'ž'],
   ['\\r{U}', 'Ů'],
   ['\\`{O}', 'Ò'],
   ['\\={u}', 'ū'],
   ['\\oint', '∮'],
   ['\\c{K}', 'Ķ'],
   ['\\k{u}', 'ų'],
   ['\\not<', '≮'],
   ['\\not>', '≯'],
   ['\\`{o}', 'ò'],
   ['\\"{I}', 'Ï'],
   ['\\v{D}', 'Ď'],
   ['\\.{G}', 'Ġ'],
   ['\\r{u}', 'ů'],
   ['\\not=', '≠'],
   ['\\`{u}', 'ù'],
   ['\\v{c}', 'č'],
   ['\\c{k}', 'ķ'],
   ['\\.{g}', 'ġ'],
   ['\\\'{N}', 'Ń'],
   ['\\odot', '⊙'],
   ['\\`{e}', 'э'],
   ['\\c{T}', 'Ţ'],
   ['\\v{d}', 'ď'],
   ['\\"{e}', 'ё'],
   ['\\\'{I}', 'Í'],
   ['\\v{R}', 'Ř'],
   ['\\k{a}', 'ą'],
   ['\\nldr', '‥'],
   ['\\`{A}', 'À'],
   ['\\\'{n}', 'ń'],
   ['\\~{N}', 'Ñ'],
   ['\\nmid', '∤'],
   ['\\.{C}', 'Ċ'],
   ['\\zeta', 'ζ'],
   ['\\~{u}', 'ũ'],
   ['\\`{E}', 'Э'],
   ['\\~{a}', 'ã'],
   ['\\c{t}', 'ţ'],
   ['\\={o}', 'ō'],
   ['\\v{r}', 'ř'],
   ['\\={A}', 'Ā'],
   ['\\.{c}', 'ċ'],
   ['\\~{U}', 'Ũ'],
   ['\\k{A}', 'Ą'],
   ['\\"{a}', 'ä'],
   ['\\u{U}', 'Ў'],
   ['\\iota', 'ι'],
   ['\\={O}', 'Ō'],
   ['\\c{C}', 'Ç'],
   ['\\gneq', '≩'],
   ['\\\'{c}', 'ć'],
   ['\\boxH', '═'],
   ['\\hbar', 'ℏ'],
   ['\\"{A}', 'Ä'],
   ['\\boxv', '│'],
   ['\\boxh', '─'],
   ['\\male', '♂'],
   ['\\\'{u}', 'ú'],
   ['\\sqrt', '√'],
   ['\\succ', '≻'],
   ['\\c{c}', 'ç'],
   ['\\\'{C}', 'Ć'],
   ['\\v{l}', 'ľ'],
   ['\\u{a}', 'ă'],
   ['\\v{Z}', 'Ž'],
   ['\\\'{o}', 'ó'],
   ['\\c{G}', 'Ģ'],
   ['\\v{C}', 'Č'],
   ['\\lneq', '≨'],
   ['\\"{E}', 'Ё'],
   ['\\={a}', 'ā'],
   ['\\c{l}', 'ļ'],
   ['\\\'{a}', 'á'],
   ['\\={E}', 'Ē'],
   ['\\boxV', '║'],
   ['\\u{g}', 'ğ'],
   ['\\\'{O}', 'Ó'],
   ['\\\'{g}', 'ǵ'],
   ['\\u{I}', 'Й'],
   ['\\c{L}', 'Ļ'],
   ['\\k{E}', 'Ę'],
   ['\\.{I}', 'İ'],
   ['\\~{I}', 'Ĩ'],
   ['\\quad', ' '],
   ['\\c{r}', 'ŗ'],
   ['\\\'{r}', 'ŕ'],
   ['\\"{Y}', 'Ÿ'],
   ['\\={e}', 'ē'],
   ['\\\'{U}', 'Ú'],
   ['\\plus', '+'],
   ['\\less', '<'],
   ['\\cent', '¢'],
   ['\\tcmu', 'µ'],
   ['\\muup', 'µ'],
   ['\\Zbar', 'Ƶ'],
   ['\\DDot', '̈'],
   ['\\ring', '̊'],
   ['\\upMu', 'Μ'],
   ['\\upNu', 'Ν'],
   ['\\upXi', 'Ξ'],
   ['\\upPi', 'Π'],
   ['\\upmu', 'μ'],
   ['\\upnu', 'ν'],
   ['\\nuup', 'ν'],
   ['\\upxi', 'ξ'],
   ['\\xiup', 'ξ'],
   ['\\uppi', 'π'],
   ['\\piup', 'π'],
   ['\\euro', '€'],
   ['\\lvec', '⃐'],
   ['\\LVec', '⃖'],
   ['\\BbbC', 'ℂ'],
   ['\\BbbH', 'ℍ'],
   ['\\BbbN', 'ℕ'],
   ['\\BbbP', 'ℙ'],
   ['\\BbbQ', 'ℚ'],
   ['\\BbbR', 'ℝ'],
   ['\\BbbZ', 'ℤ'],
   ['\\Finv', 'Ⅎ'],
   ['\\Game', '⅁'],
   ['\\gets', '←'],
   ['\\tfun', '→'],
   ['\\tsur', '↠'],
   ['\\surj', '↠'],
   ['\\tinj', '↣'],
   ['\\dlsh', '↲'],
   ['\\Ldsh', '↲'],
   ['\\drsh', '↳'],
   ['\\Rdsh', '↳'],
   ['\\pfun', '⇸'],
   ['\\ffun', '⇻'],
   ['\\nexi', '∄'],
   ['\\owns', '∋'],
   ['\\land', '∧'],
   ['\\iint', '∬'],
   ['\\nsim', '≁'],
   ['\\sdef', '≙'],
   ['\\ngtr', '≯'],
   ['\\nleq', '≰'],
   ['\\ngeq', '≱'],
   ['\\buni', '⊎'],
   ['\\dint', '⋂'],
   ['\\duni', '⋃'],
   ['\\hash', '⋕'],
   ['\\nisd', '⋺'],
   ['\\obar', '⌽'],
   ['\\rres', '▷'],
   ['\\dres', '◁'],
   ['\\XBox', '☒'],
   ['\\girl', '♀'],
   ['\\Mars', '♂'],
   ['\\Lbag', '⟅'],
   ['\\lbag', '⟅'],
   ['\\Rbag', '⟆'],
   ['\\rbag', '⟆'],
   ['\\upin', '⟒'],
   ['\\lang', '⟪'],
   ['\\rang', '⟫'],
   ['\\psur', '⤀'],
   ['\\pinj', '⤔'],
   ['\\finj', '⤕'],
   ['\\tona', '⤧'],
   ['\\toea', '⤨'],
   ['\\tosa', '⤩'],
   ['\\towa', '⤪'],
   ['\\VERT', '⦀'],
   ['\\spot', '⦁'],
   ['\\limg', '⦇'],
   ['\\rimg', '⦈'],
   ['\\obot', '⦺'],
   ['\\cirE', '⧃'],
   ['\\dsol', '⧶'],
   ['\\xsol', '⧸'],
   ['\\hide', '⧹'],
   ['\\fint', '⨏'],
   ['\\intx', '⨘'],
   ['\\Join', '⨝'],
   ['\\zcmp', '⨟'],
   ['\\semi', '⨟'],
   ['\\odiv', '⨸'],
   ['\\fcmp', '⨾'],
   ['\\comp', '⨾'],
   ['\\dsub', '⩤'],
   ['\\rsub', '⩥'],
   ['\\eqeq', '⩵'],
   ['\\Same', '⩶'],
   ['\\ltcc', '⪦'],
   ['\\gtcc', '⪧'],
   ['\\smte', '⪬'],
   ['\\late', '⪭'],
   ['\\Prec', '⪻'],
   ['\\Succ', '⪼'],
   ['\\csub', '⫏'],
   ['\\csup', '⫐'],
   ['\\mlcp', '⫛'],
   ['\\Barv', '⫧'],
   ['\\vBar', '⫨'],
   ['\\barV', '⫪'],
   ['\\Vbar', '⫫'],
   ['\\Perp', '⫫'],
   ['\\bNot', '⫭'],
   ['\\mbfA', '𝐀'],
   ['\\mbfB', '𝐁'],
   ['\\mbfC', '𝐂'],
   ['\\mbfD', '𝐃'],
   ['\\mbfE', '𝐄'],
   ['\\mbfF', '𝐅'],
   ['\\mbfG', '𝐆'],
   ['\\mbfH', '𝐇'],
   ['\\mbfI', '𝐈'],
   ['\\mbfJ', '𝐉'],
   ['\\mbfK', '𝐊'],
   ['\\mbfL', '𝐋'],
   ['\\mbfM', '𝐌'],
   ['\\mbfN', '𝐍'],
   ['\\mbfO', '𝐎'],
   ['\\mbfP', '𝐏'],
   ['\\mbfQ', '𝐐'],
   ['\\mbfR', '𝐑'],
   ['\\mbfS', '𝐒'],
   ['\\mbfT', '𝐓'],
   ['\\mbfU', '𝐔'],
   ['\\mbfV', '𝐕'],
   ['\\mbfW', '𝐖'],
   ['\\mbfX', '𝐗'],
   ['\\mbfY', '𝐘'],
   ['\\mbfZ', '𝐙'],
   ['\\mbfa', '𝐚'],
   ['\\mbfb', '𝐛'],
   ['\\mbfc', '𝐜'],
   ['\\mbfd', '𝐝'],
   ['\\mbfe', '𝐞'],
   ['\\mbff', '𝐟'],
   ['\\mbfg', '𝐠'],
   ['\\mbfh', '𝐡'],
   ['\\mbfi', '𝐢'],
   ['\\mbfj', '𝐣'],
   ['\\mbfk', '𝐤'],
   ['\\mbfl', '𝐥'],
   ['\\mbfm', '𝐦'],
   ['\\mbfn', '𝐧'],
   ['\\mbfo', '𝐨'],
   ['\\mbfp', '𝐩'],
   ['\\mbfq', '𝐪'],
   ['\\mbfr', '𝐫'],
   ['\\mbfs', '𝐬'],
   ['\\mbft', '𝐭'],
   ['\\mbfu', '𝐮'],
   ['\\mbfv', '𝐯'],
   ['\\mbfw', '𝐰'],
   ['\\mbfx', '𝐱'],
   ['\\mbfy', '𝐲'],
   ['\\mbfz', '𝐳'],
   ['\\mitA', '𝐴'],
   ['\\mitB', '𝐵'],
   ['\\mitC', '𝐶'],
   ['\\mitD', '𝐷'],
   ['\\mitE', '𝐸'],
   ['\\mitF', '𝐹'],
   ['\\mitG', '𝐺'],
   ['\\mitH', '𝐻'],
   ['\\mitI', '𝐼'],
   ['\\mitJ', '𝐽'],
   ['\\mitK', '𝐾'],
   ['\\mitL', '𝐿'],
   ['\\mitM', '𝑀'],
   ['\\mitN', '𝑁'],
   ['\\mitO', '𝑂'],
   ['\\mitP', '𝑃'],
   ['\\mitQ', '𝑄'],
   ['\\mitR', '𝑅'],
   ['\\mitS', '𝑆'],
   ['\\mitT', '𝑇'],
   ['\\mitU', '𝑈'],
   ['\\mitV', '𝑉'],
   ['\\mitW', '𝑊'],
   ['\\mitX', '𝑋'],
   ['\\mitY', '𝑌'],
   ['\\mitZ', '𝑍'],
   ['\\mita', '𝑎'],
   ['\\mitb', '𝑏'],
   ['\\mitc', '𝑐'],
   ['\\mitd', '𝑑'],
   ['\\mite', '𝑒'],
   ['\\mitf', '𝑓'],
   ['\\mitg', '𝑔'],
   ['\\miti', '𝑖'],
   ['\\mitj', '𝑗'],
   ['\\mitk', '𝑘'],
   ['\\mitl', '𝑙'],
   ['\\mitm', '𝑚'],
   ['\\mitn', '𝑛'],
   ['\\mito', '𝑜'],
   ['\\mitp', '𝑝'],
   ['\\mitq', '𝑞'],
   ['\\mitr', '𝑟'],
   ['\\mits', '𝑠'],
   ['\\mitt', '𝑡'],
   ['\\mitu', '𝑢'],
   ['\\mitv', '𝑣'],
   ['\\mitw', '𝑤'],
   ['\\mitx', '𝑥'],
   ['\\mity', '𝑦'],
   ['\\mitz', '𝑧'],
   ['\\BbbA', '𝔸'],
   ['\\BbbB', '𝔹'],
   ['\\BbbD', '𝔻'],
   ['\\BbbE', '𝔼'],
   ['\\BbbF', '𝔽'],
   ['\\BbbG', '𝔾'],
   ['\\BbbI', '𝕀'],
   ['\\BbbJ', '𝕁'],
   ['\\BbbK', '𝕂'],
   ['\\BbbL', '𝕃'],
   ['\\BbbM', '𝕄'],
   ['\\BbbO', '𝕆'],
   ['\\BbbS', '𝕊'],
   ['\\BbbT', '𝕋'],
   ['\\BbbU', '𝕌'],
   ['\\BbbV', '𝕍'],
   ['\\BbbW', '𝕎'],
   ['\\BbbX', '𝕏'],
   ['\\BbbY', '𝕐'],
   ['\\Bbba', '𝕒'],
   ['\\Bbbb', '𝕓'],
   ['\\Bbbc', '𝕔'],
   ['\\Bbbd', '𝕕'],
   ['\\Bbbe', '𝕖'],
   ['\\Bbbf', '𝕗'],
   ['\\Bbbg', '𝕘'],
   ['\\Bbbh', '𝕙'],
   ['\\Bbbi', '𝕚'],
   ['\\Bbbj', '𝕛'],
   ['\\Bbbk', '𝕜'],
   ['\\Bbbl', '𝕝'],
   ['\\Bbbm', '𝕞'],
   ['\\Bbbn', '𝕟'],
   ['\\Bbbo', '𝕠'],
   ['\\Bbbp', '𝕡'],
   ['\\Bbbq', '𝕢'],
   ['\\Bbbr', '𝕣'],
   ['\\Bbbs', '𝕤'],
   ['\\Bbbt', '𝕥'],
   ['\\Bbbu', '𝕦'],
   ['\\Bbbv', '𝕧'],
   ['\\Bbbw', '𝕨'],
   ['\\Bbbx', '𝕩'],
   ['\\Bbby', '𝕪'],
   ['\\Bbbz', '𝕫'],
   ['\\mttA', '𝙰'],
   ['\\mttB', '𝙱'],
   ['\\mttC', '𝙲'],
   ['\\mttD', '𝙳'],
   ['\\mttE', '𝙴'],
   ['\\mttF', '𝙵'],
   ['\\mttG', '𝙶'],
   ['\\mttH', '𝙷'],
   ['\\mttI', '𝙸'],
   ['\\mttJ', '𝙹'],
   ['\\mttK', '𝙺'],
   ['\\mttL', '𝙻'],
   ['\\mttM', '𝙼'],
   ['\\mttN', '𝙽'],
   ['\\mttO', '𝙾'],
   ['\\mttP', '𝙿'],
   ['\\mttQ', '𝚀'],
   ['\\mttR', '𝚁'],
   ['\\mttS', '𝚂'],
   ['\\mttT', '𝚃'],
   ['\\mttU', '𝚄'],
   ['\\mttV', '𝚅'],
   ['\\mttW', '𝚆'],
   ['\\mttX', '𝚇'],
   ['\\mttY', '𝚈'],
   ['\\mttZ', '𝚉'],
   ['\\mtta', '𝚊'],
   ['\\mttb', '𝚋'],
   ['\\mttc', '𝚌'],
   ['\\mttd', '𝚍'],
   ['\\mtte', '𝚎'],
   ['\\mttf', '𝚏'],
   ['\\mttg', '𝚐'],
   ['\\mtth', '𝚑'],
   ['\\mtti', '𝚒'],
   ['\\mttj', '𝚓'],
   ['\\mttk', '𝚔'],
   ['\\mttl', '𝚕'],
   ['\\mttm', '𝚖'],
   ['\\mttn', '𝚗'],
   ['\\mtto', '𝚘'],
   ['\\mttp', '𝚙'],
   ['\\mttq', '𝚚'],
   ['\\mttr', '𝚛'],
   ['\\mtts', '𝚜'],
   ['\\mttt', '𝚝'],
   ['\\mttu', '𝚞'],
   ['\\mttv', '𝚟'],
   ['\\mttw', '𝚠'],
   ['\\mttx', '𝚡'],
   ['\\mtty', '𝚢'],
   ['\\mttz', '𝚣'],
   ['\\leq', '≤'],
   ['\\Cup', '⋓'],
   ['\\Psi', 'Ψ'],
   ['\\neq', '≠'],
   ['\\k{}', '˛'],
   ['\\={}', '‾'],
   ['\\H{}', '˝'],
   ['\\cup', '∪'],
   ['\\geq', '≥'],
   ['\\mho', '℧'],
   ['\\Dzh', 'Џ'],
   ['\\cap', '∩'],
   ['\\bot', '⊥'],
   ['\\psi', 'ψ'],
   ['\\chi', 'χ'],
   ['\\c{}', '¸'],
   ['\\Phi', 'Φ'],
   ['\\ast', '*'],
   ['\\ell', 'ℓ'],
   ['\\top', '⊤'],
   ['\\lll', '⋘'],
   ['\\tau', 'τ'],
   ['\\Cap', '⋒'],
   ['\\sad', '☹'],
   ['\\iff', '⇔'],
   ['\\eta', 'η'],
   ['\\eth', 'ð'],
   ['\\d{}', '̣'],
   ['\\rho', 'ρ'],
   ['\\dzh', 'џ'],
   ['\\div', '÷'],
   ['\\phi', 'ϕ'],
   ['\\Rsh', '↱'],
   ['\\vee', '∨'],
   ['\\b{}', 'ˍ'],
   ['\\t{}', '͡'],
   ['\\int', '∫'],
   ['\\sim', '∼'],
   ['\\r{}', '˚'],
   ['\\Lsh', '↰'],
   ['\\yen', '¥'],
   ['\\ggg', '⋙'],
   ['\\mid', '∣'],
   ['\\sum', '∑'],
   ['\\neg', '¬'],
   ['\\Dot', '̇'],
   ['\\not', '̸'],
   ['\\cat', '⁀'],
   ['\\Vec', '⃗'],
   ['\\Mho', '℧'],
   ['\\Yup', '⅄'],
   ['\\fun', '→'],
   ['\\rel', '↔'],
   ['\\inj', '↣'],
   ['\\exi', '∃'],
   ['\\nin', '∉'],
   ['\\nni', '∌'],
   ['\\QED', '∎'],
   ['\\lor', '∨'],
   ['\\nis', '⋼'],
   ['25\\%', '░'],
   ['50\\%', '▒'],
   ['75\\%', '▓'],
   ['\\RHD', '▶'],
   ['\\rhd', '▷'],
   ['\\LHD', '◀'],
   ['\\lhd', '◁'],
   ['\\Sun', '☉'],
   ['\\sun', '☼'],
   ['\\boy', '♂'],
   ['\\leo', '♌'],
   ['\\Leo', '♌'],
   ['\\bij', '⤖'],
   ['\\Vee', '⩔'],
   ['\\lgE', '⪑'],
   ['\\glE', '⪒'],
   ['\\glj', '⪤'],
   ['\\gla', '⪥'],
   ['\\smt', '⪪'],
   ['\\lat', '⪫'],
   ['\\Top', '⫪'],
   ['\\Bot', '⫫'],
   ['\\Not', '⫬'],
   ['\\Dz', 'Ѕ'],
   ['\\Re', 'ℜ'],
   ['\\oe', 'œ'],
   ['\\DH', 'Ð'],
   ['\\ll', '≪'],
   ['\\ng', 'ŋ'],
   ['\\\'G', 'Ѓ'],
   ['\\wr', '≀'],
   ['\\wp', '℘'],
   ['\\=I', 'І'],
   ['\\:)', '☺'],
   ['\\:(', '☹'],
   ['\\AE', 'Æ'],
   ['\\AA', 'Å'],
   ['\\ss', 'ß'],
   ['\\dz', 'ѕ'],
   ['\\ae', 'æ'],
   ['\\aa', 'å'],
   ['\\th', 'þ'],
   ['\\to', '→'],
   ['\\Pi', 'Π'],
   ['\\mp', '∓'],
   ['\\Im', 'ℑ'],
   ['\\pm', '±'],
   ['\\pi', 'π'],
   ['\\"I', 'Ї'],
   ['\\\'C', 'Ћ'],
   ['\\in', '∈'],
   ['\\\'K', 'Ќ'],
   ['\\\'k', 'ќ'],
   ['\\\'c', 'ћ'],
   ['\\\'g', 'ѓ'],
   ['\\ni', '∋'],
   ['\\ne', '≠'],
   ['\\TH', 'Þ'],
   ['\\Xi', 'Ξ'],
   ['\\nu', 'ν'],
   ['\\NG', 'Ŋ'],
   ['\\:G', '㋡'],
   ['\\xi', 'ξ'],
   ['\\OE', 'Œ'],
   ['\\gg', '≫'],
   ['\\DJ', 'Đ'],
   ['\\=e', 'є'],
   ['\\=E', 'Є'],
   ['\\mu', 'μ'],
   ['\\dj', 'đ'],
   ['\\DD', 'ⅅ'],
   ['\\dd', 'ⅆ'],
   ['\\ee', 'ⅇ'],
   ['\\ii', 'ⅈ'],
   ['\\jj', 'ⅉ'],
   ['\\AC', '∿'],
   ['\\le', '≤'],
   ['\\ge', '≥'],
   ['\\Lt', '⪡'],
   ['\\Gt', '⪢'],
   ['\\:', ' '],
   ['\\;', ' '],
   ['\\&', '&'],
   ['\\$', '$'],
   ['\\%', '%'],
   ['\\#', '#'],
   ['\\,', ' '],
   ['\\-', '­'],
   ['\\S', '§'],
   ['\\P', '¶'],
   ['\\O', 'Ø'],
   ['\\L', 'Ł'],
   ['\\}', '}'],
   ['\\o', 'ø'],
   ['\\l', 'ł'],
   ['\\h', 'ℎ'],
   ['\\i', 'ℹ'],
   ['\\_', '_'],
   ['\\{', '{'],
   ['\\|', '‖'],
   ['-', '−'],
   ['\\arccos', 'arccos'],
   ['\\arcsin', 'arcsin'],
   ['\\arctan', 'arctan'],
   ['\\arg', 'arg'],
   ['\\cos', 'cos'],
   ['\\cosh', 'cosh'],
   ['\\cot', 'cot'],
   ['\\coth', 'coth'],
   ['\\csc', 'csc'],
   ['\\deg', 'deg'],
   ['\\det', 'det'],
   ['\\dim', 'dim'],
   ['\\exp', 'exp'],
   ['\\gcd', 'gcd'],
   ['\\hom', 'hom'],
   ['\\inf', 'inf'],
   ['\\injlim', 'inj lim'],
   ['\\ker', 'ker'],
   ['\\lg', 'lg'],
   ['\\lim', 'lim'],
   ['\\liminf', 'lim inf'],
   ['\\limsup', 'lim sup'],
   ['\\ln', 'ln'],
   ['\\log', 'log'],
   ['\\max', 'max'],
   ['\\min', 'min'],
   ['\\Pr', 'Pr'],
   ['\\projlim', 'proj lim'],
   ['\\sec', 'sec'],
   ['\\sin', 'sin'],
   ['\\sinh', 'sinh'],
   ['\\sup', 'sup'],
   ['\\tan', 'tan'],
   ['\\tanh', 'tanh'],
];

export const combiningmarks = [
   ['\\doubleunderline', '\u0333'],
   ['\\strikethrough', '\u0335'],
   ['\\underline', '\u0332'],
   ['\\overline', '\u0305'],
   ['\\tilde', '\u0303'],
   ['\\grave', '\u0300'],
   ['\\acute', '\u0301'],
   ['\\slash', '\u0338'],
   ['\\breve', '\u0306'],
   ['\\ddot', '\u0308'],
   ['\\dot', '\u0307'],
   ['\\bar', '\u0305'],
   ['\\vec', '\u20d7'],
   ['\\hat', '\u0302'],
];

export const subsuperscripts = [
   ['_x', 'ₓ'],
   ['_v', 'ᵥ'],
   ['_u', 'ᵤ'],
   ['_t', 'ₜ'],
   ['_s', 'ₛ'],
   ['_r', 'ᵣ'],
   ['_p', 'ₚ'],
   ['_o', 'ₒ'],
   ['_n', 'ₙ'],
   ['_m', 'ₘ'],
   ['_l', 'ₗ'],
   ['_k', 'ₖ'],
   ['_j', 'ⱼ'],
   ['_i', 'ᵢ'],
   ['_h', 'ₕ'],
   ['_e', 'ₑ'],
   ['_a', 'ₐ'],
   ['^∫', 'ᶴ'],
   ['_>', '˲'],
   ['_=', '₌'],
   ['_<', '˱'],
   ['_9', '₉'],
   ['_8', '₈'],
   ['_7', '₇'],
   ['_6', '₆'],
   ['_5', '₅'],
   ['_4', '₄'],
   ['_3', '₃'],
   ['_2', '₂'],
   ['_1', '₁'],
   ['_0', '₀'],
   ['_-', '₋'],
   ['_−', '₋'],
   ['_+', '₊'],
   ['_)', '₎'],
   ['_(', '₍'],
   ['_\\rho', 'ᵨ'],
   ['_ρ', 'ᵨ'],
   ['_\\chi', 'ᵪ'],
   ['_χ', 'ᵪ'],
   ['_\\phi', 'ᵩ'],
   ['_φ', 'ᵩ'],
   ['_\\beta', 'ᵦ'],
   ['_β', 'ᵦ'],
   ['_\\gamma', 'ᵧ'],
   ['_γ', 'ᵧ'],
   ['^\phi', 'ᵠ'],
   ['^φ', 'ᵠ'],
   ['^\chi', 'ᵡ'],
   ['^χ', 'ᵡ'],
   ['^\\delta', 'ᵟ'],
   ['^δ', 'ᵟ'],
   ['^\\gamma', 'ᵞ'],
   ['^γ', 'ᵞ'],
   ['^\\beta', 'ᵝ'],
   ['^β', 'ᵝ'],
   ['^8', '⁸'],
   ['^9', '⁹'],
   ['^<', '˂'],
   ['^=', '⁼'],
   ['^>', '˃'],
   ['^0', '⁰'],
   ['^1', '¹'],
   ['^2', '²'],
   ['^3', '³'],
   ['^4', '⁴'],
   ['^5', '⁵'],
   ['^6', '⁶'],
   ['^7', '⁷'],
   ['^(', '⁽'],
   ['^)', '⁾'],
   ['^*', '*'],
   ['^+', '⁺'],
   ['^-', '⁻'],
   ['^−', '⁻'],
   ['^P', 'ᴾ'],
   ['^R', 'ᴿ'],
   ['^T', 'ᵀ'],
   ['^U', 'ᵁ'],
   ['^V', 'ᄑ'],
   ['^W', 'ᵂ'],
   ['^H', 'ᴴ'],
   ['^I', 'ᴵ'],
   ['^J', 'ᴶ'],
   ['^K', 'ᴷ'],
   ['^L', 'ᴸ'],
   ['^M', 'ᴹ'],
   ['^N', 'ᴺ'],
   ['^O', 'ᴼ'],
   ['^A', 'ᴬ'],
   ['^B', 'ᴮ'],
   ['^D', 'ᴰ'],
   ['^E', 'ᴱ'],
   ['^G', 'ᴳ'],
   ['^x', 'ˣ'],
   ['^y', 'ʸ'],
   ['^z', 'ᶻ'],
   ['^p', 'ᵖ'],
   ['^r', 'ʳ'],
   ['^s', 'ˢ'],
   ['^t', 'ᵗ'],
   ['^u', 'ᵘ'],
   ['^v', 'ᵛ'],
   ['^w', 'ʷ'],
   ['^h', 'ʰ'],
   ['^i', 'ⁱ'],
   ['^j', 'ʲ'],
   ['^k', 'ᵏ'],
   ['^l', 'ˡ'],
   ['^m', 'ᵐ'],
   ['^n', 'ⁿ'],
   ['^o', 'ᵒ'],
   ['^a', 'ᵃ'],
   ['^b', 'ᵇ'],
   ['^c', 'ᶜ'],
   ['^d', 'ᵈ'],
   ['^e', 'ᵉ'],
   ['^f', 'ᶠ'],
   ['^g', 'ᵍ'],
];
